(function e(t,n,r){function s(o,u){if(!n[o]){if(!t[o]){var a=typeof require=="function"&&require;if(!u&&a)return a(o,!0);if(i)return i(o,!0);var f=new Error("Cannot find module '"+o+"'");throw f.code="MODULE_NOT_FOUND",f}var l=n[o]={exports:{}};t[o][0].call(l.exports,function(e){var n=t[o][1][e];return s(n?n:e)},l,l.exports,e,t,n,r)}return n[o].exports}var i=typeof require=="function"&&require;for(var o=0;o<r.length;o++)s(r[o]);return s})({1:[function(require,module,exports){
var _memoize = require('../src/memoize');
var wrapper = require('../src/promise-translator');

function memoize(getKey) {
  return _memoize(wrapper, getKey);
}

module.exports = memoize;

},{"../src/memoize":3,"../src/promise-translator":4}],2:[function(require,module,exports){
var _retry = require('../src/retry');
var wrapper = require('../src/promise-translator');

function retry(times, interval, error) {
  return _retry(wrapper, times, interval, error);
}

module.exports = retry;

},{"../src/promise-translator":4,"../src/retry":5}],3:[function(require,module,exports){
var defaultLogger = require('../utils/default-logger');
var keyGetter = require('memoize-cache-utils/key-getter');

function memoizeDecorator(wrapper, getKey) {
  getKey = keyGetter(getKey || function () { return '_default'; });
  return wrapper(function (func) {
    var cache = {};
    return function () {
      var context = this;
      var args = Array.prototype.slice.call(arguments, 0);
      var logger = defaultLogger.apply(context);
      var cb = args[args.length - 1];
      var cacheKey = getKey.apply(context, args);
      args[args.length - 1] = function (err, dep) {
        if (!err && cacheKey !== null) {
          cache[cacheKey] = dep;
        }
        cb(err, dep);
      };
      if (cacheKey !== null && cacheKey in cache) {
        logger('memoize-hit', {key: cacheKey, result: cache[cacheKey]});
        return cb(null, cache[cacheKey]);
      }
      else {
        func.apply(context, args);
      }
    };
  });
}

module.exports = memoizeDecorator;

},{"../utils/default-logger":7,"memoize-cache-utils/key-getter":136}],4:[function(require,module,exports){
var promisify = require('es6-promisify');
var callbackify = require('../utils/callbackify');

// it works for decorator(f) and decorator([f1, f2, f3 ...])

function promiseTranslator(decorator) {
  return function (f) { // f returns a promise
    var cb;
    if (Array.isArray(f)) {
      cb = f.map(callbackify);
    } else {
      cb = callbackify(f);
    }

    return promisify(decorator(cb));
  };
}

module.exports = promiseTranslator;

},{"../utils/callbackify":6,"es6-promisify":133}],5:[function(require,module,exports){
var defaultLogger = require('../utils/default-logger');

function retryDecorator(wrapper, times, interval, error) {
  var condition;
  times = times || Infinity;
  error = error || Error;
  interval = interval || 0;
  var intervalFunc = typeof interval === 'function' ?
    interval :
    function () { return interval; };

  if (error === Error || Error.isPrototypeOf(error)) {
    condition = function (err, dep) { return err instanceof error; };
  }
  else {
    condition = error;
  }

  return wrapper(function (func) {
    return function () {
      var counter = 0;
      var context = this;
      var args = Array.prototype.slice.call(arguments, 0);
      var logger = defaultLogger.apply(context);
      var cb = args[args.length - 1];

      var retry = function () {
        if (counter++ && intervalFunc(counter) > 0) { // do not wait for counter === 0
          setTimeout(function () {
            func.apply(context, args);
          }, interval);
        }
        else {
          func.apply(context, args);
        }
      };

      args[args.length - 1] = function (err, dep) {
        if (condition(err, dep) && counter < times) {
          logger('retry', {
            times: counter,
            actualResult: {err: err, res: dep}
          });
          retry();
        }
        else {
          cb(err, dep);
        }
      };
      retry();
    };
  });
}

module.exports = retryDecorator;

},{"../utils/default-logger":7}],6:[function(require,module,exports){
function isPromise(obj) {
  return typeof obj === 'object' && 'then' in obj;
}

function callbackify(func) {
  return function () {
    // get arguments
    var context = this;
    var args = Array.prototype.slice.call(arguments, 0, -1);
    var cb = arguments[arguments.length - 1];
    try {
      var output = func.apply(context, args);
    }
    catch (e) {
      return cb(e);
    }

    if (isPromise(output)) {
      output.then(function (res) { // onfulfilled
        cb(null, res);
      },
      function (error) { // onrejected
        cb(error);
      });
    }
    else {
      cb(null, output);
    }
  };
}

module.exports = callbackify;

},{}],7:[function(require,module,exports){
module.exports = function () {
  if (typeof this === 'object' && '__log' in this) {
    return this.__log;
  }
  return function () {};
};

},{}],8:[function(require,module,exports){
(function (w, cb){

  var queue = this._async_define_queue = '_async_define_queue' in this ? this._async_define_queue : [];
  var cached_dependencies = this._async_define_cached_dependencies = '_async_define_cached_dependencies' in this ? this._async_define_cached_dependencies : {};

  function getDepsArray(depNames) {
    var i,
      len = depNames.length,
      deps = [];
    for (i = 0; i < len; i++){
      if (depNames[i] in cached_dependencies){
        deps.push(cached_dependencies[depNames[i]]);
      }
      else {
        return;
      }
    }
    return deps;
  }

  function runThroughQueue() {
    while (_runThroughQueue());
  }

  function _runThroughQueue() {
    var i = 0;
    var solvedDependency = false;
    while (i < queue.length){
      if (execute(queue[i])){
        if (queue[i].name){
          solvedDependency = true;
        }
        queue.splice(i, 1);
      }
      else {
        i++;
      }
    }
    return solvedDependency;
  }

  function execute (item){
    if (item.name in cached_dependencies) { // don't execute twice
      return true;
    }
    var deps = getDepsArray(item.depNames);
    var exp;
    if (deps){
      exp = item.func.apply(w, deps);
      if (item.name){
        cached_dependencies[item.name] = exp;
      }
      return true;
    }
    else {
      return;
    }
  }

  function wrapObj (o){
    if (typeof o === 'function'){
      return o;
    }
    else {
      return function (){
        return o;
      };
    }
  }

  function ad() {
    var item = {
        name:  typeof arguments[0] === 'string' ? arguments[0] : undefined,
        depNames: Array.isArray(arguments[0]) ? arguments[0] : Array.isArray(arguments[1]) ? arguments[1] : [],
        func: wrapObj(arguments[arguments.length - 1])
    };
    if (!execute(item)){
      queue.push(item);
    }
    else {
      if (item.name){
        runThroughQueue(); // executed straight away, try to resolve func that depends on this
      }
    }
  }
  cb.call(w, ad);
}(this, function (asyncDefine) {
  if (typeof exports === 'object'){
  module.exports = asyncDefine;
}
else{
  w.asyncDefine = asyncDefine;
}

}));


},{}],9:[function(require,module,exports){
module.exports = { "default": require("core-js/library/fn/get-iterator"), __esModule: true };
},{"core-js/library/fn/get-iterator":29}],10:[function(require,module,exports){
module.exports = { "default": require("core-js/library/fn/is-iterable"), __esModule: true };
},{"core-js/library/fn/is-iterable":30}],11:[function(require,module,exports){
module.exports = { "default": require("core-js/library/fn/json/stringify"), __esModule: true };
},{"core-js/library/fn/json/stringify":31}],12:[function(require,module,exports){
module.exports = { "default": require("core-js/library/fn/object/assign"), __esModule: true };
},{"core-js/library/fn/object/assign":32}],13:[function(require,module,exports){
module.exports = { "default": require("core-js/library/fn/object/create"), __esModule: true };
},{"core-js/library/fn/object/create":33}],14:[function(require,module,exports){
module.exports = { "default": require("core-js/library/fn/object/define-property"), __esModule: true };
},{"core-js/library/fn/object/define-property":34}],15:[function(require,module,exports){
module.exports = { "default": require("core-js/library/fn/object/get-prototype-of"), __esModule: true };
},{"core-js/library/fn/object/get-prototype-of":35}],16:[function(require,module,exports){
module.exports = { "default": require("core-js/library/fn/object/keys"), __esModule: true };
},{"core-js/library/fn/object/keys":36}],17:[function(require,module,exports){
module.exports = { "default": require("core-js/library/fn/object/set-prototype-of"), __esModule: true };
},{"core-js/library/fn/object/set-prototype-of":37}],18:[function(require,module,exports){
module.exports = { "default": require("core-js/library/fn/promise"), __esModule: true };
},{"core-js/library/fn/promise":38}],19:[function(require,module,exports){
module.exports = { "default": require("core-js/library/fn/symbol"), __esModule: true };
},{"core-js/library/fn/symbol":39}],20:[function(require,module,exports){
module.exports = { "default": require("core-js/library/fn/symbol/iterator"), __esModule: true };
},{"core-js/library/fn/symbol/iterator":40}],21:[function(require,module,exports){
"use strict";

exports.__esModule = true;

exports.default = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};
},{}],22:[function(require,module,exports){
"use strict";

exports.__esModule = true;

var _defineProperty = require("../core-js/object/define-property");

var _defineProperty2 = _interopRequireDefault(_defineProperty);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      (0, _defineProperty2.default)(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();
},{"../core-js/object/define-property":14}],23:[function(require,module,exports){
"use strict";

exports.__esModule = true;

var _setPrototypeOf = require("../core-js/object/set-prototype-of");

var _setPrototypeOf2 = _interopRequireDefault(_setPrototypeOf);

var _create = require("../core-js/object/create");

var _create2 = _interopRequireDefault(_create);

var _typeof2 = require("../helpers/typeof");

var _typeof3 = _interopRequireDefault(_typeof2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : (0, _typeof3.default)(superClass)));
  }

  subClass.prototype = (0, _create2.default)(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf2.default ? (0, _setPrototypeOf2.default)(subClass, superClass) : subClass.__proto__ = superClass;
};
},{"../core-js/object/create":13,"../core-js/object/set-prototype-of":17,"../helpers/typeof":26}],24:[function(require,module,exports){
"use strict";

exports.__esModule = true;

var _typeof2 = require("../helpers/typeof");

var _typeof3 = _interopRequireDefault(_typeof2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && ((typeof call === "undefined" ? "undefined" : (0, _typeof3.default)(call)) === "object" || typeof call === "function") ? call : self;
};
},{"../helpers/typeof":26}],25:[function(require,module,exports){
"use strict";

exports.__esModule = true;

var _isIterable2 = require("../core-js/is-iterable");

var _isIterable3 = _interopRequireDefault(_isIterable2);

var _getIterator2 = require("../core-js/get-iterator");

var _getIterator3 = _interopRequireDefault(_getIterator2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function () {
  function sliceIterator(arr, i) {
    var _arr = [];
    var _n = true;
    var _d = false;
    var _e = undefined;

    try {
      for (var _i = (0, _getIterator3.default)(arr), _s; !(_n = (_s = _i.next()).done); _n = true) {
        _arr.push(_s.value);

        if (i && _arr.length === i) break;
      }
    } catch (err) {
      _d = true;
      _e = err;
    } finally {
      try {
        if (!_n && _i["return"]) _i["return"]();
      } finally {
        if (_d) throw _e;
      }
    }

    return _arr;
  }

  return function (arr, i) {
    if (Array.isArray(arr)) {
      return arr;
    } else if ((0, _isIterable3.default)(Object(arr))) {
      return sliceIterator(arr, i);
    } else {
      throw new TypeError("Invalid attempt to destructure non-iterable instance");
    }
  };
}();
},{"../core-js/get-iterator":9,"../core-js/is-iterable":10}],26:[function(require,module,exports){
"use strict";

exports.__esModule = true;

var _iterator = require("../core-js/symbol/iterator");

var _iterator2 = _interopRequireDefault(_iterator);

var _symbol = require("../core-js/symbol");

var _symbol2 = _interopRequireDefault(_symbol);

var _typeof = typeof _symbol2.default === "function" && typeof _iterator2.default === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj; };

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = typeof _symbol2.default === "function" && _typeof(_iterator2.default) === "symbol" ? function (obj) {
  return typeof obj === "undefined" ? "undefined" : _typeof(obj);
} : function (obj) {
  return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof(obj);
};
},{"../core-js/symbol":19,"../core-js/symbol/iterator":20}],27:[function(require,module,exports){
module.exports = require("regenerator-runtime");

},{"regenerator-runtime":152}],28:[function(require,module,exports){

},{}],29:[function(require,module,exports){
require('../modules/web.dom.iterable');
require('../modules/es6.string.iterator');
module.exports = require('../modules/core.get-iterator');
},{"../modules/core.get-iterator":113,"../modules/es6.string.iterator":124,"../modules/web.dom.iterable":128}],30:[function(require,module,exports){
require('../modules/web.dom.iterable');
require('../modules/es6.string.iterator');
module.exports = require('../modules/core.is-iterable');
},{"../modules/core.is-iterable":114,"../modules/es6.string.iterator":124,"../modules/web.dom.iterable":128}],31:[function(require,module,exports){
var core  = require('../../modules/_core')
  , $JSON = core.JSON || (core.JSON = {stringify: JSON.stringify});
module.exports = function stringify(it){ // eslint-disable-line no-unused-vars
  return $JSON.stringify.apply($JSON, arguments);
};
},{"../../modules/_core":48}],32:[function(require,module,exports){
require('../../modules/es6.object.assign');
module.exports = require('../../modules/_core').Object.assign;
},{"../../modules/_core":48,"../../modules/es6.object.assign":116}],33:[function(require,module,exports){
require('../../modules/es6.object.create');
var $Object = require('../../modules/_core').Object;
module.exports = function create(P, D){
  return $Object.create(P, D);
};
},{"../../modules/_core":48,"../../modules/es6.object.create":117}],34:[function(require,module,exports){
require('../../modules/es6.object.define-property');
var $Object = require('../../modules/_core').Object;
module.exports = function defineProperty(it, key, desc){
  return $Object.defineProperty(it, key, desc);
};
},{"../../modules/_core":48,"../../modules/es6.object.define-property":118}],35:[function(require,module,exports){
require('../../modules/es6.object.get-prototype-of');
module.exports = require('../../modules/_core').Object.getPrototypeOf;
},{"../../modules/_core":48,"../../modules/es6.object.get-prototype-of":119}],36:[function(require,module,exports){
require('../../modules/es6.object.keys');
module.exports = require('../../modules/_core').Object.keys;
},{"../../modules/_core":48,"../../modules/es6.object.keys":120}],37:[function(require,module,exports){
require('../../modules/es6.object.set-prototype-of');
module.exports = require('../../modules/_core').Object.setPrototypeOf;
},{"../../modules/_core":48,"../../modules/es6.object.set-prototype-of":121}],38:[function(require,module,exports){
require('../modules/es6.object.to-string');
require('../modules/es6.string.iterator');
require('../modules/web.dom.iterable');
require('../modules/es6.promise');
module.exports = require('../modules/_core').Promise;
},{"../modules/_core":48,"../modules/es6.object.to-string":122,"../modules/es6.promise":123,"../modules/es6.string.iterator":124,"../modules/web.dom.iterable":128}],39:[function(require,module,exports){
require('../../modules/es6.symbol');
require('../../modules/es6.object.to-string');
require('../../modules/es7.symbol.async-iterator');
require('../../modules/es7.symbol.observable');
module.exports = require('../../modules/_core').Symbol;
},{"../../modules/_core":48,"../../modules/es6.object.to-string":122,"../../modules/es6.symbol":125,"../../modules/es7.symbol.async-iterator":126,"../../modules/es7.symbol.observable":127}],40:[function(require,module,exports){
require('../../modules/es6.string.iterator');
require('../../modules/web.dom.iterable');
module.exports = require('../../modules/_wks-ext').f('iterator');
},{"../../modules/_wks-ext":110,"../../modules/es6.string.iterator":124,"../../modules/web.dom.iterable":128}],41:[function(require,module,exports){
module.exports = function(it){
  if(typeof it != 'function')throw TypeError(it + ' is not a function!');
  return it;
};
},{}],42:[function(require,module,exports){
module.exports = function(){ /* empty */ };
},{}],43:[function(require,module,exports){
module.exports = function(it, Constructor, name, forbiddenField){
  if(!(it instanceof Constructor) || (forbiddenField !== undefined && forbiddenField in it)){
    throw TypeError(name + ': incorrect invocation!');
  } return it;
};
},{}],44:[function(require,module,exports){
var isObject = require('./_is-object');
module.exports = function(it){
  if(!isObject(it))throw TypeError(it + ' is not an object!');
  return it;
};
},{"./_is-object":67}],45:[function(require,module,exports){
// false -> Array#indexOf
// true  -> Array#includes
var toIObject = require('./_to-iobject')
  , toLength  = require('./_to-length')
  , toIndex   = require('./_to-index');
module.exports = function(IS_INCLUDES){
  return function($this, el, fromIndex){
    var O      = toIObject($this)
      , length = toLength(O.length)
      , index  = toIndex(fromIndex, length)
      , value;
    // Array#includes uses SameValueZero equality algorithm
    if(IS_INCLUDES && el != el)while(length > index){
      value = O[index++];
      if(value != value)return true;
    // Array#toIndex ignores holes, Array#includes - not
    } else for(;length > index; index++)if(IS_INCLUDES || index in O){
      if(O[index] === el)return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};
},{"./_to-index":102,"./_to-iobject":104,"./_to-length":105}],46:[function(require,module,exports){
// getting tag from 19.1.3.6 Object.prototype.toString()
var cof = require('./_cof')
  , TAG = require('./_wks')('toStringTag')
  // ES3 wrong here
  , ARG = cof(function(){ return arguments; }()) == 'Arguments';

// fallback for IE11 Script Access Denied error
var tryGet = function(it, key){
  try {
    return it[key];
  } catch(e){ /* empty */ }
};

module.exports = function(it){
  var O, T, B;
  return it === undefined ? 'Undefined' : it === null ? 'Null'
    // @@toStringTag case
    : typeof (T = tryGet(O = Object(it), TAG)) == 'string' ? T
    // builtinTag case
    : ARG ? cof(O)
    // ES3 arguments fallback
    : (B = cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
};
},{"./_cof":47,"./_wks":111}],47:[function(require,module,exports){
var toString = {}.toString;

module.exports = function(it){
  return toString.call(it).slice(8, -1);
};
},{}],48:[function(require,module,exports){
var core = module.exports = {version: '2.4.0'};
if(typeof __e == 'number')__e = core; // eslint-disable-line no-undef
},{}],49:[function(require,module,exports){
// optional / simple context binding
var aFunction = require('./_a-function');
module.exports = function(fn, that, length){
  aFunction(fn);
  if(that === undefined)return fn;
  switch(length){
    case 1: return function(a){
      return fn.call(that, a);
    };
    case 2: return function(a, b){
      return fn.call(that, a, b);
    };
    case 3: return function(a, b, c){
      return fn.call(that, a, b, c);
    };
  }
  return function(/* ...args */){
    return fn.apply(that, arguments);
  };
};
},{"./_a-function":41}],50:[function(require,module,exports){
// 7.2.1 RequireObjectCoercible(argument)
module.exports = function(it){
  if(it == undefined)throw TypeError("Can't call method on  " + it);
  return it;
};
},{}],51:[function(require,module,exports){
// Thank's IE8 for his funny defineProperty
module.exports = !require('./_fails')(function(){
  return Object.defineProperty({}, 'a', {get: function(){ return 7; }}).a != 7;
});
},{"./_fails":56}],52:[function(require,module,exports){
var isObject = require('./_is-object')
  , document = require('./_global').document
  // in old IE typeof document.createElement is 'object'
  , is = isObject(document) && isObject(document.createElement);
module.exports = function(it){
  return is ? document.createElement(it) : {};
};
},{"./_global":58,"./_is-object":67}],53:[function(require,module,exports){
// IE 8- don't enum bug keys
module.exports = (
  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
).split(',');
},{}],54:[function(require,module,exports){
// all enumerable object keys, includes symbols
var getKeys = require('./_object-keys')
  , gOPS    = require('./_object-gops')
  , pIE     = require('./_object-pie');
module.exports = function(it){
  var result     = getKeys(it)
    , getSymbols = gOPS.f;
  if(getSymbols){
    var symbols = getSymbols(it)
      , isEnum  = pIE.f
      , i       = 0
      , key;
    while(symbols.length > i)if(isEnum.call(it, key = symbols[i++]))result.push(key);
  } return result;
};
},{"./_object-gops":85,"./_object-keys":88,"./_object-pie":89}],55:[function(require,module,exports){
var global    = require('./_global')
  , core      = require('./_core')
  , ctx       = require('./_ctx')
  , hide      = require('./_hide')
  , PROTOTYPE = 'prototype';

var $export = function(type, name, source){
  var IS_FORCED = type & $export.F
    , IS_GLOBAL = type & $export.G
    , IS_STATIC = type & $export.S
    , IS_PROTO  = type & $export.P
    , IS_BIND   = type & $export.B
    , IS_WRAP   = type & $export.W
    , exports   = IS_GLOBAL ? core : core[name] || (core[name] = {})
    , expProto  = exports[PROTOTYPE]
    , target    = IS_GLOBAL ? global : IS_STATIC ? global[name] : (global[name] || {})[PROTOTYPE]
    , key, own, out;
  if(IS_GLOBAL)source = name;
  for(key in source){
    // contains in native
    own = !IS_FORCED && target && target[key] !== undefined;
    if(own && key in exports)continue;
    // export native or passed
    out = own ? target[key] : source[key];
    // prevent global pollution for namespaces
    exports[key] = IS_GLOBAL && typeof target[key] != 'function' ? source[key]
    // bind timers to global for call from export context
    : IS_BIND && own ? ctx(out, global)
    // wrap global constructors for prevent change them in library
    : IS_WRAP && target[key] == out ? (function(C){
      var F = function(a, b, c){
        if(this instanceof C){
          switch(arguments.length){
            case 0: return new C;
            case 1: return new C(a);
            case 2: return new C(a, b);
          } return new C(a, b, c);
        } return C.apply(this, arguments);
      };
      F[PROTOTYPE] = C[PROTOTYPE];
      return F;
    // make static versions for prototype methods
    })(out) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
    // export proto methods to core.%CONSTRUCTOR%.methods.%NAME%
    if(IS_PROTO){
      (exports.virtual || (exports.virtual = {}))[key] = out;
      // export proto methods to core.%CONSTRUCTOR%.prototype.%NAME%
      if(type & $export.R && expProto && !expProto[key])hide(expProto, key, out);
    }
  }
};
// type bitmap
$export.F = 1;   // forced
$export.G = 2;   // global
$export.S = 4;   // static
$export.P = 8;   // proto
$export.B = 16;  // bind
$export.W = 32;  // wrap
$export.U = 64;  // safe
$export.R = 128; // real proto method for `library` 
module.exports = $export;
},{"./_core":48,"./_ctx":49,"./_global":58,"./_hide":60}],56:[function(require,module,exports){
module.exports = function(exec){
  try {
    return !!exec();
  } catch(e){
    return true;
  }
};
},{}],57:[function(require,module,exports){
var ctx         = require('./_ctx')
  , call        = require('./_iter-call')
  , isArrayIter = require('./_is-array-iter')
  , anObject    = require('./_an-object')
  , toLength    = require('./_to-length')
  , getIterFn   = require('./core.get-iterator-method')
  , BREAK       = {}
  , RETURN      = {};
var exports = module.exports = function(iterable, entries, fn, that, ITERATOR){
  var iterFn = ITERATOR ? function(){ return iterable; } : getIterFn(iterable)
    , f      = ctx(fn, that, entries ? 2 : 1)
    , index  = 0
    , length, step, iterator, result;
  if(typeof iterFn != 'function')throw TypeError(iterable + ' is not iterable!');
  // fast case for arrays with default iterator
  if(isArrayIter(iterFn))for(length = toLength(iterable.length); length > index; index++){
    result = entries ? f(anObject(step = iterable[index])[0], step[1]) : f(iterable[index]);
    if(result === BREAK || result === RETURN)return result;
  } else for(iterator = iterFn.call(iterable); !(step = iterator.next()).done; ){
    result = call(iterator, f, step.value, entries);
    if(result === BREAK || result === RETURN)return result;
  }
};
exports.BREAK  = BREAK;
exports.RETURN = RETURN;
},{"./_an-object":44,"./_ctx":49,"./_is-array-iter":65,"./_iter-call":68,"./_to-length":105,"./core.get-iterator-method":112}],58:[function(require,module,exports){
// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var global = module.exports = typeof window != 'undefined' && window.Math == Math
  ? window : typeof self != 'undefined' && self.Math == Math ? self : Function('return this')();
if(typeof __g == 'number')__g = global; // eslint-disable-line no-undef
},{}],59:[function(require,module,exports){
var hasOwnProperty = {}.hasOwnProperty;
module.exports = function(it, key){
  return hasOwnProperty.call(it, key);
};
},{}],60:[function(require,module,exports){
var dP         = require('./_object-dp')
  , createDesc = require('./_property-desc');
module.exports = require('./_descriptors') ? function(object, key, value){
  return dP.f(object, key, createDesc(1, value));
} : function(object, key, value){
  object[key] = value;
  return object;
};
},{"./_descriptors":51,"./_object-dp":80,"./_property-desc":91}],61:[function(require,module,exports){
module.exports = require('./_global').document && document.documentElement;
},{"./_global":58}],62:[function(require,module,exports){
module.exports = !require('./_descriptors') && !require('./_fails')(function(){
  return Object.defineProperty(require('./_dom-create')('div'), 'a', {get: function(){ return 7; }}).a != 7;
});
},{"./_descriptors":51,"./_dom-create":52,"./_fails":56}],63:[function(require,module,exports){
// fast apply, http://jsperf.lnkit.com/fast-apply/5
module.exports = function(fn, args, that){
  var un = that === undefined;
  switch(args.length){
    case 0: return un ? fn()
                      : fn.call(that);
    case 1: return un ? fn(args[0])
                      : fn.call(that, args[0]);
    case 2: return un ? fn(args[0], args[1])
                      : fn.call(that, args[0], args[1]);
    case 3: return un ? fn(args[0], args[1], args[2])
                      : fn.call(that, args[0], args[1], args[2]);
    case 4: return un ? fn(args[0], args[1], args[2], args[3])
                      : fn.call(that, args[0], args[1], args[2], args[3]);
  } return              fn.apply(that, args);
};
},{}],64:[function(require,module,exports){
// fallback for non-array-like ES3 and non-enumerable old V8 strings
var cof = require('./_cof');
module.exports = Object('z').propertyIsEnumerable(0) ? Object : function(it){
  return cof(it) == 'String' ? it.split('') : Object(it);
};
},{"./_cof":47}],65:[function(require,module,exports){
// check on default Array iterator
var Iterators  = require('./_iterators')
  , ITERATOR   = require('./_wks')('iterator')
  , ArrayProto = Array.prototype;

module.exports = function(it){
  return it !== undefined && (Iterators.Array === it || ArrayProto[ITERATOR] === it);
};
},{"./_iterators":73,"./_wks":111}],66:[function(require,module,exports){
// 7.2.2 IsArray(argument)
var cof = require('./_cof');
module.exports = Array.isArray || function isArray(arg){
  return cof(arg) == 'Array';
};
},{"./_cof":47}],67:[function(require,module,exports){
module.exports = function(it){
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};
},{}],68:[function(require,module,exports){
// call something on iterator step with safe closing on error
var anObject = require('./_an-object');
module.exports = function(iterator, fn, value, entries){
  try {
    return entries ? fn(anObject(value)[0], value[1]) : fn(value);
  // 7.4.6 IteratorClose(iterator, completion)
  } catch(e){
    var ret = iterator['return'];
    if(ret !== undefined)anObject(ret.call(iterator));
    throw e;
  }
};
},{"./_an-object":44}],69:[function(require,module,exports){
'use strict';
var create         = require('./_object-create')
  , descriptor     = require('./_property-desc')
  , setToStringTag = require('./_set-to-string-tag')
  , IteratorPrototype = {};

// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
require('./_hide')(IteratorPrototype, require('./_wks')('iterator'), function(){ return this; });

module.exports = function(Constructor, NAME, next){
  Constructor.prototype = create(IteratorPrototype, {next: descriptor(1, next)});
  setToStringTag(Constructor, NAME + ' Iterator');
};
},{"./_hide":60,"./_object-create":79,"./_property-desc":91,"./_set-to-string-tag":96,"./_wks":111}],70:[function(require,module,exports){
'use strict';
var LIBRARY        = require('./_library')
  , $export        = require('./_export')
  , redefine       = require('./_redefine')
  , hide           = require('./_hide')
  , has            = require('./_has')
  , Iterators      = require('./_iterators')
  , $iterCreate    = require('./_iter-create')
  , setToStringTag = require('./_set-to-string-tag')
  , getPrototypeOf = require('./_object-gpo')
  , ITERATOR       = require('./_wks')('iterator')
  , BUGGY          = !([].keys && 'next' in [].keys()) // Safari has buggy iterators w/o `next`
  , FF_ITERATOR    = '@@iterator'
  , KEYS           = 'keys'
  , VALUES         = 'values';

var returnThis = function(){ return this; };

module.exports = function(Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED){
  $iterCreate(Constructor, NAME, next);
  var getMethod = function(kind){
    if(!BUGGY && kind in proto)return proto[kind];
    switch(kind){
      case KEYS: return function keys(){ return new Constructor(this, kind); };
      case VALUES: return function values(){ return new Constructor(this, kind); };
    } return function entries(){ return new Constructor(this, kind); };
  };
  var TAG        = NAME + ' Iterator'
    , DEF_VALUES = DEFAULT == VALUES
    , VALUES_BUG = false
    , proto      = Base.prototype
    , $native    = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT]
    , $default   = $native || getMethod(DEFAULT)
    , $entries   = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined
    , $anyNative = NAME == 'Array' ? proto.entries || $native : $native
    , methods, key, IteratorPrototype;
  // Fix native
  if($anyNative){
    IteratorPrototype = getPrototypeOf($anyNative.call(new Base));
    if(IteratorPrototype !== Object.prototype){
      // Set @@toStringTag to native iterators
      setToStringTag(IteratorPrototype, TAG, true);
      // fix for some old engines
      if(!LIBRARY && !has(IteratorPrototype, ITERATOR))hide(IteratorPrototype, ITERATOR, returnThis);
    }
  }
  // fix Array#{values, @@iterator}.name in V8 / FF
  if(DEF_VALUES && $native && $native.name !== VALUES){
    VALUES_BUG = true;
    $default = function values(){ return $native.call(this); };
  }
  // Define iterator
  if((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])){
    hide(proto, ITERATOR, $default);
  }
  // Plug for library
  Iterators[NAME] = $default;
  Iterators[TAG]  = returnThis;
  if(DEFAULT){
    methods = {
      values:  DEF_VALUES ? $default : getMethod(VALUES),
      keys:    IS_SET     ? $default : getMethod(KEYS),
      entries: $entries
    };
    if(FORCED)for(key in methods){
      if(!(key in proto))redefine(proto, key, methods[key]);
    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
  }
  return methods;
};
},{"./_export":55,"./_has":59,"./_hide":60,"./_iter-create":69,"./_iterators":73,"./_library":75,"./_object-gpo":86,"./_redefine":93,"./_set-to-string-tag":96,"./_wks":111}],71:[function(require,module,exports){
var ITERATOR     = require('./_wks')('iterator')
  , SAFE_CLOSING = false;

try {
  var riter = [7][ITERATOR]();
  riter['return'] = function(){ SAFE_CLOSING = true; };
  Array.from(riter, function(){ throw 2; });
} catch(e){ /* empty */ }

module.exports = function(exec, skipClosing){
  if(!skipClosing && !SAFE_CLOSING)return false;
  var safe = false;
  try {
    var arr  = [7]
      , iter = arr[ITERATOR]();
    iter.next = function(){ return {done: safe = true}; };
    arr[ITERATOR] = function(){ return iter; };
    exec(arr);
  } catch(e){ /* empty */ }
  return safe;
};
},{"./_wks":111}],72:[function(require,module,exports){
module.exports = function(done, value){
  return {value: value, done: !!done};
};
},{}],73:[function(require,module,exports){
module.exports = {};
},{}],74:[function(require,module,exports){
var getKeys   = require('./_object-keys')
  , toIObject = require('./_to-iobject');
module.exports = function(object, el){
  var O      = toIObject(object)
    , keys   = getKeys(O)
    , length = keys.length
    , index  = 0
    , key;
  while(length > index)if(O[key = keys[index++]] === el)return key;
};
},{"./_object-keys":88,"./_to-iobject":104}],75:[function(require,module,exports){
module.exports = true;
},{}],76:[function(require,module,exports){
var META     = require('./_uid')('meta')
  , isObject = require('./_is-object')
  , has      = require('./_has')
  , setDesc  = require('./_object-dp').f
  , id       = 0;
var isExtensible = Object.isExtensible || function(){
  return true;
};
var FREEZE = !require('./_fails')(function(){
  return isExtensible(Object.preventExtensions({}));
});
var setMeta = function(it){
  setDesc(it, META, {value: {
    i: 'O' + ++id, // object ID
    w: {}          // weak collections IDs
  }});
};
var fastKey = function(it, create){
  // return primitive with prefix
  if(!isObject(it))return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
  if(!has(it, META)){
    // can't set metadata to uncaught frozen object
    if(!isExtensible(it))return 'F';
    // not necessary to add metadata
    if(!create)return 'E';
    // add missing metadata
    setMeta(it);
  // return object ID
  } return it[META].i;
};
var getWeak = function(it, create){
  if(!has(it, META)){
    // can't set metadata to uncaught frozen object
    if(!isExtensible(it))return true;
    // not necessary to add metadata
    if(!create)return false;
    // add missing metadata
    setMeta(it);
  // return hash weak collections IDs
  } return it[META].w;
};
// add metadata on freeze-family methods calling
var onFreeze = function(it){
  if(FREEZE && meta.NEED && isExtensible(it) && !has(it, META))setMeta(it);
  return it;
};
var meta = module.exports = {
  KEY:      META,
  NEED:     false,
  fastKey:  fastKey,
  getWeak:  getWeak,
  onFreeze: onFreeze
};
},{"./_fails":56,"./_has":59,"./_is-object":67,"./_object-dp":80,"./_uid":108}],77:[function(require,module,exports){
var global    = require('./_global')
  , macrotask = require('./_task').set
  , Observer  = global.MutationObserver || global.WebKitMutationObserver
  , process   = global.process
  , Promise   = global.Promise
  , isNode    = require('./_cof')(process) == 'process';

module.exports = function(){
  var head, last, notify;

  var flush = function(){
    var parent, fn;
    if(isNode && (parent = process.domain))parent.exit();
    while(head){
      fn   = head.fn;
      head = head.next;
      try {
        fn();
      } catch(e){
        if(head)notify();
        else last = undefined;
        throw e;
      }
    } last = undefined;
    if(parent)parent.enter();
  };

  // Node.js
  if(isNode){
    notify = function(){
      process.nextTick(flush);
    };
  // browsers with MutationObserver
  } else if(Observer){
    var toggle = true
      , node   = document.createTextNode('');
    new Observer(flush).observe(node, {characterData: true}); // eslint-disable-line no-new
    notify = function(){
      node.data = toggle = !toggle;
    };
  // environments with maybe non-completely correct, but existent Promise
  } else if(Promise && Promise.resolve){
    var promise = Promise.resolve();
    notify = function(){
      promise.then(flush);
    };
  // for other environments - macrotask based on:
  // - setImmediate
  // - MessageChannel
  // - window.postMessag
  // - onreadystatechange
  // - setTimeout
  } else {
    notify = function(){
      // strange IE + webpack dev server bug - use .call(global)
      macrotask.call(global, flush);
    };
  }

  return function(fn){
    var task = {fn: fn, next: undefined};
    if(last)last.next = task;
    if(!head){
      head = task;
      notify();
    } last = task;
  };
};
},{"./_cof":47,"./_global":58,"./_task":101}],78:[function(require,module,exports){
'use strict';
// 19.1.2.1 Object.assign(target, source, ...)
var getKeys  = require('./_object-keys')
  , gOPS     = require('./_object-gops')
  , pIE      = require('./_object-pie')
  , toObject = require('./_to-object')
  , IObject  = require('./_iobject')
  , $assign  = Object.assign;

// should work with symbols and should have deterministic property order (V8 bug)
module.exports = !$assign || require('./_fails')(function(){
  var A = {}
    , B = {}
    , S = Symbol()
    , K = 'abcdefghijklmnopqrst';
  A[S] = 7;
  K.split('').forEach(function(k){ B[k] = k; });
  return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
}) ? function assign(target, source){ // eslint-disable-line no-unused-vars
  var T     = toObject(target)
    , aLen  = arguments.length
    , index = 1
    , getSymbols = gOPS.f
    , isEnum     = pIE.f;
  while(aLen > index){
    var S      = IObject(arguments[index++])
      , keys   = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S)
      , length = keys.length
      , j      = 0
      , key;
    while(length > j)if(isEnum.call(S, key = keys[j++]))T[key] = S[key];
  } return T;
} : $assign;
},{"./_fails":56,"./_iobject":64,"./_object-gops":85,"./_object-keys":88,"./_object-pie":89,"./_to-object":106}],79:[function(require,module,exports){
// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
var anObject    = require('./_an-object')
  , dPs         = require('./_object-dps')
  , enumBugKeys = require('./_enum-bug-keys')
  , IE_PROTO    = require('./_shared-key')('IE_PROTO')
  , Empty       = function(){ /* empty */ }
  , PROTOTYPE   = 'prototype';

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var createDict = function(){
  // Thrash, waste and sodomy: IE GC bug
  var iframe = require('./_dom-create')('iframe')
    , i      = enumBugKeys.length
    , lt     = '<'
    , gt     = '>'
    , iframeDocument;
  iframe.style.display = 'none';
  require('./_html').appendChild(iframe);
  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
  // createDict = iframe.contentWindow.Object;
  // html.removeChild(iframe);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
  iframeDocument.close();
  createDict = iframeDocument.F;
  while(i--)delete createDict[PROTOTYPE][enumBugKeys[i]];
  return createDict();
};

module.exports = Object.create || function create(O, Properties){
  var result;
  if(O !== null){
    Empty[PROTOTYPE] = anObject(O);
    result = new Empty;
    Empty[PROTOTYPE] = null;
    // add "__proto__" for Object.getPrototypeOf polyfill
    result[IE_PROTO] = O;
  } else result = createDict();
  return Properties === undefined ? result : dPs(result, Properties);
};

},{"./_an-object":44,"./_dom-create":52,"./_enum-bug-keys":53,"./_html":61,"./_object-dps":81,"./_shared-key":97}],80:[function(require,module,exports){
var anObject       = require('./_an-object')
  , IE8_DOM_DEFINE = require('./_ie8-dom-define')
  , toPrimitive    = require('./_to-primitive')
  , dP             = Object.defineProperty;

exports.f = require('./_descriptors') ? Object.defineProperty : function defineProperty(O, P, Attributes){
  anObject(O);
  P = toPrimitive(P, true);
  anObject(Attributes);
  if(IE8_DOM_DEFINE)try {
    return dP(O, P, Attributes);
  } catch(e){ /* empty */ }
  if('get' in Attributes || 'set' in Attributes)throw TypeError('Accessors not supported!');
  if('value' in Attributes)O[P] = Attributes.value;
  return O;
};
},{"./_an-object":44,"./_descriptors":51,"./_ie8-dom-define":62,"./_to-primitive":107}],81:[function(require,module,exports){
var dP       = require('./_object-dp')
  , anObject = require('./_an-object')
  , getKeys  = require('./_object-keys');

module.exports = require('./_descriptors') ? Object.defineProperties : function defineProperties(O, Properties){
  anObject(O);
  var keys   = getKeys(Properties)
    , length = keys.length
    , i = 0
    , P;
  while(length > i)dP.f(O, P = keys[i++], Properties[P]);
  return O;
};
},{"./_an-object":44,"./_descriptors":51,"./_object-dp":80,"./_object-keys":88}],82:[function(require,module,exports){
var pIE            = require('./_object-pie')
  , createDesc     = require('./_property-desc')
  , toIObject      = require('./_to-iobject')
  , toPrimitive    = require('./_to-primitive')
  , has            = require('./_has')
  , IE8_DOM_DEFINE = require('./_ie8-dom-define')
  , gOPD           = Object.getOwnPropertyDescriptor;

exports.f = require('./_descriptors') ? gOPD : function getOwnPropertyDescriptor(O, P){
  O = toIObject(O);
  P = toPrimitive(P, true);
  if(IE8_DOM_DEFINE)try {
    return gOPD(O, P);
  } catch(e){ /* empty */ }
  if(has(O, P))return createDesc(!pIE.f.call(O, P), O[P]);
};
},{"./_descriptors":51,"./_has":59,"./_ie8-dom-define":62,"./_object-pie":89,"./_property-desc":91,"./_to-iobject":104,"./_to-primitive":107}],83:[function(require,module,exports){
// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
var toIObject = require('./_to-iobject')
  , gOPN      = require('./_object-gopn').f
  , toString  = {}.toString;

var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
  ? Object.getOwnPropertyNames(window) : [];

var getWindowNames = function(it){
  try {
    return gOPN(it);
  } catch(e){
    return windowNames.slice();
  }
};

module.exports.f = function getOwnPropertyNames(it){
  return windowNames && toString.call(it) == '[object Window]' ? getWindowNames(it) : gOPN(toIObject(it));
};

},{"./_object-gopn":84,"./_to-iobject":104}],84:[function(require,module,exports){
// 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
var $keys      = require('./_object-keys-internal')
  , hiddenKeys = require('./_enum-bug-keys').concat('length', 'prototype');

exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O){
  return $keys(O, hiddenKeys);
};
},{"./_enum-bug-keys":53,"./_object-keys-internal":87}],85:[function(require,module,exports){
exports.f = Object.getOwnPropertySymbols;
},{}],86:[function(require,module,exports){
// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
var has         = require('./_has')
  , toObject    = require('./_to-object')
  , IE_PROTO    = require('./_shared-key')('IE_PROTO')
  , ObjectProto = Object.prototype;

module.exports = Object.getPrototypeOf || function(O){
  O = toObject(O);
  if(has(O, IE_PROTO))return O[IE_PROTO];
  if(typeof O.constructor == 'function' && O instanceof O.constructor){
    return O.constructor.prototype;
  } return O instanceof Object ? ObjectProto : null;
};
},{"./_has":59,"./_shared-key":97,"./_to-object":106}],87:[function(require,module,exports){
var has          = require('./_has')
  , toIObject    = require('./_to-iobject')
  , arrayIndexOf = require('./_array-includes')(false)
  , IE_PROTO     = require('./_shared-key')('IE_PROTO');

module.exports = function(object, names){
  var O      = toIObject(object)
    , i      = 0
    , result = []
    , key;
  for(key in O)if(key != IE_PROTO)has(O, key) && result.push(key);
  // Don't enum bug & hidden keys
  while(names.length > i)if(has(O, key = names[i++])){
    ~arrayIndexOf(result, key) || result.push(key);
  }
  return result;
};
},{"./_array-includes":45,"./_has":59,"./_shared-key":97,"./_to-iobject":104}],88:[function(require,module,exports){
// 19.1.2.14 / 15.2.3.14 Object.keys(O)
var $keys       = require('./_object-keys-internal')
  , enumBugKeys = require('./_enum-bug-keys');

module.exports = Object.keys || function keys(O){
  return $keys(O, enumBugKeys);
};
},{"./_enum-bug-keys":53,"./_object-keys-internal":87}],89:[function(require,module,exports){
exports.f = {}.propertyIsEnumerable;
},{}],90:[function(require,module,exports){
// most Object methods by ES6 should accept primitives
var $export = require('./_export')
  , core    = require('./_core')
  , fails   = require('./_fails');
module.exports = function(KEY, exec){
  var fn  = (core.Object || {})[KEY] || Object[KEY]
    , exp = {};
  exp[KEY] = exec(fn);
  $export($export.S + $export.F * fails(function(){ fn(1); }), 'Object', exp);
};
},{"./_core":48,"./_export":55,"./_fails":56}],91:[function(require,module,exports){
module.exports = function(bitmap, value){
  return {
    enumerable  : !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable    : !(bitmap & 4),
    value       : value
  };
};
},{}],92:[function(require,module,exports){
var hide = require('./_hide');
module.exports = function(target, src, safe){
  for(var key in src){
    if(safe && target[key])target[key] = src[key];
    else hide(target, key, src[key]);
  } return target;
};
},{"./_hide":60}],93:[function(require,module,exports){
module.exports = require('./_hide');
},{"./_hide":60}],94:[function(require,module,exports){
// Works with __proto__ only. Old v8 can't work with null proto objects.
/* eslint-disable no-proto */
var isObject = require('./_is-object')
  , anObject = require('./_an-object');
var check = function(O, proto){
  anObject(O);
  if(!isObject(proto) && proto !== null)throw TypeError(proto + ": can't set as prototype!");
};
module.exports = {
  set: Object.setPrototypeOf || ('__proto__' in {} ? // eslint-disable-line
    function(test, buggy, set){
      try {
        set = require('./_ctx')(Function.call, require('./_object-gopd').f(Object.prototype, '__proto__').set, 2);
        set(test, []);
        buggy = !(test instanceof Array);
      } catch(e){ buggy = true; }
      return function setPrototypeOf(O, proto){
        check(O, proto);
        if(buggy)O.__proto__ = proto;
        else set(O, proto);
        return O;
      };
    }({}, false) : undefined),
  check: check
};
},{"./_an-object":44,"./_ctx":49,"./_is-object":67,"./_object-gopd":82}],95:[function(require,module,exports){
'use strict';
var global      = require('./_global')
  , core        = require('./_core')
  , dP          = require('./_object-dp')
  , DESCRIPTORS = require('./_descriptors')
  , SPECIES     = require('./_wks')('species');

module.exports = function(KEY){
  var C = typeof core[KEY] == 'function' ? core[KEY] : global[KEY];
  if(DESCRIPTORS && C && !C[SPECIES])dP.f(C, SPECIES, {
    configurable: true,
    get: function(){ return this; }
  });
};
},{"./_core":48,"./_descriptors":51,"./_global":58,"./_object-dp":80,"./_wks":111}],96:[function(require,module,exports){
var def = require('./_object-dp').f
  , has = require('./_has')
  , TAG = require('./_wks')('toStringTag');

module.exports = function(it, tag, stat){
  if(it && !has(it = stat ? it : it.prototype, TAG))def(it, TAG, {configurable: true, value: tag});
};
},{"./_has":59,"./_object-dp":80,"./_wks":111}],97:[function(require,module,exports){
var shared = require('./_shared')('keys')
  , uid    = require('./_uid');
module.exports = function(key){
  return shared[key] || (shared[key] = uid(key));
};
},{"./_shared":98,"./_uid":108}],98:[function(require,module,exports){
var global = require('./_global')
  , SHARED = '__core-js_shared__'
  , store  = global[SHARED] || (global[SHARED] = {});
module.exports = function(key){
  return store[key] || (store[key] = {});
};
},{"./_global":58}],99:[function(require,module,exports){
// 7.3.20 SpeciesConstructor(O, defaultConstructor)
var anObject  = require('./_an-object')
  , aFunction = require('./_a-function')
  , SPECIES   = require('./_wks')('species');
module.exports = function(O, D){
  var C = anObject(O).constructor, S;
  return C === undefined || (S = anObject(C)[SPECIES]) == undefined ? D : aFunction(S);
};
},{"./_a-function":41,"./_an-object":44,"./_wks":111}],100:[function(require,module,exports){
var toInteger = require('./_to-integer')
  , defined   = require('./_defined');
// true  -> String#at
// false -> String#codePointAt
module.exports = function(TO_STRING){
  return function(that, pos){
    var s = String(defined(that))
      , i = toInteger(pos)
      , l = s.length
      , a, b;
    if(i < 0 || i >= l)return TO_STRING ? '' : undefined;
    a = s.charCodeAt(i);
    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
      ? TO_STRING ? s.charAt(i) : a
      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
  };
};
},{"./_defined":50,"./_to-integer":103}],101:[function(require,module,exports){
var ctx                = require('./_ctx')
  , invoke             = require('./_invoke')
  , html               = require('./_html')
  , cel                = require('./_dom-create')
  , global             = require('./_global')
  , process            = global.process
  , setTask            = global.setImmediate
  , clearTask          = global.clearImmediate
  , MessageChannel     = global.MessageChannel
  , counter            = 0
  , queue              = {}
  , ONREADYSTATECHANGE = 'onreadystatechange'
  , defer, channel, port;
var run = function(){
  var id = +this;
  if(queue.hasOwnProperty(id)){
    var fn = queue[id];
    delete queue[id];
    fn();
  }
};
var listener = function(event){
  run.call(event.data);
};
// Node.js 0.9+ & IE10+ has setImmediate, otherwise:
if(!setTask || !clearTask){
  setTask = function setImmediate(fn){
    var args = [], i = 1;
    while(arguments.length > i)args.push(arguments[i++]);
    queue[++counter] = function(){
      invoke(typeof fn == 'function' ? fn : Function(fn), args);
    };
    defer(counter);
    return counter;
  };
  clearTask = function clearImmediate(id){
    delete queue[id];
  };
  // Node.js 0.8-
  if(require('./_cof')(process) == 'process'){
    defer = function(id){
      process.nextTick(ctx(run, id, 1));
    };
  // Browsers with MessageChannel, includes WebWorkers
  } else if(MessageChannel){
    channel = new MessageChannel;
    port    = channel.port2;
    channel.port1.onmessage = listener;
    defer = ctx(port.postMessage, port, 1);
  // Browsers with postMessage, skip WebWorkers
  // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
  } else if(global.addEventListener && typeof postMessage == 'function' && !global.importScripts){
    defer = function(id){
      global.postMessage(id + '', '*');
    };
    global.addEventListener('message', listener, false);
  // IE8-
  } else if(ONREADYSTATECHANGE in cel('script')){
    defer = function(id){
      html.appendChild(cel('script'))[ONREADYSTATECHANGE] = function(){
        html.removeChild(this);
        run.call(id);
      };
    };
  // Rest old browsers
  } else {
    defer = function(id){
      setTimeout(ctx(run, id, 1), 0);
    };
  }
}
module.exports = {
  set:   setTask,
  clear: clearTask
};
},{"./_cof":47,"./_ctx":49,"./_dom-create":52,"./_global":58,"./_html":61,"./_invoke":63}],102:[function(require,module,exports){
var toInteger = require('./_to-integer')
  , max       = Math.max
  , min       = Math.min;
module.exports = function(index, length){
  index = toInteger(index);
  return index < 0 ? max(index + length, 0) : min(index, length);
};
},{"./_to-integer":103}],103:[function(require,module,exports){
// 7.1.4 ToInteger
var ceil  = Math.ceil
  , floor = Math.floor;
module.exports = function(it){
  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
};
},{}],104:[function(require,module,exports){
// to indexed object, toObject with fallback for non-array-like ES3 strings
var IObject = require('./_iobject')
  , defined = require('./_defined');
module.exports = function(it){
  return IObject(defined(it));
};
},{"./_defined":50,"./_iobject":64}],105:[function(require,module,exports){
// 7.1.15 ToLength
var toInteger = require('./_to-integer')
  , min       = Math.min;
module.exports = function(it){
  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
};
},{"./_to-integer":103}],106:[function(require,module,exports){
// 7.1.13 ToObject(argument)
var defined = require('./_defined');
module.exports = function(it){
  return Object(defined(it));
};
},{"./_defined":50}],107:[function(require,module,exports){
// 7.1.1 ToPrimitive(input [, PreferredType])
var isObject = require('./_is-object');
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
module.exports = function(it, S){
  if(!isObject(it))return it;
  var fn, val;
  if(S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it)))return val;
  if(typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it)))return val;
  if(!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it)))return val;
  throw TypeError("Can't convert object to primitive value");
};
},{"./_is-object":67}],108:[function(require,module,exports){
var id = 0
  , px = Math.random();
module.exports = function(key){
  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
};
},{}],109:[function(require,module,exports){
var global         = require('./_global')
  , core           = require('./_core')
  , LIBRARY        = require('./_library')
  , wksExt         = require('./_wks-ext')
  , defineProperty = require('./_object-dp').f;
module.exports = function(name){
  var $Symbol = core.Symbol || (core.Symbol = LIBRARY ? {} : global.Symbol || {});
  if(name.charAt(0) != '_' && !(name in $Symbol))defineProperty($Symbol, name, {value: wksExt.f(name)});
};
},{"./_core":48,"./_global":58,"./_library":75,"./_object-dp":80,"./_wks-ext":110}],110:[function(require,module,exports){
exports.f = require('./_wks');
},{"./_wks":111}],111:[function(require,module,exports){
var store      = require('./_shared')('wks')
  , uid        = require('./_uid')
  , Symbol     = require('./_global').Symbol
  , USE_SYMBOL = typeof Symbol == 'function';

var $exports = module.exports = function(name){
  return store[name] || (store[name] =
    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
};

$exports.store = store;
},{"./_global":58,"./_shared":98,"./_uid":108}],112:[function(require,module,exports){
var classof   = require('./_classof')
  , ITERATOR  = require('./_wks')('iterator')
  , Iterators = require('./_iterators');
module.exports = require('./_core').getIteratorMethod = function(it){
  if(it != undefined)return it[ITERATOR]
    || it['@@iterator']
    || Iterators[classof(it)];
};
},{"./_classof":46,"./_core":48,"./_iterators":73,"./_wks":111}],113:[function(require,module,exports){
var anObject = require('./_an-object')
  , get      = require('./core.get-iterator-method');
module.exports = require('./_core').getIterator = function(it){
  var iterFn = get(it);
  if(typeof iterFn != 'function')throw TypeError(it + ' is not iterable!');
  return anObject(iterFn.call(it));
};
},{"./_an-object":44,"./_core":48,"./core.get-iterator-method":112}],114:[function(require,module,exports){
var classof   = require('./_classof')
  , ITERATOR  = require('./_wks')('iterator')
  , Iterators = require('./_iterators');
module.exports = require('./_core').isIterable = function(it){
  var O = Object(it);
  return O[ITERATOR] !== undefined
    || '@@iterator' in O
    || Iterators.hasOwnProperty(classof(O));
};
},{"./_classof":46,"./_core":48,"./_iterators":73,"./_wks":111}],115:[function(require,module,exports){
'use strict';
var addToUnscopables = require('./_add-to-unscopables')
  , step             = require('./_iter-step')
  , Iterators        = require('./_iterators')
  , toIObject        = require('./_to-iobject');

// 22.1.3.4 Array.prototype.entries()
// 22.1.3.13 Array.prototype.keys()
// 22.1.3.29 Array.prototype.values()
// 22.1.3.30 Array.prototype[@@iterator]()
module.exports = require('./_iter-define')(Array, 'Array', function(iterated, kind){
  this._t = toIObject(iterated); // target
  this._i = 0;                   // next index
  this._k = kind;                // kind
// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
}, function(){
  var O     = this._t
    , kind  = this._k
    , index = this._i++;
  if(!O || index >= O.length){
    this._t = undefined;
    return step(1);
  }
  if(kind == 'keys'  )return step(0, index);
  if(kind == 'values')return step(0, O[index]);
  return step(0, [index, O[index]]);
}, 'values');

// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
Iterators.Arguments = Iterators.Array;

addToUnscopables('keys');
addToUnscopables('values');
addToUnscopables('entries');
},{"./_add-to-unscopables":42,"./_iter-define":70,"./_iter-step":72,"./_iterators":73,"./_to-iobject":104}],116:[function(require,module,exports){
// 19.1.3.1 Object.assign(target, source)
var $export = require('./_export');

$export($export.S + $export.F, 'Object', {assign: require('./_object-assign')});
},{"./_export":55,"./_object-assign":78}],117:[function(require,module,exports){
var $export = require('./_export')
// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
$export($export.S, 'Object', {create: require('./_object-create')});
},{"./_export":55,"./_object-create":79}],118:[function(require,module,exports){
var $export = require('./_export');
// 19.1.2.4 / 15.2.3.6 Object.defineProperty(O, P, Attributes)
$export($export.S + $export.F * !require('./_descriptors'), 'Object', {defineProperty: require('./_object-dp').f});
},{"./_descriptors":51,"./_export":55,"./_object-dp":80}],119:[function(require,module,exports){
// 19.1.2.9 Object.getPrototypeOf(O)
var toObject        = require('./_to-object')
  , $getPrototypeOf = require('./_object-gpo');

require('./_object-sap')('getPrototypeOf', function(){
  return function getPrototypeOf(it){
    return $getPrototypeOf(toObject(it));
  };
});
},{"./_object-gpo":86,"./_object-sap":90,"./_to-object":106}],120:[function(require,module,exports){
// 19.1.2.14 Object.keys(O)
var toObject = require('./_to-object')
  , $keys    = require('./_object-keys');

require('./_object-sap')('keys', function(){
  return function keys(it){
    return $keys(toObject(it));
  };
});
},{"./_object-keys":88,"./_object-sap":90,"./_to-object":106}],121:[function(require,module,exports){
// 19.1.3.19 Object.setPrototypeOf(O, proto)
var $export = require('./_export');
$export($export.S, 'Object', {setPrototypeOf: require('./_set-proto').set});
},{"./_export":55,"./_set-proto":94}],122:[function(require,module,exports){
arguments[4][28][0].apply(exports,arguments)
},{"dup":28}],123:[function(require,module,exports){
'use strict';
var LIBRARY            = require('./_library')
  , global             = require('./_global')
  , ctx                = require('./_ctx')
  , classof            = require('./_classof')
  , $export            = require('./_export')
  , isObject           = require('./_is-object')
  , aFunction          = require('./_a-function')
  , anInstance         = require('./_an-instance')
  , forOf              = require('./_for-of')
  , speciesConstructor = require('./_species-constructor')
  , task               = require('./_task').set
  , microtask          = require('./_microtask')()
  , PROMISE            = 'Promise'
  , TypeError          = global.TypeError
  , process            = global.process
  , $Promise           = global[PROMISE]
  , process            = global.process
  , isNode             = classof(process) == 'process'
  , empty              = function(){ /* empty */ }
  , Internal, GenericPromiseCapability, Wrapper;

var USE_NATIVE = !!function(){
  try {
    // correct subclassing with @@species support
    var promise     = $Promise.resolve(1)
      , FakePromise = (promise.constructor = {})[require('./_wks')('species')] = function(exec){ exec(empty, empty); };
    // unhandled rejections tracking support, NodeJS Promise without it fails @@species test
    return (isNode || typeof PromiseRejectionEvent == 'function') && promise.then(empty) instanceof FakePromise;
  } catch(e){ /* empty */ }
}();

// helpers
var sameConstructor = function(a, b){
  // with library wrapper special case
  return a === b || a === $Promise && b === Wrapper;
};
var isThenable = function(it){
  var then;
  return isObject(it) && typeof (then = it.then) == 'function' ? then : false;
};
var newPromiseCapability = function(C){
  return sameConstructor($Promise, C)
    ? new PromiseCapability(C)
    : new GenericPromiseCapability(C);
};
var PromiseCapability = GenericPromiseCapability = function(C){
  var resolve, reject;
  this.promise = new C(function($$resolve, $$reject){
    if(resolve !== undefined || reject !== undefined)throw TypeError('Bad Promise constructor');
    resolve = $$resolve;
    reject  = $$reject;
  });
  this.resolve = aFunction(resolve);
  this.reject  = aFunction(reject);
};
var perform = function(exec){
  try {
    exec();
  } catch(e){
    return {error: e};
  }
};
var notify = function(promise, isReject){
  if(promise._n)return;
  promise._n = true;
  var chain = promise._c;
  microtask(function(){
    var value = promise._v
      , ok    = promise._s == 1
      , i     = 0;
    var run = function(reaction){
      var handler = ok ? reaction.ok : reaction.fail
        , resolve = reaction.resolve
        , reject  = reaction.reject
        , domain  = reaction.domain
        , result, then;
      try {
        if(handler){
          if(!ok){
            if(promise._h == 2)onHandleUnhandled(promise);
            promise._h = 1;
          }
          if(handler === true)result = value;
          else {
            if(domain)domain.enter();
            result = handler(value);
            if(domain)domain.exit();
          }
          if(result === reaction.promise){
            reject(TypeError('Promise-chain cycle'));
          } else if(then = isThenable(result)){
            then.call(result, resolve, reject);
          } else resolve(result);
        } else reject(value);
      } catch(e){
        reject(e);
      }
    };
    while(chain.length > i)run(chain[i++]); // variable length - can't use forEach
    promise._c = [];
    promise._n = false;
    if(isReject && !promise._h)onUnhandled(promise);
  });
};
var onUnhandled = function(promise){
  task.call(global, function(){
    var value = promise._v
      , abrupt, handler, console;
    if(isUnhandled(promise)){
      abrupt = perform(function(){
        if(isNode){
          process.emit('unhandledRejection', value, promise);
        } else if(handler = global.onunhandledrejection){
          handler({promise: promise, reason: value});
        } else if((console = global.console) && console.error){
          console.error('Unhandled promise rejection', value);
        }
      });
      // Browsers should not trigger `rejectionHandled` event if it was handled here, NodeJS - should
      promise._h = isNode || isUnhandled(promise) ? 2 : 1;
    } promise._a = undefined;
    if(abrupt)throw abrupt.error;
  });
};
var isUnhandled = function(promise){
  if(promise._h == 1)return false;
  var chain = promise._a || promise._c
    , i     = 0
    , reaction;
  while(chain.length > i){
    reaction = chain[i++];
    if(reaction.fail || !isUnhandled(reaction.promise))return false;
  } return true;
};
var onHandleUnhandled = function(promise){
  task.call(global, function(){
    var handler;
    if(isNode){
      process.emit('rejectionHandled', promise);
    } else if(handler = global.onrejectionhandled){
      handler({promise: promise, reason: promise._v});
    }
  });
};
var $reject = function(value){
  var promise = this;
  if(promise._d)return;
  promise._d = true;
  promise = promise._w || promise; // unwrap
  promise._v = value;
  promise._s = 2;
  if(!promise._a)promise._a = promise._c.slice();
  notify(promise, true);
};
var $resolve = function(value){
  var promise = this
    , then;
  if(promise._d)return;
  promise._d = true;
  promise = promise._w || promise; // unwrap
  try {
    if(promise === value)throw TypeError("Promise can't be resolved itself");
    if(then = isThenable(value)){
      microtask(function(){
        var wrapper = {_w: promise, _d: false}; // wrap
        try {
          then.call(value, ctx($resolve, wrapper, 1), ctx($reject, wrapper, 1));
        } catch(e){
          $reject.call(wrapper, e);
        }
      });
    } else {
      promise._v = value;
      promise._s = 1;
      notify(promise, false);
    }
  } catch(e){
    $reject.call({_w: promise, _d: false}, e); // wrap
  }
};

// constructor polyfill
if(!USE_NATIVE){
  // 25.4.3.1 Promise(executor)
  $Promise = function Promise(executor){
    anInstance(this, $Promise, PROMISE, '_h');
    aFunction(executor);
    Internal.call(this);
    try {
      executor(ctx($resolve, this, 1), ctx($reject, this, 1));
    } catch(err){
      $reject.call(this, err);
    }
  };
  Internal = function Promise(executor){
    this._c = [];             // <- awaiting reactions
    this._a = undefined;      // <- checked in isUnhandled reactions
    this._s = 0;              // <- state
    this._d = false;          // <- done
    this._v = undefined;      // <- value
    this._h = 0;              // <- rejection state, 0 - default, 1 - handled, 2 - unhandled
    this._n = false;          // <- notify
  };
  Internal.prototype = require('./_redefine-all')($Promise.prototype, {
    // 25.4.5.3 Promise.prototype.then(onFulfilled, onRejected)
    then: function then(onFulfilled, onRejected){
      var reaction    = newPromiseCapability(speciesConstructor(this, $Promise));
      reaction.ok     = typeof onFulfilled == 'function' ? onFulfilled : true;
      reaction.fail   = typeof onRejected == 'function' && onRejected;
      reaction.domain = isNode ? process.domain : undefined;
      this._c.push(reaction);
      if(this._a)this._a.push(reaction);
      if(this._s)notify(this, false);
      return reaction.promise;
    },
    // 25.4.5.1 Promise.prototype.catch(onRejected)
    'catch': function(onRejected){
      return this.then(undefined, onRejected);
    }
  });
  PromiseCapability = function(){
    var promise  = new Internal;
    this.promise = promise;
    this.resolve = ctx($resolve, promise, 1);
    this.reject  = ctx($reject, promise, 1);
  };
}

$export($export.G + $export.W + $export.F * !USE_NATIVE, {Promise: $Promise});
require('./_set-to-string-tag')($Promise, PROMISE);
require('./_set-species')(PROMISE);
Wrapper = require('./_core')[PROMISE];

// statics
$export($export.S + $export.F * !USE_NATIVE, PROMISE, {
  // 25.4.4.5 Promise.reject(r)
  reject: function reject(r){
    var capability = newPromiseCapability(this)
      , $$reject   = capability.reject;
    $$reject(r);
    return capability.promise;
  }
});
$export($export.S + $export.F * (LIBRARY || !USE_NATIVE), PROMISE, {
  // 25.4.4.6 Promise.resolve(x)
  resolve: function resolve(x){
    // instanceof instead of internal slot check because we should fix it without replacement native Promise core
    if(x instanceof $Promise && sameConstructor(x.constructor, this))return x;
    var capability = newPromiseCapability(this)
      , $$resolve  = capability.resolve;
    $$resolve(x);
    return capability.promise;
  }
});
$export($export.S + $export.F * !(USE_NATIVE && require('./_iter-detect')(function(iter){
  $Promise.all(iter)['catch'](empty);
})), PROMISE, {
  // 25.4.4.1 Promise.all(iterable)
  all: function all(iterable){
    var C          = this
      , capability = newPromiseCapability(C)
      , resolve    = capability.resolve
      , reject     = capability.reject;
    var abrupt = perform(function(){
      var values    = []
        , index     = 0
        , remaining = 1;
      forOf(iterable, false, function(promise){
        var $index        = index++
          , alreadyCalled = false;
        values.push(undefined);
        remaining++;
        C.resolve(promise).then(function(value){
          if(alreadyCalled)return;
          alreadyCalled  = true;
          values[$index] = value;
          --remaining || resolve(values);
        }, reject);
      });
      --remaining || resolve(values);
    });
    if(abrupt)reject(abrupt.error);
    return capability.promise;
  },
  // 25.4.4.4 Promise.race(iterable)
  race: function race(iterable){
    var C          = this
      , capability = newPromiseCapability(C)
      , reject     = capability.reject;
    var abrupt = perform(function(){
      forOf(iterable, false, function(promise){
        C.resolve(promise).then(capability.resolve, reject);
      });
    });
    if(abrupt)reject(abrupt.error);
    return capability.promise;
  }
});
},{"./_a-function":41,"./_an-instance":43,"./_classof":46,"./_core":48,"./_ctx":49,"./_export":55,"./_for-of":57,"./_global":58,"./_is-object":67,"./_iter-detect":71,"./_library":75,"./_microtask":77,"./_redefine-all":92,"./_set-species":95,"./_set-to-string-tag":96,"./_species-constructor":99,"./_task":101,"./_wks":111}],124:[function(require,module,exports){
'use strict';
var $at  = require('./_string-at')(true);

// 21.1.3.27 String.prototype[@@iterator]()
require('./_iter-define')(String, 'String', function(iterated){
  this._t = String(iterated); // target
  this._i = 0;                // next index
// 21.1.5.2.1 %StringIteratorPrototype%.next()
}, function(){
  var O     = this._t
    , index = this._i
    , point;
  if(index >= O.length)return {value: undefined, done: true};
  point = $at(O, index);
  this._i += point.length;
  return {value: point, done: false};
});
},{"./_iter-define":70,"./_string-at":100}],125:[function(require,module,exports){
'use strict';
// ECMAScript 6 symbols shim
var global         = require('./_global')
  , has            = require('./_has')
  , DESCRIPTORS    = require('./_descriptors')
  , $export        = require('./_export')
  , redefine       = require('./_redefine')
  , META           = require('./_meta').KEY
  , $fails         = require('./_fails')
  , shared         = require('./_shared')
  , setToStringTag = require('./_set-to-string-tag')
  , uid            = require('./_uid')
  , wks            = require('./_wks')
  , wksExt         = require('./_wks-ext')
  , wksDefine      = require('./_wks-define')
  , keyOf          = require('./_keyof')
  , enumKeys       = require('./_enum-keys')
  , isArray        = require('./_is-array')
  , anObject       = require('./_an-object')
  , toIObject      = require('./_to-iobject')
  , toPrimitive    = require('./_to-primitive')
  , createDesc     = require('./_property-desc')
  , _create        = require('./_object-create')
  , gOPNExt        = require('./_object-gopn-ext')
  , $GOPD          = require('./_object-gopd')
  , $DP            = require('./_object-dp')
  , $keys          = require('./_object-keys')
  , gOPD           = $GOPD.f
  , dP             = $DP.f
  , gOPN           = gOPNExt.f
  , $Symbol        = global.Symbol
  , $JSON          = global.JSON
  , _stringify     = $JSON && $JSON.stringify
  , PROTOTYPE      = 'prototype'
  , HIDDEN         = wks('_hidden')
  , TO_PRIMITIVE   = wks('toPrimitive')
  , isEnum         = {}.propertyIsEnumerable
  , SymbolRegistry = shared('symbol-registry')
  , AllSymbols     = shared('symbols')
  , OPSymbols      = shared('op-symbols')
  , ObjectProto    = Object[PROTOTYPE]
  , USE_NATIVE     = typeof $Symbol == 'function'
  , QObject        = global.QObject;
// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
var setter = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;

// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
var setSymbolDesc = DESCRIPTORS && $fails(function(){
  return _create(dP({}, 'a', {
    get: function(){ return dP(this, 'a', {value: 7}).a; }
  })).a != 7;
}) ? function(it, key, D){
  var protoDesc = gOPD(ObjectProto, key);
  if(protoDesc)delete ObjectProto[key];
  dP(it, key, D);
  if(protoDesc && it !== ObjectProto)dP(ObjectProto, key, protoDesc);
} : dP;

var wrap = function(tag){
  var sym = AllSymbols[tag] = _create($Symbol[PROTOTYPE]);
  sym._k = tag;
  return sym;
};

var isSymbol = USE_NATIVE && typeof $Symbol.iterator == 'symbol' ? function(it){
  return typeof it == 'symbol';
} : function(it){
  return it instanceof $Symbol;
};

var $defineProperty = function defineProperty(it, key, D){
  if(it === ObjectProto)$defineProperty(OPSymbols, key, D);
  anObject(it);
  key = toPrimitive(key, true);
  anObject(D);
  if(has(AllSymbols, key)){
    if(!D.enumerable){
      if(!has(it, HIDDEN))dP(it, HIDDEN, createDesc(1, {}));
      it[HIDDEN][key] = true;
    } else {
      if(has(it, HIDDEN) && it[HIDDEN][key])it[HIDDEN][key] = false;
      D = _create(D, {enumerable: createDesc(0, false)});
    } return setSymbolDesc(it, key, D);
  } return dP(it, key, D);
};
var $defineProperties = function defineProperties(it, P){
  anObject(it);
  var keys = enumKeys(P = toIObject(P))
    , i    = 0
    , l = keys.length
    , key;
  while(l > i)$defineProperty(it, key = keys[i++], P[key]);
  return it;
};
var $create = function create(it, P){
  return P === undefined ? _create(it) : $defineProperties(_create(it), P);
};
var $propertyIsEnumerable = function propertyIsEnumerable(key){
  var E = isEnum.call(this, key = toPrimitive(key, true));
  if(this === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key))return false;
  return E || !has(this, key) || !has(AllSymbols, key) || has(this, HIDDEN) && this[HIDDEN][key] ? E : true;
};
var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key){
  it  = toIObject(it);
  key = toPrimitive(key, true);
  if(it === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key))return;
  var D = gOPD(it, key);
  if(D && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key]))D.enumerable = true;
  return D;
};
var $getOwnPropertyNames = function getOwnPropertyNames(it){
  var names  = gOPN(toIObject(it))
    , result = []
    , i      = 0
    , key;
  while(names.length > i){
    if(!has(AllSymbols, key = names[i++]) && key != HIDDEN && key != META)result.push(key);
  } return result;
};
var $getOwnPropertySymbols = function getOwnPropertySymbols(it){
  var IS_OP  = it === ObjectProto
    , names  = gOPN(IS_OP ? OPSymbols : toIObject(it))
    , result = []
    , i      = 0
    , key;
  while(names.length > i){
    if(has(AllSymbols, key = names[i++]) && (IS_OP ? has(ObjectProto, key) : true))result.push(AllSymbols[key]);
  } return result;
};

// 19.4.1.1 Symbol([description])
if(!USE_NATIVE){
  $Symbol = function Symbol(){
    if(this instanceof $Symbol)throw TypeError('Symbol is not a constructor!');
    var tag = uid(arguments.length > 0 ? arguments[0] : undefined);
    var $set = function(value){
      if(this === ObjectProto)$set.call(OPSymbols, value);
      if(has(this, HIDDEN) && has(this[HIDDEN], tag))this[HIDDEN][tag] = false;
      setSymbolDesc(this, tag, createDesc(1, value));
    };
    if(DESCRIPTORS && setter)setSymbolDesc(ObjectProto, tag, {configurable: true, set: $set});
    return wrap(tag);
  };
  redefine($Symbol[PROTOTYPE], 'toString', function toString(){
    return this._k;
  });

  $GOPD.f = $getOwnPropertyDescriptor;
  $DP.f   = $defineProperty;
  require('./_object-gopn').f = gOPNExt.f = $getOwnPropertyNames;
  require('./_object-pie').f  = $propertyIsEnumerable;
  require('./_object-gops').f = $getOwnPropertySymbols;

  if(DESCRIPTORS && !require('./_library')){
    redefine(ObjectProto, 'propertyIsEnumerable', $propertyIsEnumerable, true);
  }

  wksExt.f = function(name){
    return wrap(wks(name));
  }
}

$export($export.G + $export.W + $export.F * !USE_NATIVE, {Symbol: $Symbol});

for(var symbols = (
  // 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
  'hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables'
).split(','), i = 0; symbols.length > i; )wks(symbols[i++]);

for(var symbols = $keys(wks.store), i = 0; symbols.length > i; )wksDefine(symbols[i++]);

$export($export.S + $export.F * !USE_NATIVE, 'Symbol', {
  // 19.4.2.1 Symbol.for(key)
  'for': function(key){
    return has(SymbolRegistry, key += '')
      ? SymbolRegistry[key]
      : SymbolRegistry[key] = $Symbol(key);
  },
  // 19.4.2.5 Symbol.keyFor(sym)
  keyFor: function keyFor(key){
    if(isSymbol(key))return keyOf(SymbolRegistry, key);
    throw TypeError(key + ' is not a symbol!');
  },
  useSetter: function(){ setter = true; },
  useSimple: function(){ setter = false; }
});

$export($export.S + $export.F * !USE_NATIVE, 'Object', {
  // 19.1.2.2 Object.create(O [, Properties])
  create: $create,
  // 19.1.2.4 Object.defineProperty(O, P, Attributes)
  defineProperty: $defineProperty,
  // 19.1.2.3 Object.defineProperties(O, Properties)
  defineProperties: $defineProperties,
  // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
  getOwnPropertyDescriptor: $getOwnPropertyDescriptor,
  // 19.1.2.7 Object.getOwnPropertyNames(O)
  getOwnPropertyNames: $getOwnPropertyNames,
  // 19.1.2.8 Object.getOwnPropertySymbols(O)
  getOwnPropertySymbols: $getOwnPropertySymbols
});

// 24.3.2 JSON.stringify(value [, replacer [, space]])
$JSON && $export($export.S + $export.F * (!USE_NATIVE || $fails(function(){
  var S = $Symbol();
  // MS Edge converts symbol values to JSON as {}
  // WebKit converts symbol values to JSON as null
  // V8 throws on boxed symbols
  return _stringify([S]) != '[null]' || _stringify({a: S}) != '{}' || _stringify(Object(S)) != '{}';
})), 'JSON', {
  stringify: function stringify(it){
    if(it === undefined || isSymbol(it))return; // IE8 returns string on undefined
    var args = [it]
      , i    = 1
      , replacer, $replacer;
    while(arguments.length > i)args.push(arguments[i++]);
    replacer = args[1];
    if(typeof replacer == 'function')$replacer = replacer;
    if($replacer || !isArray(replacer))replacer = function(key, value){
      if($replacer)value = $replacer.call(this, key, value);
      if(!isSymbol(value))return value;
    };
    args[1] = replacer;
    return _stringify.apply($JSON, args);
  }
});

// 19.4.3.4 Symbol.prototype[@@toPrimitive](hint)
$Symbol[PROTOTYPE][TO_PRIMITIVE] || require('./_hide')($Symbol[PROTOTYPE], TO_PRIMITIVE, $Symbol[PROTOTYPE].valueOf);
// 19.4.3.5 Symbol.prototype[@@toStringTag]
setToStringTag($Symbol, 'Symbol');
// 20.2.1.9 Math[@@toStringTag]
setToStringTag(Math, 'Math', true);
// 24.3.3 JSON[@@toStringTag]
setToStringTag(global.JSON, 'JSON', true);
},{"./_an-object":44,"./_descriptors":51,"./_enum-keys":54,"./_export":55,"./_fails":56,"./_global":58,"./_has":59,"./_hide":60,"./_is-array":66,"./_keyof":74,"./_library":75,"./_meta":76,"./_object-create":79,"./_object-dp":80,"./_object-gopd":82,"./_object-gopn":84,"./_object-gopn-ext":83,"./_object-gops":85,"./_object-keys":88,"./_object-pie":89,"./_property-desc":91,"./_redefine":93,"./_set-to-string-tag":96,"./_shared":98,"./_to-iobject":104,"./_to-primitive":107,"./_uid":108,"./_wks":111,"./_wks-define":109,"./_wks-ext":110}],126:[function(require,module,exports){
require('./_wks-define')('asyncIterator');
},{"./_wks-define":109}],127:[function(require,module,exports){
require('./_wks-define')('observable');
},{"./_wks-define":109}],128:[function(require,module,exports){
require('./es6.array.iterator');
var global        = require('./_global')
  , hide          = require('./_hide')
  , Iterators     = require('./_iterators')
  , TO_STRING_TAG = require('./_wks')('toStringTag');

for(var collections = ['NodeList', 'DOMTokenList', 'MediaList', 'StyleSheetList', 'CSSRuleList'], i = 0; i < 5; i++){
  var NAME       = collections[i]
    , Collection = global[NAME]
    , proto      = Collection && Collection.prototype;
  if(proto && !proto[TO_STRING_TAG])hide(proto, TO_STRING_TAG, NAME);
  Iterators[NAME] = Iterators.Array;
}
},{"./_global":58,"./_hide":60,"./_iterators":73,"./_wks":111,"./es6.array.iterator":115}],129:[function(require,module,exports){
/**
 * Code refactored from Mozilla Developer Network:
 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/assign
 */

'use strict';

function assign(target, firstSource) {
  if (target === undefined || target === null) {
    throw new TypeError('Cannot convert first argument to object');
  }

  var to = Object(target);
  for (var i = 1; i < arguments.length; i++) {
    var nextSource = arguments[i];
    if (nextSource === undefined || nextSource === null) {
      continue;
    }

    var keysArray = Object.keys(Object(nextSource));
    for (var nextIndex = 0, len = keysArray.length; nextIndex < len; nextIndex++) {
      var nextKey = keysArray[nextIndex];
      var desc = Object.getOwnPropertyDescriptor(nextSource, nextKey);
      if (desc !== undefined && desc.enumerable) {
        to[nextKey] = nextSource[nextKey];
      }
    }
  }
  return to;
}

function polyfill() {
  if (!Object.assign) {
    Object.defineProperty(Object, 'assign', {
      enumerable: false,
      configurable: true,
      writable: true,
      value: assign
    });
  }
}

module.exports = {
  assign: assign,
  polyfill: polyfill
};

},{}],130:[function(require,module,exports){
(function (global){
(function(global){

//
// Check for native Promise and it has correct interface
//

var NativePromise = global['Promise'];
var nativePromiseSupported =
  NativePromise &&
  // Some of these methods are missing from
  // Firefox/Chrome experimental implementations
  'resolve' in NativePromise &&
  'reject' in NativePromise &&
  'all' in NativePromise &&
  'race' in NativePromise &&
  // Older version of the spec had a resolver object
  // as the arg rather than a function
  (function(){
    var resolve;
    new NativePromise(function(r){ resolve = r; });
    return typeof resolve === 'function';
  })();


//
// export if necessary
//

if (typeof exports !== 'undefined' && exports)
{
  // node.js
  exports.Promise = nativePromiseSupported ? NativePromise : Promise;
  exports.Polyfill = Promise;
}
else
{
  // AMD
  if (typeof define == 'function' && define.amd)
  {
    define(function(){
      return nativePromiseSupported ? NativePromise : Promise;
    });
  }
  else
  {
    // in browser add to global
    if (!nativePromiseSupported)
      global['Promise'] = Promise;
  }
}


//
// Polyfill
//

var PENDING = 'pending';
var SEALED = 'sealed';
var FULFILLED = 'fulfilled';
var REJECTED = 'rejected';
var NOOP = function(){};

function isArray(value) {
  return Object.prototype.toString.call(value) === '[object Array]';
}

// async calls
var asyncSetTimer = typeof setImmediate !== 'undefined' ? setImmediate : setTimeout;
var asyncQueue = [];
var asyncTimer;

function asyncFlush(){
  // run promise callbacks
  for (var i = 0; i < asyncQueue.length; i++)
    asyncQueue[i][0](asyncQueue[i][1]);

  // reset async asyncQueue
  asyncQueue = [];
  asyncTimer = false;
}

function asyncCall(callback, arg){
  asyncQueue.push([callback, arg]);

  if (!asyncTimer)
  {
    asyncTimer = true;
    asyncSetTimer(asyncFlush, 0);
  }
}


function invokeResolver(resolver, promise) {
  function resolvePromise(value) {
    resolve(promise, value);
  }

  function rejectPromise(reason) {
    reject(promise, reason);
  }

  try {
    resolver(resolvePromise, rejectPromise);
  } catch(e) {
    rejectPromise(e);
  }
}

function invokeCallback(subscriber){
  var owner = subscriber.owner;
  var settled = owner.state_;
  var value = owner.data_;  
  var callback = subscriber[settled];
  var promise = subscriber.then;

  if (typeof callback === 'function')
  {
    settled = FULFILLED;
    try {
      value = callback(value);
    } catch(e) {
      reject(promise, e);
    }
  }

  if (!handleThenable(promise, value))
  {
    if (settled === FULFILLED)
      resolve(promise, value);

    if (settled === REJECTED)
      reject(promise, value);
  }
}

function handleThenable(promise, value) {
  var resolved;

  try {
    if (promise === value)
      throw new TypeError('A promises callback cannot return that same promise.');

    if (value && (typeof value === 'function' || typeof value === 'object'))
    {
      var then = value.then;  // then should be retrived only once

      if (typeof then === 'function')
      {
        then.call(value, function(val){
          if (!resolved)
          {
            resolved = true;

            if (value !== val)
              resolve(promise, val);
            else
              fulfill(promise, val);
          }
        }, function(reason){
          if (!resolved)
          {
            resolved = true;

            reject(promise, reason);
          }
        });

        return true;
      }
    }
  } catch (e) {
    if (!resolved)
      reject(promise, e);

    return true;
  }

  return false;
}

function resolve(promise, value){
  if (promise === value || !handleThenable(promise, value))
    fulfill(promise, value);
}

function fulfill(promise, value){
  if (promise.state_ === PENDING)
  {
    promise.state_ = SEALED;
    promise.data_ = value;

    asyncCall(publishFulfillment, promise);
  }
}

function reject(promise, reason){
  if (promise.state_ === PENDING)
  {
    promise.state_ = SEALED;
    promise.data_ = reason;

    asyncCall(publishRejection, promise);
  }
}

function publish(promise) {
  var callbacks = promise.then_;
  promise.then_ = undefined;

  for (var i = 0; i < callbacks.length; i++) {
    invokeCallback(callbacks[i]);
  }
}

function publishFulfillment(promise){
  promise.state_ = FULFILLED;
  publish(promise);
}

function publishRejection(promise){
  promise.state_ = REJECTED;
  publish(promise);
}

/**
* @class
*/
function Promise(resolver){
  if (typeof resolver !== 'function')
    throw new TypeError('Promise constructor takes a function argument');

  if (this instanceof Promise === false)
    throw new TypeError('Failed to construct \'Promise\': Please use the \'new\' operator, this object constructor cannot be called as a function.');

  this.then_ = [];

  invokeResolver(resolver, this);
}

Promise.prototype = {
  constructor: Promise,

  state_: PENDING,
  then_: null,
  data_: undefined,

  then: function(onFulfillment, onRejection){
    var subscriber = {
      owner: this,
      then: new this.constructor(NOOP),
      fulfilled: onFulfillment,
      rejected: onRejection
    };

    if (this.state_ === FULFILLED || this.state_ === REJECTED)
    {
      // already resolved, call callback async
      asyncCall(invokeCallback, subscriber);
    }
    else
    {
      // subscribe
      this.then_.push(subscriber);
    }

    return subscriber.then;
  },

  'catch': function(onRejection) {
    return this.then(null, onRejection);
  }
};

Promise.all = function(promises){
  var Class = this;

  if (!isArray(promises))
    throw new TypeError('You must pass an array to Promise.all().');

  return new Class(function(resolve, reject){
    var results = [];
    var remaining = 0;

    function resolver(index){
      remaining++;
      return function(value){
        results[index] = value;
        if (!--remaining)
          resolve(results);
      };
    }

    for (var i = 0, promise; i < promises.length; i++)
    {
      promise = promises[i];

      if (promise && typeof promise.then === 'function')
        promise.then(resolver(i), reject);
      else
        results[i] = promise;
    }

    if (!remaining)
      resolve(results);
  });
};

Promise.race = function(promises){
  var Class = this;

  if (!isArray(promises))
    throw new TypeError('You must pass an array to Promise.race().');

  return new Class(function(resolve, reject) {
    for (var i = 0, promise; i < promises.length; i++)
    {
      promise = promises[i];

      if (promise && typeof promise.then === 'function')
        promise.then(resolve, reject);
      else
        resolve(promise);
    }
  });
};

Promise.resolve = function(value){
  var Class = this;

  if (value && typeof value === 'object' && value.constructor === Class)
    return value;

  return new Class(function(resolve){
    resolve(value);
  });
};

Promise.reject = function(reason){
  var Class = this;

  return new Class(function(resolve, reject){
    reject(reason);
  });
};

})(typeof window != 'undefined' ? window : typeof global != 'undefined' ? global : typeof self != 'undefined' ? self : this);

}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})

},{}],131:[function(require,module,exports){
(function (process,global){
/*!
 * @overview es6-promise - a tiny implementation of Promises/A+.
 * @copyright Copyright (c) 2014 Yehuda Katz, Tom Dale, Stefan Penner and contributors (Conversion to ES6 API by Jake Archibald)
 * @license   Licensed under MIT license
 *            See https://raw.githubusercontent.com/stefanpenner/es6-promise/master/LICENSE
 * @version   3.3.1
 */

(function (global, factory) {
    typeof exports === 'object' && typeof module !== 'undefined' ? module.exports = factory() :
    typeof define === 'function' && define.amd ? define(factory) :
    (global.ES6Promise = factory());
}(this, (function () { 'use strict';

function objectOrFunction(x) {
  return typeof x === 'function' || typeof x === 'object' && x !== null;
}

function isFunction(x) {
  return typeof x === 'function';
}

var _isArray = undefined;
if (!Array.isArray) {
  _isArray = function (x) {
    return Object.prototype.toString.call(x) === '[object Array]';
  };
} else {
  _isArray = Array.isArray;
}

var isArray = _isArray;

var len = 0;
var vertxNext = undefined;
var customSchedulerFn = undefined;

var asap = function asap(callback, arg) {
  queue[len] = callback;
  queue[len + 1] = arg;
  len += 2;
  if (len === 2) {
    // If len is 2, that means that we need to schedule an async flush.
    // If additional callbacks are queued before the queue is flushed, they
    // will be processed by this flush that we are scheduling.
    if (customSchedulerFn) {
      customSchedulerFn(flush);
    } else {
      scheduleFlush();
    }
  }
};

function setScheduler(scheduleFn) {
  customSchedulerFn = scheduleFn;
}

function setAsap(asapFn) {
  asap = asapFn;
}

var browserWindow = typeof window !== 'undefined' ? window : undefined;
var browserGlobal = browserWindow || {};
var BrowserMutationObserver = browserGlobal.MutationObserver || browserGlobal.WebKitMutationObserver;
var isNode = typeof self === 'undefined' && typeof process !== 'undefined' && ({}).toString.call(process) === '[object process]';

// test for web worker but not in IE10
var isWorker = typeof Uint8ClampedArray !== 'undefined' && typeof importScripts !== 'undefined' && typeof MessageChannel !== 'undefined';

// node
function useNextTick() {
  // node version 0.10.x displays a deprecation warning when nextTick is used recursively
  // see https://github.com/cujojs/when/issues/410 for details
  return function () {
    return process.nextTick(flush);
  };
}

// vertx
function useVertxTimer() {
  return function () {
    vertxNext(flush);
  };
}

function useMutationObserver() {
  var iterations = 0;
  var observer = new BrowserMutationObserver(flush);
  var node = document.createTextNode('');
  observer.observe(node, { characterData: true });

  return function () {
    node.data = iterations = ++iterations % 2;
  };
}

// web worker
function useMessageChannel() {
  var channel = new MessageChannel();
  channel.port1.onmessage = flush;
  return function () {
    return channel.port2.postMessage(0);
  };
}

function useSetTimeout() {
  // Store setTimeout reference so es6-promise will be unaffected by
  // other code modifying setTimeout (like sinon.useFakeTimers())
  var globalSetTimeout = setTimeout;
  return function () {
    return globalSetTimeout(flush, 1);
  };
}

var queue = new Array(1000);
function flush() {
  for (var i = 0; i < len; i += 2) {
    var callback = queue[i];
    var arg = queue[i + 1];

    callback(arg);

    queue[i] = undefined;
    queue[i + 1] = undefined;
  }

  len = 0;
}

function attemptVertx() {
  try {
    var r = require;
    var vertx = r('vertx');
    vertxNext = vertx.runOnLoop || vertx.runOnContext;
    return useVertxTimer();
  } catch (e) {
    return useSetTimeout();
  }
}

var scheduleFlush = undefined;
// Decide what async method to use to triggering processing of queued callbacks:
if (isNode) {
  scheduleFlush = useNextTick();
} else if (BrowserMutationObserver) {
  scheduleFlush = useMutationObserver();
} else if (isWorker) {
  scheduleFlush = useMessageChannel();
} else if (browserWindow === undefined && typeof require === 'function') {
  scheduleFlush = attemptVertx();
} else {
  scheduleFlush = useSetTimeout();
}

function then(onFulfillment, onRejection) {
  var _arguments = arguments;

  var parent = this;

  var child = new this.constructor(noop);

  if (child[PROMISE_ID] === undefined) {
    makePromise(child);
  }

  var _state = parent._state;

  if (_state) {
    (function () {
      var callback = _arguments[_state - 1];
      asap(function () {
        return invokeCallback(_state, child, callback, parent._result);
      });
    })();
  } else {
    subscribe(parent, child, onFulfillment, onRejection);
  }

  return child;
}

/**
  `Promise.resolve` returns a promise that will become resolved with the
  passed `value`. It is shorthand for the following:

  ```javascript
  let promise = new Promise(function(resolve, reject){
    resolve(1);
  });

  promise.then(function(value){
    // value === 1
  });
  ```

  Instead of writing the above, your code now simply becomes the following:

  ```javascript
  let promise = Promise.resolve(1);

  promise.then(function(value){
    // value === 1
  });
  ```

  @method resolve
  @static
  @param {Any} value value that the returned promise will be resolved with
  Useful for tooling.
  @return {Promise} a promise that will become fulfilled with the given
  `value`
*/
function resolve(object) {
  /*jshint validthis:true */
  var Constructor = this;

  if (object && typeof object === 'object' && object.constructor === Constructor) {
    return object;
  }

  var promise = new Constructor(noop);
  _resolve(promise, object);
  return promise;
}

var PROMISE_ID = Math.random().toString(36).substring(16);

function noop() {}

var PENDING = void 0;
var FULFILLED = 1;
var REJECTED = 2;

var GET_THEN_ERROR = new ErrorObject();

function selfFulfillment() {
  return new TypeError("You cannot resolve a promise with itself");
}

function cannotReturnOwn() {
  return new TypeError('A promises callback cannot return that same promise.');
}

function getThen(promise) {
  try {
    return promise.then;
  } catch (error) {
    GET_THEN_ERROR.error = error;
    return GET_THEN_ERROR;
  }
}

function tryThen(then, value, fulfillmentHandler, rejectionHandler) {
  try {
    then.call(value, fulfillmentHandler, rejectionHandler);
  } catch (e) {
    return e;
  }
}

function handleForeignThenable(promise, thenable, then) {
  asap(function (promise) {
    var sealed = false;
    var error = tryThen(then, thenable, function (value) {
      if (sealed) {
        return;
      }
      sealed = true;
      if (thenable !== value) {
        _resolve(promise, value);
      } else {
        fulfill(promise, value);
      }
    }, function (reason) {
      if (sealed) {
        return;
      }
      sealed = true;

      _reject(promise, reason);
    }, 'Settle: ' + (promise._label || ' unknown promise'));

    if (!sealed && error) {
      sealed = true;
      _reject(promise, error);
    }
  }, promise);
}

function handleOwnThenable(promise, thenable) {
  if (thenable._state === FULFILLED) {
    fulfill(promise, thenable._result);
  } else if (thenable._state === REJECTED) {
    _reject(promise, thenable._result);
  } else {
    subscribe(thenable, undefined, function (value) {
      return _resolve(promise, value);
    }, function (reason) {
      return _reject(promise, reason);
    });
  }
}

function handleMaybeThenable(promise, maybeThenable, then$$) {
  if (maybeThenable.constructor === promise.constructor && then$$ === then && maybeThenable.constructor.resolve === resolve) {
    handleOwnThenable(promise, maybeThenable);
  } else {
    if (then$$ === GET_THEN_ERROR) {
      _reject(promise, GET_THEN_ERROR.error);
    } else if (then$$ === undefined) {
      fulfill(promise, maybeThenable);
    } else if (isFunction(then$$)) {
      handleForeignThenable(promise, maybeThenable, then$$);
    } else {
      fulfill(promise, maybeThenable);
    }
  }
}

function _resolve(promise, value) {
  if (promise === value) {
    _reject(promise, selfFulfillment());
  } else if (objectOrFunction(value)) {
    handleMaybeThenable(promise, value, getThen(value));
  } else {
    fulfill(promise, value);
  }
}

function publishRejection(promise) {
  if (promise._onerror) {
    promise._onerror(promise._result);
  }

  publish(promise);
}

function fulfill(promise, value) {
  if (promise._state !== PENDING) {
    return;
  }

  promise._result = value;
  promise._state = FULFILLED;

  if (promise._subscribers.length !== 0) {
    asap(publish, promise);
  }
}

function _reject(promise, reason) {
  if (promise._state !== PENDING) {
    return;
  }
  promise._state = REJECTED;
  promise._result = reason;

  asap(publishRejection, promise);
}

function subscribe(parent, child, onFulfillment, onRejection) {
  var _subscribers = parent._subscribers;
  var length = _subscribers.length;

  parent._onerror = null;

  _subscribers[length] = child;
  _subscribers[length + FULFILLED] = onFulfillment;
  _subscribers[length + REJECTED] = onRejection;

  if (length === 0 && parent._state) {
    asap(publish, parent);
  }
}

function publish(promise) {
  var subscribers = promise._subscribers;
  var settled = promise._state;

  if (subscribers.length === 0) {
    return;
  }

  var child = undefined,
      callback = undefined,
      detail = promise._result;

  for (var i = 0; i < subscribers.length; i += 3) {
    child = subscribers[i];
    callback = subscribers[i + settled];

    if (child) {
      invokeCallback(settled, child, callback, detail);
    } else {
      callback(detail);
    }
  }

  promise._subscribers.length = 0;
}

function ErrorObject() {
  this.error = null;
}

var TRY_CATCH_ERROR = new ErrorObject();

function tryCatch(callback, detail) {
  try {
    return callback(detail);
  } catch (e) {
    TRY_CATCH_ERROR.error = e;
    return TRY_CATCH_ERROR;
  }
}

function invokeCallback(settled, promise, callback, detail) {
  var hasCallback = isFunction(callback),
      value = undefined,
      error = undefined,
      succeeded = undefined,
      failed = undefined;

  if (hasCallback) {
    value = tryCatch(callback, detail);

    if (value === TRY_CATCH_ERROR) {
      failed = true;
      error = value.error;
      value = null;
    } else {
      succeeded = true;
    }

    if (promise === value) {
      _reject(promise, cannotReturnOwn());
      return;
    }
  } else {
    value = detail;
    succeeded = true;
  }

  if (promise._state !== PENDING) {
    // noop
  } else if (hasCallback && succeeded) {
      _resolve(promise, value);
    } else if (failed) {
      _reject(promise, error);
    } else if (settled === FULFILLED) {
      fulfill(promise, value);
    } else if (settled === REJECTED) {
      _reject(promise, value);
    }
}

function initializePromise(promise, resolver) {
  try {
    resolver(function resolvePromise(value) {
      _resolve(promise, value);
    }, function rejectPromise(reason) {
      _reject(promise, reason);
    });
  } catch (e) {
    _reject(promise, e);
  }
}

var id = 0;
function nextId() {
  return id++;
}

function makePromise(promise) {
  promise[PROMISE_ID] = id++;
  promise._state = undefined;
  promise._result = undefined;
  promise._subscribers = [];
}

function Enumerator(Constructor, input) {
  this._instanceConstructor = Constructor;
  this.promise = new Constructor(noop);

  if (!this.promise[PROMISE_ID]) {
    makePromise(this.promise);
  }

  if (isArray(input)) {
    this._input = input;
    this.length = input.length;
    this._remaining = input.length;

    this._result = new Array(this.length);

    if (this.length === 0) {
      fulfill(this.promise, this._result);
    } else {
      this.length = this.length || 0;
      this._enumerate();
      if (this._remaining === 0) {
        fulfill(this.promise, this._result);
      }
    }
  } else {
    _reject(this.promise, validationError());
  }
}

function validationError() {
  return new Error('Array Methods must be provided an Array');
};

Enumerator.prototype._enumerate = function () {
  var length = this.length;
  var _input = this._input;

  for (var i = 0; this._state === PENDING && i < length; i++) {
    this._eachEntry(_input[i], i);
  }
};

Enumerator.prototype._eachEntry = function (entry, i) {
  var c = this._instanceConstructor;
  var resolve$$ = c.resolve;

  if (resolve$$ === resolve) {
    var _then = getThen(entry);

    if (_then === then && entry._state !== PENDING) {
      this._settledAt(entry._state, i, entry._result);
    } else if (typeof _then !== 'function') {
      this._remaining--;
      this._result[i] = entry;
    } else if (c === Promise) {
      var promise = new c(noop);
      handleMaybeThenable(promise, entry, _then);
      this._willSettleAt(promise, i);
    } else {
      this._willSettleAt(new c(function (resolve$$) {
        return resolve$$(entry);
      }), i);
    }
  } else {
    this._willSettleAt(resolve$$(entry), i);
  }
};

Enumerator.prototype._settledAt = function (state, i, value) {
  var promise = this.promise;

  if (promise._state === PENDING) {
    this._remaining--;

    if (state === REJECTED) {
      _reject(promise, value);
    } else {
      this._result[i] = value;
    }
  }

  if (this._remaining === 0) {
    fulfill(promise, this._result);
  }
};

Enumerator.prototype._willSettleAt = function (promise, i) {
  var enumerator = this;

  subscribe(promise, undefined, function (value) {
    return enumerator._settledAt(FULFILLED, i, value);
  }, function (reason) {
    return enumerator._settledAt(REJECTED, i, reason);
  });
};

/**
  `Promise.all` accepts an array of promises, and returns a new promise which
  is fulfilled with an array of fulfillment values for the passed promises, or
  rejected with the reason of the first passed promise to be rejected. It casts all
  elements of the passed iterable to promises as it runs this algorithm.

  Example:

  ```javascript
  let promise1 = resolve(1);
  let promise2 = resolve(2);
  let promise3 = resolve(3);
  let promises = [ promise1, promise2, promise3 ];

  Promise.all(promises).then(function(array){
    // The array here would be [ 1, 2, 3 ];
  });
  ```

  If any of the `promises` given to `all` are rejected, the first promise
  that is rejected will be given as an argument to the returned promises's
  rejection handler. For example:

  Example:

  ```javascript
  let promise1 = resolve(1);
  let promise2 = reject(new Error("2"));
  let promise3 = reject(new Error("3"));
  let promises = [ promise1, promise2, promise3 ];

  Promise.all(promises).then(function(array){
    // Code here never runs because there are rejected promises!
  }, function(error) {
    // error.message === "2"
  });
  ```

  @method all
  @static
  @param {Array} entries array of promises
  @param {String} label optional string for labeling the promise.
  Useful for tooling.
  @return {Promise} promise that is fulfilled when all `promises` have been
  fulfilled, or rejected if any of them become rejected.
  @static
*/
function all(entries) {
  return new Enumerator(this, entries).promise;
}

/**
  `Promise.race` returns a new promise which is settled in the same way as the
  first passed promise to settle.

  Example:

  ```javascript
  let promise1 = new Promise(function(resolve, reject){
    setTimeout(function(){
      resolve('promise 1');
    }, 200);
  });

  let promise2 = new Promise(function(resolve, reject){
    setTimeout(function(){
      resolve('promise 2');
    }, 100);
  });

  Promise.race([promise1, promise2]).then(function(result){
    // result === 'promise 2' because it was resolved before promise1
    // was resolved.
  });
  ```

  `Promise.race` is deterministic in that only the state of the first
  settled promise matters. For example, even if other promises given to the
  `promises` array argument are resolved, but the first settled promise has
  become rejected before the other promises became fulfilled, the returned
  promise will become rejected:

  ```javascript
  let promise1 = new Promise(function(resolve, reject){
    setTimeout(function(){
      resolve('promise 1');
    }, 200);
  });

  let promise2 = new Promise(function(resolve, reject){
    setTimeout(function(){
      reject(new Error('promise 2'));
    }, 100);
  });

  Promise.race([promise1, promise2]).then(function(result){
    // Code here never runs
  }, function(reason){
    // reason.message === 'promise 2' because promise 2 became rejected before
    // promise 1 became fulfilled
  });
  ```

  An example real-world use case is implementing timeouts:

  ```javascript
  Promise.race([ajax('foo.json'), timeout(5000)])
  ```

  @method race
  @static
  @param {Array} promises array of promises to observe
  Useful for tooling.
  @return {Promise} a promise which settles in the same way as the first passed
  promise to settle.
*/
function race(entries) {
  /*jshint validthis:true */
  var Constructor = this;

  if (!isArray(entries)) {
    return new Constructor(function (_, reject) {
      return reject(new TypeError('You must pass an array to race.'));
    });
  } else {
    return new Constructor(function (resolve, reject) {
      var length = entries.length;
      for (var i = 0; i < length; i++) {
        Constructor.resolve(entries[i]).then(resolve, reject);
      }
    });
  }
}

/**
  `Promise.reject` returns a promise rejected with the passed `reason`.
  It is shorthand for the following:

  ```javascript
  let promise = new Promise(function(resolve, reject){
    reject(new Error('WHOOPS'));
  });

  promise.then(function(value){
    // Code here doesn't run because the promise is rejected!
  }, function(reason){
    // reason.message === 'WHOOPS'
  });
  ```

  Instead of writing the above, your code now simply becomes the following:

  ```javascript
  let promise = Promise.reject(new Error('WHOOPS'));

  promise.then(function(value){
    // Code here doesn't run because the promise is rejected!
  }, function(reason){
    // reason.message === 'WHOOPS'
  });
  ```

  @method reject
  @static
  @param {Any} reason value that the returned promise will be rejected with.
  Useful for tooling.
  @return {Promise} a promise rejected with the given `reason`.
*/
function reject(reason) {
  /*jshint validthis:true */
  var Constructor = this;
  var promise = new Constructor(noop);
  _reject(promise, reason);
  return promise;
}

function needsResolver() {
  throw new TypeError('You must pass a resolver function as the first argument to the promise constructor');
}

function needsNew() {
  throw new TypeError("Failed to construct 'Promise': Please use the 'new' operator, this object constructor cannot be called as a function.");
}

/**
  Promise objects represent the eventual result of an asynchronous operation. The
  primary way of interacting with a promise is through its `then` method, which
  registers callbacks to receive either a promise's eventual value or the reason
  why the promise cannot be fulfilled.

  Terminology
  -----------

  - `promise` is an object or function with a `then` method whose behavior conforms to this specification.
  - `thenable` is an object or function that defines a `then` method.
  - `value` is any legal JavaScript value (including undefined, a thenable, or a promise).
  - `exception` is a value that is thrown using the throw statement.
  - `reason` is a value that indicates why a promise was rejected.
  - `settled` the final resting state of a promise, fulfilled or rejected.

  A promise can be in one of three states: pending, fulfilled, or rejected.

  Promises that are fulfilled have a fulfillment value and are in the fulfilled
  state.  Promises that are rejected have a rejection reason and are in the
  rejected state.  A fulfillment value is never a thenable.

  Promises can also be said to *resolve* a value.  If this value is also a
  promise, then the original promise's settled state will match the value's
  settled state.  So a promise that *resolves* a promise that rejects will
  itself reject, and a promise that *resolves* a promise that fulfills will
  itself fulfill.


  Basic Usage:
  ------------

  ```js
  let promise = new Promise(function(resolve, reject) {
    // on success
    resolve(value);

    // on failure
    reject(reason);
  });

  promise.then(function(value) {
    // on fulfillment
  }, function(reason) {
    // on rejection
  });
  ```

  Advanced Usage:
  ---------------

  Promises shine when abstracting away asynchronous interactions such as
  `XMLHttpRequest`s.

  ```js
  function getJSON(url) {
    return new Promise(function(resolve, reject){
      let xhr = new XMLHttpRequest();

      xhr.open('GET', url);
      xhr.onreadystatechange = handler;
      xhr.responseType = 'json';
      xhr.setRequestHeader('Accept', 'application/json');
      xhr.send();

      function handler() {
        if (this.readyState === this.DONE) {
          if (this.status === 200) {
            resolve(this.response);
          } else {
            reject(new Error('getJSON: `' + url + '` failed with status: [' + this.status + ']'));
          }
        }
      };
    });
  }

  getJSON('/posts.json').then(function(json) {
    // on fulfillment
  }, function(reason) {
    // on rejection
  });
  ```

  Unlike callbacks, promises are great composable primitives.

  ```js
  Promise.all([
    getJSON('/posts'),
    getJSON('/comments')
  ]).then(function(values){
    values[0] // => postsJSON
    values[1] // => commentsJSON

    return values;
  });
  ```

  @class Promise
  @param {function} resolver
  Useful for tooling.
  @constructor
*/
function Promise(resolver) {
  this[PROMISE_ID] = nextId();
  this._result = this._state = undefined;
  this._subscribers = [];

  if (noop !== resolver) {
    typeof resolver !== 'function' && needsResolver();
    this instanceof Promise ? initializePromise(this, resolver) : needsNew();
  }
}

Promise.all = all;
Promise.race = race;
Promise.resolve = resolve;
Promise.reject = reject;
Promise._setScheduler = setScheduler;
Promise._setAsap = setAsap;
Promise._asap = asap;

Promise.prototype = {
  constructor: Promise,

  /**
    The primary way of interacting with a promise is through its `then` method,
    which registers callbacks to receive either a promise's eventual value or the
    reason why the promise cannot be fulfilled.
  
    ```js
    findUser().then(function(user){
      // user is available
    }, function(reason){
      // user is unavailable, and you are given the reason why
    });
    ```
  
    Chaining
    --------
  
    The return value of `then` is itself a promise.  This second, 'downstream'
    promise is resolved with the return value of the first promise's fulfillment
    or rejection handler, or rejected if the handler throws an exception.
  
    ```js
    findUser().then(function (user) {
      return user.name;
    }, function (reason) {
      return 'default name';
    }).then(function (userName) {
      // If `findUser` fulfilled, `userName` will be the user's name, otherwise it
      // will be `'default name'`
    });
  
    findUser().then(function (user) {
      throw new Error('Found user, but still unhappy');
    }, function (reason) {
      throw new Error('`findUser` rejected and we're unhappy');
    }).then(function (value) {
      // never reached
    }, function (reason) {
      // if `findUser` fulfilled, `reason` will be 'Found user, but still unhappy'.
      // If `findUser` rejected, `reason` will be '`findUser` rejected and we're unhappy'.
    });
    ```
    If the downstream promise does not specify a rejection handler, rejection reasons will be propagated further downstream.
  
    ```js
    findUser().then(function (user) {
      throw new PedagogicalException('Upstream error');
    }).then(function (value) {
      // never reached
    }).then(function (value) {
      // never reached
    }, function (reason) {
      // The `PedgagocialException` is propagated all the way down to here
    });
    ```
  
    Assimilation
    ------------
  
    Sometimes the value you want to propagate to a downstream promise can only be
    retrieved asynchronously. This can be achieved by returning a promise in the
    fulfillment or rejection handler. The downstream promise will then be pending
    until the returned promise is settled. This is called *assimilation*.
  
    ```js
    findUser().then(function (user) {
      return findCommentsByAuthor(user);
    }).then(function (comments) {
      // The user's comments are now available
    });
    ```
  
    If the assimliated promise rejects, then the downstream promise will also reject.
  
    ```js
    findUser().then(function (user) {
      return findCommentsByAuthor(user);
    }).then(function (comments) {
      // If `findCommentsByAuthor` fulfills, we'll have the value here
    }, function (reason) {
      // If `findCommentsByAuthor` rejects, we'll have the reason here
    });
    ```
  
    Simple Example
    --------------
  
    Synchronous Example
  
    ```javascript
    let result;
  
    try {
      result = findResult();
      // success
    } catch(reason) {
      // failure
    }
    ```
  
    Errback Example
  
    ```js
    findResult(function(result, err){
      if (err) {
        // failure
      } else {
        // success
      }
    });
    ```
  
    Promise Example;
  
    ```javascript
    findResult().then(function(result){
      // success
    }, function(reason){
      // failure
    });
    ```
  
    Advanced Example
    --------------
  
    Synchronous Example
  
    ```javascript
    let author, books;
  
    try {
      author = findAuthor();
      books  = findBooksByAuthor(author);
      // success
    } catch(reason) {
      // failure
    }
    ```
  
    Errback Example
  
    ```js
  
    function foundBooks(books) {
  
    }
  
    function failure(reason) {
  
    }
  
    findAuthor(function(author, err){
      if (err) {
        failure(err);
        // failure
      } else {
        try {
          findBoooksByAuthor(author, function(books, err) {
            if (err) {
              failure(err);
            } else {
              try {
                foundBooks(books);
              } catch(reason) {
                failure(reason);
              }
            }
          });
        } catch(error) {
          failure(err);
        }
        // success
      }
    });
    ```
  
    Promise Example;
  
    ```javascript
    findAuthor().
      then(findBooksByAuthor).
      then(function(books){
        // found books
    }).catch(function(reason){
      // something went wrong
    });
    ```
  
    @method then
    @param {Function} onFulfilled
    @param {Function} onRejected
    Useful for tooling.
    @return {Promise}
  */
  then: then,

  /**
    `catch` is simply sugar for `then(undefined, onRejection)` which makes it the same
    as the catch block of a try/catch statement.
  
    ```js
    function findAuthor(){
      throw new Error('couldn't find that author');
    }
  
    // synchronous
    try {
      findAuthor();
    } catch(reason) {
      // something went wrong
    }
  
    // async with promises
    findAuthor().catch(function(reason){
      // something went wrong
    });
    ```
  
    @method catch
    @param {Function} onRejection
    Useful for tooling.
    @return {Promise}
  */
  'catch': function _catch(onRejection) {
    return this.then(null, onRejection);
  }
};

function polyfill() {
    var local = undefined;

    if (typeof global !== 'undefined') {
        local = global;
    } else if (typeof self !== 'undefined') {
        local = self;
    } else {
        try {
            local = Function('return this')();
        } catch (e) {
            throw new Error('polyfill failed because global object is unavailable in this environment');
        }
    }

    var P = local.Promise;

    if (P) {
        var promiseToString = null;
        try {
            promiseToString = Object.prototype.toString.call(P.resolve());
        } catch (e) {
            // silently ignored
        }

        if (promiseToString === '[object Promise]' && !P.cast) {
            return;
        }
    }

    local.Promise = Promise;
}

polyfill();
// Strange compat..
Promise.polyfill = polyfill;
Promise.Promise = Promise;

return Promise;

})));

}).call(this,require('_process'),typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})

},{"_process":138}],132:[function(require,module,exports){
(function (global){
/*jslint es6, node, browser, maxlen: 120 */
/*global self, window */

"use strict";

module.exports = (function () {

    "use strict";

    var globalObject = undefined;

    function isFunction(x) {
        return typeof x === "function";
    }

    // Seek the global object
    if (global !== undefined) {
        globalObject = global;
    } else if (window !== undefined && window.document) {
        globalObject = window;
    } else {
        globalObject = self;
    }

    // Test for any native promise implementation, and if that
    // implementation appears to conform to the specificaton.
    // This code mostly nicked from the es6-promise module polyfill
    // and then fooled with.
    var hasPromiseSupport = (function () {

        // No promise object at all, and it's a non-starter
        if (!globalObject.hasOwnProperty("Promise")) {
            return false;
        }

        // There is a Promise object. Does it conform to the spec?
        var P = globalObject.Promise;

        // Some of these methods are missing from
        // Firefox/Chrome experimental implementations
        if (!P.hasOwnProperty("resolve") || !P.hasOwnProperty("reject")) {
            return false;
        }

        if (!P.hasOwnProperty("all") || !P.hasOwnProperty("race")) {
            return false;
        }

        // Older version of the spec had a resolver object
        // as the arg rather than a function
        return (function () {

            var resolve = undefined,
                p = new globalObject.Promise(function (r) {
                resolve = r;
            });

            if (p) {
                return isFunction(resolve);
            }

            return false;
        })();
    })();

    // Export the native Promise implementation if it
    // looks like it matches the spec
    if (hasPromiseSupport) {
        return globalObject.Promise;
    }

    //  Otherwise, return the es6-promise polyfill by @jaffathecake.
    return require("es6-promise").Promise;
})();
}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})

},{"es6-promise":131}],133:[function(require,module,exports){
/*jslint node, this, es6, maxlen: 120 */
"use strict";

module.exports = (function () {

    "use strict";

    // Get a promise object. This may be native, or it may be polyfilled
    var ES6Promise = require("./promise.js");

    // Promise Context object constructor.
    function Context(resolve, reject, custom) {
        this.resolve = resolve;
        this.reject = reject;
        this.custom = custom;
    }

    // Default callback function - rejects on truthy error, otherwise resolves
    function callback() {
        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        var ctx = args.shift(),
            err = args.shift(),
            cust = undefined;

        args = args.length > 1 ? args : args[0];

        if (typeof ctx.custom === 'function') {
            cust = function () {
                for (var _len2 = arguments.length, custArgs = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
                    custArgs[_key2] = arguments[_key2];
                }

                // Bind the callback to itself, so the resolve and reject
                // properties that we bound are available to the callback.
                // Then we push it onto the end of the arguments array.
                return ctx.custom.apply(cust, custArgs);
            };
            cust.resolve = ctx.resolve;
            cust.reject = ctx.reject;
            cust.call(null, err, args);
        } else {
            if (err) {
                return ctx.reject(err);
            }
            ctx.resolve(args);
        }
    }

    /**
     * promisify
     *
     * Transforms callback-based function -- func(arg1, arg2 .. argN, callback) -- into
     * an ES6-compatible Promise. User can provide their own callback function; otherwise
     * promisify provides a callback of the form (error, result) and rejects on truthy error.
     * If supplying your own callback function, use this.resolve() and this.reject().
     *
     * @param {function} original - The function to promisify
     * @param {function} callback - Optional custom callbac function
     *
     * @return {function} A promisified version of 'original'
     */
    return function (original, custom) {

        return function () {
            for (var _len3 = arguments.length, args = Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
                args[_key3] = arguments[_key3];
            }

            // Store original context
            var that = this;

            // Return the promisified function
            return new ES6Promise(function (resolve, reject) {

                // Create a Context object
                var ctx = new Context(resolve, reject, custom);

                // Append the callback bound to the context
                args.push(callback.bind(null, ctx));

                // Call the function
                original.apply(that, args);
            });
        };
    };
})();
},{"./promise.js":132}],134:[function(require,module,exports){
(function() {
	var testObject = {};

	if (!(Object.setPrototypeOf || testObject.__proto__)) {
		var nativeGetPrototypeOf = Object.getPrototypeOf;

		Object.getPrototypeOf = function(object) {
			if (object.__proto__) {
				return object.__proto__;
			} else {
				return nativeGetPrototypeOf.call(Object, object);
			}
		}
	}
})();

},{}],135:[function(require,module,exports){
"use strict";

/**
 * Expose `md5omatic(str)`.
 */
 
module.exports = md5omatic;

/**
 * Hash any string using message digest.
 *
 * @param {String} str
 * @return {String}
 * @api public
 */
 
function md5omatic(str) {
    var x = str2blks_MD5(str);
    var a =  1732584193;
    var b = -271733879;
    var c = -1732584194;
    var d =  271733878;

    for(var i=0; i<x.length; i += 16)
    {
        var olda = a;
        var oldb = b;
        var oldc = c;
        var oldd = d;

        a = ff(a, b, c, d, x[i+ 0], 7 , -680876936);
        d = ff(d, a, b, c, x[i+ 1], 12, -389564586);
        c = ff(c, d, a, b, x[i+ 2], 17,  606105819);
        b = ff(b, c, d, a, x[i+ 3], 22, -1044525330);
        a = ff(a, b, c, d, x[i+ 4], 7 , -176418897);
        d = ff(d, a, b, c, x[i+ 5], 12,  1200080426);
        c = ff(c, d, a, b, x[i+ 6], 17, -1473231341);
        b = ff(b, c, d, a, x[i+ 7], 22, -45705983);
        a = ff(a, b, c, d, x[i+ 8], 7 ,  1770035416);
        d = ff(d, a, b, c, x[i+ 9], 12, -1958414417);
        c = ff(c, d, a, b, x[i+10], 17, -42063);
        b = ff(b, c, d, a, x[i+11], 22, -1990404162);
        a = ff(a, b, c, d, x[i+12], 7 ,  1804603682);
        d = ff(d, a, b, c, x[i+13], 12, -40341101);
        c = ff(c, d, a, b, x[i+14], 17, -1502002290);
        b = ff(b, c, d, a, x[i+15], 22,  1236535329);
        a = gg(a, b, c, d, x[i+ 1], 5 , -165796510);
        d = gg(d, a, b, c, x[i+ 6], 9 , -1069501632);
        c = gg(c, d, a, b, x[i+11], 14,  643717713);
        b = gg(b, c, d, a, x[i+ 0], 20, -373897302);
        a = gg(a, b, c, d, x[i+ 5], 5 , -701558691);
        d = gg(d, a, b, c, x[i+10], 9 ,  38016083);
        c = gg(c, d, a, b, x[i+15], 14, -660478335);
        b = gg(b, c, d, a, x[i+ 4], 20, -405537848);
        a = gg(a, b, c, d, x[i+ 9], 5 ,  568446438);
        d = gg(d, a, b, c, x[i+14], 9 , -1019803690);
        c = gg(c, d, a, b, x[i+ 3], 14, -187363961);
        b = gg(b, c, d, a, x[i+ 8], 20,  1163531501);
        a = gg(a, b, c, d, x[i+13], 5 , -1444681467);
        d = gg(d, a, b, c, x[i+ 2], 9 , -51403784);
        c = gg(c, d, a, b, x[i+ 7], 14,  1735328473);
        b = gg(b, c, d, a, x[i+12], 20, -1926607734);
        a = hh(a, b, c, d, x[i+ 5], 4 , -378558);
        d = hh(d, a, b, c, x[i+ 8], 11, -2022574463);
        c = hh(c, d, a, b, x[i+11], 16,  1839030562);
        b = hh(b, c, d, a, x[i+14], 23, -35309556);
        a = hh(a, b, c, d, x[i+ 1], 4 , -1530992060);
        d = hh(d, a, b, c, x[i+ 4], 11,  1272893353);
        c = hh(c, d, a, b, x[i+ 7], 16, -155497632);
        b = hh(b, c, d, a, x[i+10], 23, -1094730640);
        a = hh(a, b, c, d, x[i+13], 4 ,  681279174);
        d = hh(d, a, b, c, x[i+ 0], 11, -358537222);
        c = hh(c, d, a, b, x[i+ 3], 16, -722521979);
        b = hh(b, c, d, a, x[i+ 6], 23,  76029189);
        a = hh(a, b, c, d, x[i+ 9], 4 , -640364487);
        d = hh(d, a, b, c, x[i+12], 11, -421815835);
        c = hh(c, d, a, b, x[i+15], 16,  530742520);
        b = hh(b, c, d, a, x[i+ 2], 23, -995338651);
        a = ii(a, b, c, d, x[i+ 0], 6 , -198630844);
        d = ii(d, a, b, c, x[i+ 7], 10,  1126891415);
        c = ii(c, d, a, b, x[i+14], 15, -1416354905);
        b = ii(b, c, d, a, x[i+ 5], 21, -57434055);
        a = ii(a, b, c, d, x[i+12], 6 ,  1700485571);
        d = ii(d, a, b, c, x[i+ 3], 10, -1894986606);
        c = ii(c, d, a, b, x[i+10], 15, -1051523);
        b = ii(b, c, d, a, x[i+ 1], 21, -2054922799);
        a = ii(a, b, c, d, x[i+ 8], 6 ,  1873313359);
        d = ii(d, a, b, c, x[i+15], 10, -30611744);
        c = ii(c, d, a, b, x[i+ 6], 15, -1560198380);
        b = ii(b, c, d, a, x[i+13], 21,  1309151649);
        a = ii(a, b, c, d, x[i+ 4], 6 , -145523070);
        d = ii(d, a, b, c, x[i+11], 10, -1120210379);
        c = ii(c, d, a, b, x[i+ 2], 15,  718787259);
        b = ii(b, c, d, a, x[i+ 9], 21, -343485551);

        a = addme(a, olda);
        b = addme(b, oldb);
        c = addme(c, oldc);
        d = addme(d, oldd);
    }

    return rhex(a) + rhex(b) + rhex(c) + rhex(d);
};

var hex_chr = "0123456789abcdef";

function bitOR(a, b)
{
    var lsb = (a & 0x1) | (b & 0x1);
    var msb31 = (a >>> 1) | (b >>> 1);

    return (msb31 << 1) | lsb;
}

function bitXOR(a, b)
{
    var lsb = (a & 0x1) ^ (b & 0x1);
    var msb31 = (a >>> 1) ^ (b >>> 1);

    return (msb31 << 1) | lsb;
}

function bitAND(a, b)
{
    var lsb = (a & 0x1) & (b & 0x1);
    var msb31 = (a >>> 1) & (b >>> 1);

    return (msb31 << 1) | lsb;
}

function addme(x, y)
{
    var lsw = (x & 0xFFFF)+(y & 0xFFFF);
    var msw = (x >> 16)+(y >> 16)+(lsw >> 16);

    return (msw << 16) | (lsw & 0xFFFF);
}

function rhex(num)
{
    var str = "";
    var j;

    for(j=0; j<=3; j++)
        str += hex_chr.charAt((num >> (j * 8 + 4)) & 0x0F) + hex_chr.charAt((num >> (j * 8)) & 0x0F);

    return str;
}

function str2blks_MD5(str)
{
    var nblk = ((str.length + 8) >> 6) + 1;
    var blks = new Array(nblk * 16);
    var i;

    for(i=0; i<nblk * 16; i++)
        blks[i] = 0;

    for(i=0; i<str.length; i++)
        blks[i >> 2] |= str.charCodeAt(i) << (((str.length * 8 + i) % 4) * 8);

    blks[i >> 2] |= 0x80 << (((str.length * 8 + i) % 4) * 8);

    var l = str.length * 8;
    blks[nblk * 16 - 2] = (l & 0xFF);
    blks[nblk * 16 - 2] |= ((l >>> 8) & 0xFF) << 8;
    blks[nblk * 16 - 2] |= ((l >>> 16) & 0xFF) << 16;
    blks[nblk * 16 - 2] |= ((l >>> 24) & 0xFF) << 24;

    return blks;
}

function rol(num, cnt)
{
    return (num << cnt) | (num >>> (32 - cnt));
}

function cmn(q, a, b, x, s, t)
{
    return addme(rol((addme(addme(a, q), addme(x, t))), s), b);
}

function ff(a, b, c, d, x, s, t)
{
    return cmn(bitOR(bitAND(b, c), bitAND((~b), d)), a, b, x, s, t);
}

function gg(a, b, c, d, x, s, t)
{
    return cmn(bitOR(bitAND(b, d), bitAND(c, (~d))), a, b, x, s, t);
}

function hh(a, b, c, d, x, s, t)
{
    return cmn(bitXOR(bitXOR(b, c), d), a, b, x, s, t);
}

function ii(a, b, c, d, x, s, t)
{
    return cmn(bitXOR(c, bitOR(b, (~d))), a, b, x, s, t);
}
},{}],136:[function(require,module,exports){
var md5omatic = require('md5-o-matic');

module.exports = function (func, prefix) {
  prefix = prefix || '';
  func = func || function () { return '_default'; };
  return function () {
    var args = Array.prototype.slice.call(arguments);
    var k = func.apply(undefined, args);
    if (k === null) {
      return null;
    }
    if (typeof k === 'undefined' ||
      (typeof k === 'number' && isNaN(k)) ||
      k === '' ||
      (typeof k === 'object' && Object.keys(k).length === 0)) {
      throw new Error('Not a valid key');
    }
    if (typeof k !== 'string') {
      k = md5omatic(JSON.stringify(k));
    }
    return prefix + k;
  };
};

},{"md5-o-matic":135}],137:[function(require,module,exports){
function isObj(v) {
  return typeof v === 'object';
}

function isStr(v) {
  return typeof v === 'string';
}

function isBool(v) {
  return typeof v === 'boolean';
}

function isUndef(v) {
  if (typeof v === 'string') {
    return v.length === 0;
  }
  return typeof v === 'undefined';
}

function flatten(arr) {
  return [].concat.apply([], arr);
}

var emailRE = /.+\@.+\..+/;

var _validatorFactories = {
  object: function () { return function (value) { return (isUndef(value) || isObj(value) ? [] : ['object.base']); }; },
  string: function () { return function (value) { return (isUndef(value) || isStr(value) ? [] : ['string.base']); }; },
  boolean: function () { return function (value) { return (isUndef(value) || isBool(value) ? [] : ['boolean.base']); }; },
  min: function (minValue) { return function (value) { return (isUndef(value) || value.length >= minValue ? [] : ['string.min']); }; },
  max: function (maxValue) { return function (value) { return (isUndef(value) || value.length <= maxValue ? [] : ['string.max']); }; },
  email: function () { return function (value) { return (isUndef(value) || emailRE.test(value) ? [] : ['string.email']); }; },
  required: function () { return function (value) { return (!isUndef(value) ? [] : ['any.empty']); }; },
  regex: function (re) { return function (value) { return (isUndef(value) || re.test(value) ? [] : ['string.regex.base']); }; },
  keys: function (obj) { return function (value) { return (isUndef(value) ? [] : flatten(Object.keys(obj).map(function (attr) { return obj[attr]._validate(value[attr], attr); }))); }; },
};

function _joi() {
  this._validators = [];
}

var joi = {};

Object.keys(_validatorFactories).forEach(function (k) {
  _joi.prototype[k] = function unnamed(arg) {
    this._validators.push(_validatorFactories[k](arg));
    return this;
  };

  joi[k] = function (arg) {
    var j = new _joi();
    return j[k](arg);
  };
});

_joi.prototype._validate = function _validate(value, path) {
  return flatten(this._validators.map(function (func) { return func(value); }))
  .map(function (e) {
    var out = {
      type: typeof e === 'string' ? e : e.type,
    };
    var paths = [];
    if (path) {
      paths.push(path);
    }
    if (typeof e !== 'string' && 'path' in e) {
      paths.push(e.path);
    }

    if (paths.length) {
      out.path = paths.join('.');
    }
    return out;
  });
};

joi.validate = function validate(data, schema, options, callback) {
  // const abortEarly = options.abortEarly;
  var errors = schema._validate(data);
  var out = errors.length ? {
    error: {
      details: errors,
    },
    value: data,
  } : { error: null, value: data };

  if (callback) {
    callback(out.error, out.value);
  }
  return out;
};

module.exports = joi;

},{}],138:[function(require,module,exports){
// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };

},{}],139:[function(require,module,exports){
module.exports = require('./lib/effects')
},{"./lib/effects":140}],140:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _io = require('./internal/io');

Object.defineProperty(exports, 'take', {
  enumerable: true,
  get: function get() {
    return _io.take;
  }
});
Object.defineProperty(exports, 'takem', {
  enumerable: true,
  get: function get() {
    return _io.takem;
  }
});
Object.defineProperty(exports, 'put', {
  enumerable: true,
  get: function get() {
    return _io.put;
  }
});
Object.defineProperty(exports, 'race', {
  enumerable: true,
  get: function get() {
    return _io.race;
  }
});
Object.defineProperty(exports, 'call', {
  enumerable: true,
  get: function get() {
    return _io.call;
  }
});
Object.defineProperty(exports, 'apply', {
  enumerable: true,
  get: function get() {
    return _io.apply;
  }
});
Object.defineProperty(exports, 'cps', {
  enumerable: true,
  get: function get() {
    return _io.cps;
  }
});
Object.defineProperty(exports, 'fork', {
  enumerable: true,
  get: function get() {
    return _io.fork;
  }
});
Object.defineProperty(exports, 'spawn', {
  enumerable: true,
  get: function get() {
    return _io.spawn;
  }
});
Object.defineProperty(exports, 'join', {
  enumerable: true,
  get: function get() {
    return _io.join;
  }
});
Object.defineProperty(exports, 'cancel', {
  enumerable: true,
  get: function get() {
    return _io.cancel;
  }
});
Object.defineProperty(exports, 'select', {
  enumerable: true,
  get: function get() {
    return _io.select;
  }
});
Object.defineProperty(exports, 'actionChannel', {
  enumerable: true,
  get: function get() {
    return _io.actionChannel;
  }
});
Object.defineProperty(exports, 'cancelled', {
  enumerable: true,
  get: function get() {
    return _io.cancelled;
  }
});
Object.defineProperty(exports, 'flush', {
  enumerable: true,
  get: function get() {
    return _io.flush;
  }
});
},{"./internal/io":145}],141:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.utils = exports.effects = exports.CANCEL = exports.delay = exports.throttle = exports.takeLatest = exports.takeEvery = exports.buffers = exports.channel = exports.eventChannel = exports.END = exports.runSaga = undefined;

var _runSaga = require('./internal/runSaga');

Object.defineProperty(exports, 'runSaga', {
  enumerable: true,
  get: function get() {
    return _runSaga.runSaga;
  }
});

var _channel = require('./internal/channel');

Object.defineProperty(exports, 'END', {
  enumerable: true,
  get: function get() {
    return _channel.END;
  }
});
Object.defineProperty(exports, 'eventChannel', {
  enumerable: true,
  get: function get() {
    return _channel.eventChannel;
  }
});
Object.defineProperty(exports, 'channel', {
  enumerable: true,
  get: function get() {
    return _channel.channel;
  }
});

var _buffers = require('./internal/buffers');

Object.defineProperty(exports, 'buffers', {
  enumerable: true,
  get: function get() {
    return _buffers.buffers;
  }
});

var _sagaHelpers = require('./internal/sagaHelpers');

Object.defineProperty(exports, 'takeEvery', {
  enumerable: true,
  get: function get() {
    return _sagaHelpers.takeEvery;
  }
});
Object.defineProperty(exports, 'takeLatest', {
  enumerable: true,
  get: function get() {
    return _sagaHelpers.takeLatest;
  }
});
Object.defineProperty(exports, 'throttle', {
  enumerable: true,
  get: function get() {
    return _sagaHelpers.throttle;
  }
});

var _utils = require('./internal/utils');

Object.defineProperty(exports, 'delay', {
  enumerable: true,
  get: function get() {
    return _utils.delay;
  }
});
Object.defineProperty(exports, 'CANCEL', {
  enumerable: true,
  get: function get() {
    return _utils.CANCEL;
  }
});

var _middleware = require('./internal/middleware');

var _middleware2 = _interopRequireDefault(_middleware);

var _effects = require('./effects');

var effects = _interopRequireWildcard(_effects);

var _utils2 = require('./utils');

var utils = _interopRequireWildcard(_utils2);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _middleware2.default;
exports.effects = effects;
exports.utils = utils;
},{"./effects":140,"./internal/buffers":143,"./internal/channel":144,"./internal/middleware":146,"./internal/runSaga":148,"./internal/sagaHelpers":149,"./internal/utils":150,"./utils":151}],142:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = asap;
var queue = [];
var isSuspended = false;

function asap(task) {
  if (!isSuspended) {
    isSuspended = true;
    queue.push(task);
    asap.flush();
  } else {
    queue.push(task);
  }
}

asap.suspend = function () {
  return isSuspended = true;
};
asap.flush = function () {
  var nextTask = void 0;
  while (nextTask = queue.shift()) {
    nextTask();
  }
  isSuspended = false;
};
},{}],143:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.buffers = exports.BUFFER_OVERFLOW = undefined;

var _utils = require('./utils');

var BUFFER_OVERFLOW = exports.BUFFER_OVERFLOW = 'Channel\'s Buffer overflow!';

var ON_OVERFLOW_THROW = 1;
var ON_OVERFLOW_DROP = 2;
var ON_OVERFLOW_SLIDE = 3;
var ON_OVERFLOW_EXPAND = 4;

var zeroBuffer = { isEmpty: _utils.kTrue, put: _utils.noop, take: _utils.noop };

function ringBuffer() {
  var limit = arguments.length <= 0 || arguments[0] === undefined ? 10 : arguments[0];
  var overflowAction = arguments[1];

  var arr = new Array(limit);
  var length = 0;
  var pushIndex = 0;
  var popIndex = 0;

  var push = function push(it) {
    arr[pushIndex] = it;
    pushIndex = (pushIndex + 1) % limit;
    length++;
  };

  var take = function take() {
    if (length != 0) {
      var it = arr[popIndex];
      arr[popIndex] = null;
      length--;
      popIndex = (popIndex + 1) % limit;
      return it;
    }
  };

  var flush = function flush() {
    var items = [];
    while (length) {
      items.push(take());
    }
    return items;
  };

  return {
    isEmpty: function isEmpty() {
      return length == 0;
    },
    put: function put(it) {
      if (length < limit) {
        push(it);
      } else {
        var doubledLimit = void 0;
        switch (overflowAction) {
          case ON_OVERFLOW_THROW:
            throw new Error(BUFFER_OVERFLOW);
          case ON_OVERFLOW_SLIDE:
            arr[pushIndex] = it;
            pushIndex = (pushIndex + 1) % limit;
            popIndex = pushIndex;
            break;
          case ON_OVERFLOW_EXPAND:
            doubledLimit = 2 * limit;

            arr = flush();

            length = arr.length;
            pushIndex = arr.length;
            popIndex = 0;

            arr.length = doubledLimit;
            limit = doubledLimit;

            push(it);
            break;
          default:
          // DROP
        }
      }
    },
    take: take, flush: flush
  };
}

var buffers = exports.buffers = {
  none: function none() {
    return zeroBuffer;
  },
  fixed: function fixed(limit) {
    return ringBuffer(limit, ON_OVERFLOW_THROW);
  },
  dropping: function dropping(limit) {
    return ringBuffer(limit, ON_OVERFLOW_DROP);
  },
  sliding: function sliding(limit) {
    return ringBuffer(limit, ON_OVERFLOW_SLIDE);
  },
  expanding: function expanding(initialSize) {
    return ringBuffer(initialSize, ON_OVERFLOW_EXPAND);
  }
};
},{"./utils":150}],144:[function(require,module,exports){
(function (process){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.UNDEFINED_INPUT_ERROR = exports.INVALID_BUFFER = exports.isEnd = exports.END = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.emitter = emitter;
exports.channel = channel;
exports.eventChannel = eventChannel;
exports.stdChannel = stdChannel;

var _utils = require('./utils');

var _buffers = require('./buffers');

var CHANNEL_END_TYPE = '@@redux-saga/CHANNEL_END';
var END = exports.END = { type: CHANNEL_END_TYPE };
var isEnd = exports.isEnd = function isEnd(a) {
  return a && a.type === CHANNEL_END_TYPE;
};

function emitter() {
  var subscribers = [];

  function subscribe(sub) {
    subscribers.push(sub);
    return function () {
      return (0, _utils.remove)(subscribers, sub);
    };
  }

  function emit(item) {
    var arr = subscribers.slice();
    for (var i = 0, len = arr.length; i < len; i++) {
      arr[i](item);
    }
  }

  return {
    subscribe: subscribe,
    emit: emit
  };
}

var INVALID_BUFFER = exports.INVALID_BUFFER = 'invalid buffer passed to channel factory function';
var UNDEFINED_INPUT_ERROR = exports.UNDEFINED_INPUT_ERROR = 'Saga was provided with an undefined action';

if (process.env.NODE_ENV !== 'production') {
  exports.UNDEFINED_INPUT_ERROR = UNDEFINED_INPUT_ERROR += '\nHints:\n    - check that your Action Creator returns a non-undefined value\n    - if the Saga was started using runSaga, check that your subscribe source provides the action to its listeners\n  ';
}

function channel() {
  var buffer = arguments.length <= 0 || arguments[0] === undefined ? _buffers.buffers.fixed() : arguments[0];

  var closed = false;
  var takers = [];

  (0, _utils.check)(buffer, _utils.is.buffer, INVALID_BUFFER);

  function checkForbiddenStates() {
    if (closed && takers.length) {
      throw (0, _utils.internalErr)('Cannot have a closed channel with pending takers');
    }
    if (takers.length && !buffer.isEmpty()) {
      throw (0, _utils.internalErr)('Cannot have pending takers with non empty buffer');
    }
  }

  function put(input) {
    checkForbiddenStates();
    (0, _utils.check)(input, _utils.is.notUndef, UNDEFINED_INPUT_ERROR);
    if (closed) {
      return;
    }
    if (!takers.length) {
      return buffer.put(input);
    }
    for (var i = 0; i < takers.length; i++) {
      var cb = takers[i];
      if (!cb[_utils.MATCH] || cb[_utils.MATCH](input)) {
        takers.splice(i, 1);
        return cb(input);
      }
    }
  }

  function take(cb) {
    checkForbiddenStates();
    (0, _utils.check)(cb, _utils.is.func, 'channel.take\'s callback must be a function');

    if (closed && buffer.isEmpty()) {
      cb(END);
    } else if (!buffer.isEmpty()) {
      cb(buffer.take());
    } else {
      takers.push(cb);
      cb.cancel = function () {
        return (0, _utils.remove)(takers, cb);
      };
    }
  }

  function flush(cb) {
    checkForbiddenStates(); // TODO: check if some new state should be forbidden now
    (0, _utils.check)(cb, _utils.is.func, 'channel.flush\' callback must be a function');
    if (closed && buffer.isEmpty()) {
      cb(END);
      return;
    }
    cb(buffer.flush());
  }

  function close() {
    checkForbiddenStates();
    if (!closed) {
      closed = true;
      if (takers.length) {
        var arr = takers;
        takers = [];
        for (var i = 0, len = arr.length; i < len; i++) {
          arr[i](END);
        }
      }
    }
  }

  return { take: take, put: put, flush: flush, close: close,
    get __takers__() {
      return takers;
    },
    get __closed__() {
      return closed;
    }
  };
}

function eventChannel(subscribe) {
  var buffer = arguments.length <= 1 || arguments[1] === undefined ? _buffers.buffers.none() : arguments[1];
  var matcher = arguments[2];

  /**
    should be if(typeof matcher !== undefined) instead?
    see PR #273 for a background discussion
  **/
  if (arguments.length > 2) {
    (0, _utils.check)(matcher, _utils.is.func, 'Invalid match function passed to eventChannel');
  }

  var chan = channel(buffer);
  var unsubscribe = subscribe(function (input) {
    if (isEnd(input)) {
      chan.close();
    } else if (!matcher || matcher(input)) {
      chan.put(input);
    }
  });

  if (!_utils.is.func(unsubscribe)) {
    throw new Error('in eventChannel: subscribe should return a function to unsubscribe');
  }

  return {
    take: chan.take,
    flush: chan.flush,
    close: function close() {
      if (!chan.__closed__) {
        chan.close();
        unsubscribe();
      }
    }
  };
}

function stdChannel(subscribe) {
  var chan = eventChannel(subscribe);

  return _extends({}, chan, {
    take: function take(cb, matcher) {
      if (arguments.length > 1) {
        (0, _utils.check)(matcher, _utils.is.func, 'channel.take\'s matcher argument must be a function');
        cb[_utils.MATCH] = matcher;
      }
      chan.take(cb);
    }
  });
}
}).call(this,require('_process'))

},{"./buffers":143,"./utils":150,"_process":138}],145:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.asEffect = undefined;

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

exports.take = take;
exports.takem = takem;
exports.put = put;
exports.race = race;
exports.call = call;
exports.apply = apply;
exports.cps = cps;
exports.fork = fork;
exports.spawn = spawn;
exports.join = join;
exports.cancel = cancel;
exports.select = select;
exports.actionChannel = actionChannel;
exports.cancelled = cancelled;
exports.flush = flush;

var _utils = require('./utils');

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var IO = (0, _utils.sym)('IO');
var TAKE = 'TAKE';
var PUT = 'PUT';
var RACE = 'RACE';
var CALL = 'CALL';
var CPS = 'CPS';
var FORK = 'FORK';
var JOIN = 'JOIN';
var CANCEL = 'CANCEL';
var SELECT = 'SELECT';
var ACTION_CHANNEL = 'ACTION_CHANNEL';
var CANCELLED = 'CANCELLED';
var FLUSH = 'FLUSH';

var effect = function effect(type, payload) {
  var _ref;

  return _ref = {}, _defineProperty(_ref, IO, true), _defineProperty(_ref, type, payload), _ref;
};

function take() {
  var patternOrChannel = arguments.length <= 0 || arguments[0] === undefined ? '*' : arguments[0];

  if (arguments.length) {
    (0, _utils.check)(arguments[0], _utils.is.notUndef, 'take(patternOrChannel): patternOrChannel is undefined');
  }
  if (_utils.is.pattern(patternOrChannel)) {
    return effect(TAKE, { pattern: patternOrChannel });
  }
  if (_utils.is.channel(patternOrChannel)) {
    return effect(TAKE, { channel: patternOrChannel });
  }
  throw new Error('take(patternOrChannel): argument ' + String(patternOrChannel) + ' is not valid channel or a valid pattern');
}

function takem() {
  var eff = take.apply(undefined, arguments);
  eff[TAKE].maybe = true;
  return eff;
}

function put(channel, action) {
  if (arguments.length > 1) {
    (0, _utils.check)(channel, _utils.is.notUndef, 'put(channel, action): argument channel is undefined');
    (0, _utils.check)(channel, _utils.is.channel, 'put(channel, action): argument ' + channel + ' is not a valid channel');
    (0, _utils.check)(action, _utils.is.notUndef, 'put(channel, action): argument action is undefined');
  } else {
    (0, _utils.check)(channel, _utils.is.notUndef, 'put(action): argument action is undefined');
    action = channel;
    channel = null;
  }
  return effect(PUT, { channel: channel, action: action });
}

put.sync = function () {
  var eff = put.apply(undefined, arguments);
  eff[PUT].sync = true;
  return eff;
};

function race(effects) {
  return effect(RACE, effects);
}

function getFnCallDesc(meth, fn, args) {
  (0, _utils.check)(fn, _utils.is.notUndef, meth + ': argument fn is undefined');

  var context = null;
  if (_utils.is.array(fn)) {
    var _fn = fn;

    var _fn2 = _slicedToArray(_fn, 2);

    context = _fn2[0];
    fn = _fn2[1];
  } else if (fn.fn) {
    var _fn3 = fn;
    context = _fn3.context;
    fn = _fn3.fn;
  }
  (0, _utils.check)(fn, _utils.is.func, meth + ': argument ' + fn + ' is not a function');

  return { context: context, fn: fn, args: args };
}

function call(fn) {
  for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    args[_key - 1] = arguments[_key];
  }

  return effect(CALL, getFnCallDesc('call', fn, args));
}

function apply(context, fn) {
  var args = arguments.length <= 2 || arguments[2] === undefined ? [] : arguments[2];

  return effect(CALL, getFnCallDesc('apply', { context: context, fn: fn }, args));
}

function cps(fn) {
  for (var _len2 = arguments.length, args = Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
    args[_key2 - 1] = arguments[_key2];
  }

  return effect(CPS, getFnCallDesc('cps', fn, args));
}

function fork(fn) {
  for (var _len3 = arguments.length, args = Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++) {
    args[_key3 - 1] = arguments[_key3];
  }

  return effect(FORK, getFnCallDesc('fork', fn, args));
}

function spawn(fn) {
  for (var _len4 = arguments.length, args = Array(_len4 > 1 ? _len4 - 1 : 0), _key4 = 1; _key4 < _len4; _key4++) {
    args[_key4 - 1] = arguments[_key4];
  }

  var eff = fork.apply(undefined, [fn].concat(args));
  eff[FORK].detached = true;
  return eff;
}

var isForkedTask = function isForkedTask(task) {
  return task[_utils.TASK];
};

function join(task) {
  (0, _utils.check)(task, _utils.is.notUndef, 'join(task): argument task is undefined');
  if (!isForkedTask(task)) {
    throw new Error('join(task): argument ' + task + ' is not a valid Task object \n(HINT: if you are getting this errors in tests, consider using createMockTask from redux-saga/utils)');
  }

  return effect(JOIN, task);
}

function cancel(task) {
  (0, _utils.check)(task, _utils.is.notUndef, 'cancel(task): argument task is undefined');
  if (!isForkedTask(task)) {
    throw new Error('cancel(task): argument ' + task + ' is not a valid Task object \n(HINT: if you are getting this errors in tests, consider using createMockTask from redux-saga/utils)');
  }

  return effect(CANCEL, task);
}

function select(selector) {
  for (var _len5 = arguments.length, args = Array(_len5 > 1 ? _len5 - 1 : 0), _key5 = 1; _key5 < _len5; _key5++) {
    args[_key5 - 1] = arguments[_key5];
  }

  if (arguments.length === 0) {
    selector = _utils.ident;
  } else {
    (0, _utils.check)(selector, _utils.is.notUndef, 'select(selector,[...]): argument selector is undefined');
    (0, _utils.check)(selector, _utils.is.func, 'select(selector,[...]): argument ' + selector + ' is not a function');
  }
  return effect(SELECT, { selector: selector, args: args });
}

/**
  channel(pattern, [buffer])    => creates an event channel for store actions
**/
function actionChannel(pattern, buffer) {
  (0, _utils.check)(pattern, _utils.is.notUndef, 'actionChannel(pattern,...): argument pattern is undefined');
  if (arguments.length > 1) {
    (0, _utils.check)(buffer, _utils.is.notUndef, 'actionChannel(pattern, buffer): argument buffer is undefined');
    (0, _utils.check)(buffer, _utils.is.notUndef, 'actionChannel(pattern, buffer): argument ' + buffer + ' is not a valid buffer');
  }
  return effect(ACTION_CHANNEL, { pattern: pattern, buffer: buffer });
}

function cancelled() {
  return effect(CANCELLED, {});
}

function flush(channel) {
  (0, _utils.check)(channel, _utils.is.channel, 'flush(channel): argument ' + channel + ' is not valid channel');
  return effect(FLUSH, channel);
}

var asEffect = exports.asEffect = {
  take: function take(effect) {
    return effect && effect[IO] && effect[TAKE];
  },
  put: function put(effect) {
    return effect && effect[IO] && effect[PUT];
  },
  race: function race(effect) {
    return effect && effect[IO] && effect[RACE];
  },
  call: function call(effect) {
    return effect && effect[IO] && effect[CALL];
  },
  cps: function cps(effect) {
    return effect && effect[IO] && effect[CPS];
  },
  fork: function fork(effect) {
    return effect && effect[IO] && effect[FORK];
  },
  join: function join(effect) {
    return effect && effect[IO] && effect[JOIN];
  },
  cancel: function cancel(effect) {
    return effect && effect[IO] && effect[CANCEL];
  },
  select: function select(effect) {
    return effect && effect[IO] && effect[SELECT];
  },
  actionChannel: function actionChannel(effect) {
    return effect && effect[IO] && effect[ACTION_CHANNEL];
  },
  cancelled: function cancelled(effect) {
    return effect && effect[IO] && effect[CANCELLED];
  },
  flush: function flush(effect) {
    return effect && effect[IO] && effect[FLUSH];
  }
};
},{"./utils":150}],146:[function(require,module,exports){
(function (process){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = sagaMiddlewareFactory;

var _utils = require('./utils');

var _proc = require('./proc');

var _proc2 = _interopRequireDefault(_proc);

var _channel = require('./channel');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function sagaMiddlewareFactory() {
  var options = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];

  var runSagaDynamically = void 0;

  if (_utils.is.func(options)) {
    if (process.env.NODE_ENV === 'production') {
      throw new Error('Saga middleware no longer accept Generator functions. Use sagaMiddleware.run instead');
    } else {
      throw new Error('You passed a function to the Saga middleware. You are likely trying to start a        Saga by directly passing it to the middleware. This is no longer possible starting from 0.10.0.        To run a Saga, you must do it dynamically AFTER mounting the middleware into the store.\n        Example:\n          import createSagaMiddleware from \'redux-saga\'\n          ... other imports\n\n          const sagaMiddleware = createSagaMiddleware()\n          const store = createStore(reducer, applyMiddleware(sagaMiddleware))\n          sagaMiddleware.run(saga, ...args)\n      ');
    }
  }

  if (options.logger && !_utils.is.func(options.logger)) {
    throw new Error('`options.logger` passed to the Saga middleware is not a function!');
  }

  if (options.onerror && !_utils.is.func(options.onerror)) {
    throw new Error('`options.onerror` passed to the Saga middleware is not a function!');
  }

  function sagaMiddleware(_ref) {
    var getState = _ref.getState;
    var dispatch = _ref.dispatch;

    runSagaDynamically = runSaga;
    var sagaEmitter = (0, _channel.emitter)();

    function runSaga(saga) {
      for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        args[_key - 1] = arguments[_key];
      }

      return (0, _proc2.default)(saga.apply(undefined, args), sagaEmitter.subscribe, dispatch, getState, options, 0, saga.name);
    }

    return function (next) {
      return function (action) {
        var result = next(action); // hit reducers
        sagaEmitter.emit(action);
        return result;
      };
    };
  }

  sagaMiddleware.run = function (saga) {
    for (var _len2 = arguments.length, args = Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
      args[_key2 - 1] = arguments[_key2];
    }

    (0, _utils.check)(runSagaDynamically, _utils.is.notUndef, 'Before running a Saga, you must mount the Saga middleware on the Store using applyMiddleware');
    (0, _utils.check)(saga, _utils.is.func, 'sagaMiddleware.run(saga, ...args): saga argument must be a Generator function!');
    return runSagaDynamically.apply(undefined, [saga].concat(args));
  };

  return sagaMiddleware;
}
}).call(this,require('_process'))

},{"./channel":144,"./proc":147,"./utils":150,"_process":138}],147:[function(require,module,exports){
(function (process){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TASK_CANCEL = exports.CHANNEL_END = exports.NOT_ITERATOR_ERROR = undefined;
exports.default = proc;

var _utils = require('./utils');

var _asap = require('./asap');

var _asap2 = _interopRequireDefault(_asap);

var _io = require('./io');

var _channel = require('./channel');

var _buffers = require('./buffers');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineEnumerableProperties(obj, descs) { for (var key in descs) { var desc = descs[key]; desc.configurable = desc.enumerable = true; if ("value" in desc) desc.writable = true; Object.defineProperty(obj, key, desc); } return obj; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var isDev = process.env.NODE_ENV === 'development';

var NOT_ITERATOR_ERROR = exports.NOT_ITERATOR_ERROR = 'proc first argument (Saga function result) must be an iterator';

var nextEffectId = (0, _utils.autoInc)();
var CHANNEL_END = exports.CHANNEL_END = {
  toString: function toString() {
    return '@@redux-saga/CHANNEL_END';
  }
};
var TASK_CANCEL = exports.TASK_CANCEL = {
  toString: function toString() {
    return '@@redux-saga/TASK_CANCEL';
  }
};

var matchers = {
  wildcard: function wildcard() {
    return _utils.kTrue;
  },
  default: function _default(pattern) {
    return function (input) {
      return input.type === pattern;
    };
  },
  array: function array(patterns) {
    return function (input) {
      return patterns.some(function (p) {
        return p === input.type;
      });
    };
  },
  predicate: function predicate(_predicate) {
    return function (input) {
      return _predicate(input);
    };
  }
};

function matcher(pattern) {
  return (pattern === '*' ? matchers.wildcard : _utils.is.array(pattern) ? matchers.array : _utils.is.func(pattern) ? matchers.predicate : matchers.default)(pattern);
}

/**
  Used to track a parent task and its forks
  In the new fork model, forked tasks are attached by default to their parent
  We model this using the concept of Parent task && main Task
  main task is the main flow of the current Generator, the parent tasks is the
  aggregation of the main tasks + all its forked tasks.
  Thus the whole model represents an execution tree with multiple branches (vs the
  linear execution tree in sequential (non parallel) programming)

  A parent tasks has the following semantics
  - It completes iff all its forks either complete or all cancelled
  - If it's cancelled, all forks are cancelled as well
  - It aborts if any uncaught error bubbles up from forks
  - If it completes, the return value is the one returned by the main task
**/
function forkQueue(name, mainTask, cb) {
  var tasks = [],
      result = void 0,
      completed = false;
  addTask(mainTask);

  function abort(err) {
    cancelAll();
    cb(err, true);
  }

  function addTask(task) {
    tasks.push(task);
    task.cont = function (res, isErr) {
      if (completed) {
        return;
      }

      (0, _utils.remove)(tasks, task);
      task.cont = _utils.noop;
      if (isErr) {
        abort(res);
      } else {
        if (task === mainTask) {
          result = res;
        }
        if (!tasks.length) {
          completed = true;
          cb(result);
        }
      }
    };
    // task.cont.cancel = task.cancel
  }

  function cancelAll() {
    if (completed) {
      return;
    }
    completed = true;
    tasks.forEach(function (t) {
      t.cont = _utils.noop;
      t.cancel();
    });
    tasks = [];
  }

  return {
    addTask: addTask,
    cancelAll: cancelAll,
    abort: abort,
    getTasks: function getTasks() {
      return tasks;
    },
    taskNames: function taskNames() {
      return tasks.map(function (t) {
        return t.name;
      });
    }
  };
}

function createTaskIterator(_ref) {
  var context = _ref.context;
  var fn = _ref.fn;
  var args = _ref.args;

  if (_utils.is.iterator(fn)) {
    return fn;
  }

  // catch synchronous failures; see #152 and #441
  var result = void 0,
      error = void 0;
  try {
    result = fn.apply(context, args);
  } catch (err) {
    error = err;
  }

  // i.e. a generator function returns an iterator
  if (_utils.is.iterator(result)) {
    return result;
  }

  // do not bubble up synchronous failures for detached forks
  // instead create a failed task. See #152 and #441
  return error ? (0, _utils.makeIterator)(function () {
    throw error;
  }) : (0, _utils.makeIterator)(function () {
    var pc = void 0;
    var eff = { done: false, value: result };
    var ret = function ret(value) {
      return { done: true, value: value };
    };
    return function (arg) {
      if (!pc) {
        pc = true;
        return eff;
      } else {
        return ret(arg);
      }
    };
  }());
}

function wrapHelper(helper) {
  return {
    fn: helper
  };
}

function proc(iterator) {
  var subscribe = arguments.length <= 1 || arguments[1] === undefined ? function () {
    return _utils.noop;
  } : arguments[1];
  var dispatch = arguments.length <= 2 || arguments[2] === undefined ? _utils.noop : arguments[2];
  var getState = arguments.length <= 3 || arguments[3] === undefined ? _utils.noop : arguments[3];
  var options = arguments.length <= 4 || arguments[4] === undefined ? {} : arguments[4];
  var parentEffectId = arguments.length <= 5 || arguments[5] === undefined ? 0 : arguments[5];
  var name = arguments.length <= 6 || arguments[6] === undefined ? 'anonymous' : arguments[6];
  var cont = arguments[7];

  (0, _utils.check)(iterator, _utils.is.iterator, NOT_ITERATOR_ERROR);

  var sagaMonitor = options.sagaMonitor;
  var logger = options.logger;
  var onError = options.onError;

  var log = logger || _utils.log;
  var stdChannel = (0, _channel.stdChannel)(subscribe);
  /**
    Tracks the current effect cancellation
    Each time the generator progresses. calling runEffect will set a new value
    on it. It allows propagating cancellation to child effects
  **/
  next.cancel = _utils.noop;

  /**
    Creates a new task descriptor for this generator, We'll also create a main task
    to track the main flow (besides other forked tasks)
  **/
  var task = newTask(parentEffectId, name, iterator, cont);
  var mainTask = { name: name, cancel: cancelMain, isRunning: true };
  var taskQueue = forkQueue(name, mainTask, end);

  /**
    cancellation of the main task. We'll simply resume the Generator with a Cancel
  **/
  function cancelMain() {
    if (mainTask.isRunning && !mainTask.isCancelled) {
      mainTask.isCancelled = true;
      next(TASK_CANCEL);
    }
  }

  /**
    This may be called by a parent generator to trigger/propagate cancellation
    cancel all pending tasks (including the main task), then end the current task.
     Cancellation propagates down to the whole execution tree holded by this Parent task
    It's also propagated to all joiners of this task and their execution tree/joiners
     Cancellation is noop for terminated/Cancelled tasks tasks
  **/
  function cancel() {
    /**
      We need to check both Running and Cancelled status
      Tasks can be Cancelled but still Running
    **/
    if (iterator._isRunning && !iterator._isCancelled) {
      iterator._isCancelled = true;
      taskQueue.cancelAll();
      /**
        Ending with a Never result will propagate the Cancellation to all joiners
      **/
      end(TASK_CANCEL);
    }
  }
  /**
    attaches cancellation logic to this task's continuation
    this will permit cancellation to propagate down the call chain
  **/
  cont && (cont.cancel = cancel);

  // tracks the running status
  iterator._isRunning = true;

  // kicks up the generator
  next();

  // then return the task descriptor to the caller
  return task;

  /**
    This is the generator driver
    It's a recursive async/continuation function which calls itself
    until the generator terminates or throws
  **/
  function next(arg, isErr) {
    // Preventive measure. If we end up here, then there is really something wrong
    if (!mainTask.isRunning) {
      throw new Error('Trying to resume an already finished generator');
    }

    try {
      var result = void 0;
      if (isErr) {
        result = iterator.throw(arg);
      } else if (arg === TASK_CANCEL) {
        /**
          getting TASK_CANCEL autoamtically cancels the main task
          We can get this value here
           - By cancelling the parent task manually
          - By joining a Cancelled task
        **/
        mainTask.isCancelled = true;
        /**
          Cancels the current effect; this will propagate the cancellation down to any called tasks
        **/
        next.cancel();
        /**
          If this Generator has a `return` method then invokes it
          Thill will jump to the finally block
        **/
        result = _utils.is.func(iterator.return) ? iterator.return(TASK_CANCEL) : { done: true, value: TASK_CANCEL };
      } else if (arg === CHANNEL_END) {
        // We get CHANNEL_END by taking from a channel that ended using `take` (and not `takem` used to trap End of channels)
        result = _utils.is.func(iterator.return) ? iterator.return() : { done: true };
      } else {
        result = iterator.next(arg);
      }

      if (!result.done) {
        runEffect(result.value, parentEffectId, '', next);
      } else {
        /**
          This Generator has ended, terminate the main task and notify the fork queue
        **/
        mainTask.isMainRunning = false;
        mainTask.cont && mainTask.cont(result.value);
      }
    } catch (error) {
      if (mainTask.isCancelled) {
        log('error', 'uncaught at ' + name, error.message);
      }
      mainTask.isMainRunning = false;
      mainTask.cont(error, true);
    }
  }

  function end(result, isErr) {
    iterator._isRunning = false;
    stdChannel.close();
    if (!isErr) {
      if (result === TASK_CANCEL && isDev) {
        log('info', name + ' has been cancelled', '');
      }
      iterator._result = result;
      iterator._deferredEnd && iterator._deferredEnd.resolve(result);
    } else {
      if (result instanceof Error) {
        result.sagaStack = 'at ' + name + ' \n ' + (result.sagaStack || result.stack);
      }
      if (!task.cont) {
        log('error', 'uncaught', result.sagaStack || result.stack);
        if (result instanceof Error && onError) {
          onError(result);
        }
      }
      iterator._error = result;
      iterator._isAborted = true;
      iterator._deferredEnd && iterator._deferredEnd.reject(result);
    }
    task.cont && task.cont(result, isErr);
    task.joiners.forEach(function (j) {
      return j.cb(result, isErr);
    });
    task.joiners = null;
  }

  function runEffect(effect, parentEffectId) {
    var label = arguments.length <= 2 || arguments[2] === undefined ? '' : arguments[2];
    var cb = arguments[3];

    var effectId = nextEffectId();
    sagaMonitor && sagaMonitor.effectTriggered({ effectId: effectId, parentEffectId: parentEffectId, label: label, effect: effect });

    /**
      completion callback and cancel callback are mutually exclusive
      We can't cancel an already completed effect
      And We can't complete an already cancelled effectId
    **/
    var effectSettled = void 0;

    // Completion callback passed to the appropriate effect runner
    function currCb(res, isErr) {
      if (effectSettled) {
        return;
      }

      effectSettled = true;
      cb.cancel = _utils.noop; // defensive measure
      if (sagaMonitor) {
        isErr ? sagaMonitor.effectRejected(effectId, res) : sagaMonitor.effectResolved(effectId, res);
      }

      cb(res, isErr);
    }
    // tracks down the current cancel
    currCb.cancel = _utils.noop;

    // setup cancellation logic on the parent cb
    cb.cancel = function () {
      // prevents cancelling an already completed effect
      if (effectSettled) {
        return;
      }

      effectSettled = true;
      /**
        propagates cancel downward
        catch uncaught cancellations errors; since we can no longer call the completion
        callback, log errors raised during cancellations into the console
      **/
      try {
        currCb.cancel();
      } catch (err) {
        log('error', 'uncaught at ' + name, err.message);
      }
      currCb.cancel = _utils.noop; // defensive measure

      sagaMonitor && sagaMonitor.effectCancelled(effectId);
    };

    /**
      each effect runner must attach its own logic of cancellation to the provided callback
      it allows this generator to propagate cancellation downward.
       ATTENTION! effect runners must setup the cancel logic by setting cb.cancel = [cancelMethod]
      And the setup must occur before calling the callback
       This is a sort of inversion of control: called async functions are responsible
      of completing the flow by calling the provided continuation; while caller functions
      are responsible for aborting the current flow by calling the attached cancel function
       Library users can attach their own cancellation logic to promises by defining a
      promise[CANCEL] method in their returned promises
      ATTENTION! calling cancel must have no effect on an already completed or cancelled effect
    **/
    var data = void 0;
    return (
      // Non declarative effect
      _utils.is.promise(effect) ? resolvePromise(effect, currCb) : _utils.is.helper(effect) ? runForkEffect(wrapHelper(effect), effectId, currCb) : _utils.is.iterator(effect) ? resolveIterator(effect, effectId, name, currCb)

      // declarative effects
      : _utils.is.array(effect) ? runParallelEffect(effect, effectId, currCb) : _utils.is.notUndef(data = _io.asEffect.take(effect)) ? runTakeEffect(data, currCb) : _utils.is.notUndef(data = _io.asEffect.put(effect)) ? runPutEffect(data, currCb) : _utils.is.notUndef(data = _io.asEffect.race(effect)) ? runRaceEffect(data, effectId, currCb) : _utils.is.notUndef(data = _io.asEffect.call(effect)) ? runCallEffect(data, effectId, currCb) : _utils.is.notUndef(data = _io.asEffect.cps(effect)) ? runCPSEffect(data, currCb) : _utils.is.notUndef(data = _io.asEffect.fork(effect)) ? runForkEffect(data, effectId, currCb) : _utils.is.notUndef(data = _io.asEffect.join(effect)) ? runJoinEffect(data, currCb) : _utils.is.notUndef(data = _io.asEffect.cancel(effect)) ? runCancelEffect(data, currCb) : _utils.is.notUndef(data = _io.asEffect.select(effect)) ? runSelectEffect(data, currCb) : _utils.is.notUndef(data = _io.asEffect.actionChannel(effect)) ? runChannelEffect(data, currCb) : _utils.is.notUndef(data = _io.asEffect.flush(effect)) ? runFlushEffect(data, currCb) : _utils.is.notUndef(data = _io.asEffect.cancelled(effect)) ? runCancelledEffect(data, currCb) : /* anything else returned as is        */currCb(effect)
    );
  }

  function resolvePromise(promise, cb) {
    var cancelPromise = promise[_utils.CANCEL];
    if (typeof cancelPromise === 'function') {
      cb.cancel = cancelPromise;
    }
    promise.then(cb, function (error) {
      return cb(error, true);
    });
  }

  function resolveIterator(iterator, effectId, name, cb) {
    proc(iterator, subscribe, dispatch, getState, options, effectId, name, cb);
  }

  function runTakeEffect(_ref2, cb) {
    var channel = _ref2.channel;
    var pattern = _ref2.pattern;
    var maybe = _ref2.maybe;

    channel = channel || stdChannel;
    var takeCb = function takeCb(inp) {
      return inp instanceof Error ? cb(inp, true) : (0, _channel.isEnd)(inp) && !maybe ? cb(CHANNEL_END) : cb(inp);
    };
    try {
      channel.take(takeCb, matcher(pattern));
    } catch (err) {
      return cb(err, true);
    }
    cb.cancel = takeCb.cancel;
  }

  function runPutEffect(_ref3, cb) {
    var channel = _ref3.channel;
    var action = _ref3.action;
    var sync = _ref3.sync;

    /*
      Use a reentrant lock `asap` to flatten all nested dispatches
      If this put cause another Saga to take this action an then immediately
      put an action that will be taken by this Saga. Then the outer Saga will miss
      the action from the inner Saga b/c this put has not yet returned.
    */
    (0, _asap2.default)(function () {
      var result = void 0;
      try {
        result = (channel ? channel.put : dispatch)(action);
      } catch (error) {
        // If we have a channel or `put.sync` was used then bubble up the error.
        if (channel || sync) return cb(error, true);
        log('error', 'uncaught at ' + name, error.stack || error.message || error);
      }

      if (sync && _utils.is.promise(result)) {
        resolvePromise(result, cb);
      } else {
        return cb(result);
      }
    });
    // Put effects are non cancellables
  }

  function runCallEffect(_ref4, effectId, cb) {
    var context = _ref4.context;
    var fn = _ref4.fn;
    var args = _ref4.args;

    var result = void 0;
    // catch synchronous failures; see #152
    try {
      result = fn.apply(context, args);
    } catch (error) {
      return cb(error, true);
    }
    return _utils.is.promise(result) ? resolvePromise(result, cb) : _utils.is.iterator(result) ? resolveIterator(result, effectId, fn.name, cb) : cb(result);
  }

  function runCPSEffect(_ref5, cb) {
    var context = _ref5.context;
    var fn = _ref5.fn;
    var args = _ref5.args;

    // CPS (ie node style functions) can define their own cancellation logic
    // by setting cancel field on the cb

    // catch synchronous failures; see #152
    try {
      (function () {
        var cpsCb = function cpsCb(err, res) {
          return _utils.is.undef(err) ? cb(res) : cb(err, true);
        };
        fn.apply(context, args.concat(cpsCb));
        if (cpsCb.cancel) {
          cb.cancel = function () {
            return cpsCb.cancel();
          };
        }
      })();
    } catch (error) {
      return cb(error, true);
    }
  }

  function runForkEffect(_ref6, effectId, cb) {
    var context = _ref6.context;
    var fn = _ref6.fn;
    var args = _ref6.args;
    var detached = _ref6.detached;

    var taskIterator = createTaskIterator({ context: context, fn: fn, args: args });

    _asap2.default.suspend();
    var task = proc(taskIterator, subscribe, dispatch, getState, options, effectId, fn.name, detached ? null : _utils.noop);

    if (detached) {
      cb(task);
    } else {
      if (taskIterator._isRunning) {
        taskQueue.addTask(task);
        cb(task);
      } else if (taskIterator._error) {
        taskQueue.abort(taskIterator._error);
      } else {
        cb(task);
      }
    }
    _asap2.default.flush();
    // Fork effects are non cancellables
  }

  function runJoinEffect(t, cb) {
    if (t.isRunning()) {
      (function () {
        var joiner = { task: task, cb: cb };
        cb.cancel = function () {
          return (0, _utils.remove)(t.joiners, joiner);
        };
        t.joiners.push(joiner);
      })();
    } else {
      t.isAborted() ? cb(t.error(), true) : cb(t.result());
    }
  }

  function runCancelEffect(task, cb) {
    if (task.isRunning()) {
      task.cancel();
    }
    cb();
    // cancel effects are non cancellables
  }

  function runParallelEffect(effects, effectId, cb) {
    if (!effects.length) {
      return cb([]);
    }

    var completedCount = 0;
    var completed = void 0;
    var results = Array(effects.length);

    function checkEffectEnd() {
      if (completedCount === results.length) {
        completed = true;
        cb(results);
      }
    }

    var childCbs = effects.map(function (eff, idx) {
      var chCbAtIdx = function chCbAtIdx(res, isErr) {
        if (completed) {
          return;
        }
        if (isErr || (0, _channel.isEnd)(res) || res === CHANNEL_END || res === TASK_CANCEL) {
          cb.cancel();
          cb(res, isErr);
        } else {
          results[idx] = res;
          completedCount++;
          checkEffectEnd();
        }
      };
      chCbAtIdx.cancel = _utils.noop;
      return chCbAtIdx;
    });

    cb.cancel = function () {
      if (!completed) {
        completed = true;
        childCbs.forEach(function (chCb) {
          return chCb.cancel();
        });
      }
    };

    effects.forEach(function (eff, idx) {
      return runEffect(eff, effectId, idx, childCbs[idx]);
    });
  }

  function runRaceEffect(effects, effectId, cb) {
    var completed = void 0;
    var keys = Object.keys(effects);
    var childCbs = {};

    keys.forEach(function (key) {
      var chCbAtKey = function chCbAtKey(res, isErr) {
        if (completed) {
          return;
        }

        if (isErr) {
          // Race Auto cancellation
          cb.cancel();
          cb(res, true);
        } else if (!(0, _channel.isEnd)(res) && res !== CHANNEL_END && res !== TASK_CANCEL) {
          cb.cancel();
          completed = true;
          cb(_defineProperty({}, key, res));
        }
      };
      chCbAtKey.cancel = _utils.noop;
      childCbs[key] = chCbAtKey;
    });

    cb.cancel = function () {
      // prevents unnecessary cancellation
      if (!completed) {
        completed = true;
        keys.forEach(function (key) {
          return childCbs[key].cancel();
        });
      }
    };
    keys.forEach(function (key) {
      if (completed) {
        return;
      }
      runEffect(effects[key], effectId, key, childCbs[key]);
    });
  }

  function runSelectEffect(_ref7, cb) {
    var selector = _ref7.selector;
    var args = _ref7.args;

    try {
      var state = selector.apply(undefined, [getState()].concat(_toConsumableArray(args)));
      cb(state);
    } catch (error) {
      cb(error, true);
    }
  }

  function runChannelEffect(_ref8, cb) {
    var pattern = _ref8.pattern;
    var buffer = _ref8.buffer;

    var match = matcher(pattern);
    match.pattern = pattern;
    cb((0, _channel.eventChannel)(subscribe, buffer || _buffers.buffers.fixed(), match));
  }

  function runCancelledEffect(data, cb) {
    cb(!!mainTask.isCancelled);
  }

  function runFlushEffect(channel, cb) {
    channel.flush(cb);
  }

  function newTask(id, name, iterator, cont) {
    var _done, _ref9, _mutatorMap;

    iterator._deferredEnd = null;
    return _ref9 = {}, _defineProperty(_ref9, _utils.TASK, true), _defineProperty(_ref9, 'id', id), _defineProperty(_ref9, 'name', name), _done = 'done', _mutatorMap = {}, _mutatorMap[_done] = _mutatorMap[_done] || {}, _mutatorMap[_done].get = function () {
      if (iterator._deferredEnd) {
        return iterator._deferredEnd.promise;
      } else {
        var def = (0, _utils.deferred)();
        iterator._deferredEnd = def;
        if (!iterator._isRunning) {
          iterator._error ? def.reject(iterator._error) : def.resolve(iterator._result);
        }
        return def.promise;
      }
    }, _defineProperty(_ref9, 'cont', cont), _defineProperty(_ref9, 'joiners', []), _defineProperty(_ref9, 'cancel', cancel), _defineProperty(_ref9, 'isRunning', function isRunning() {
      return iterator._isRunning;
    }), _defineProperty(_ref9, 'isCancelled', function isCancelled() {
      return iterator._isCancelled;
    }), _defineProperty(_ref9, 'isAborted', function isAborted() {
      return iterator._isAborted;
    }), _defineProperty(_ref9, 'result', function result() {
      return iterator._result;
    }), _defineProperty(_ref9, 'error', function error() {
      return iterator._error;
    }), _defineEnumerableProperties(_ref9, _mutatorMap), _ref9;
  }
}
}).call(this,require('_process'))

},{"./asap":142,"./buffers":143,"./channel":144,"./io":145,"./utils":150,"_process":138}],148:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.runSaga = runSaga;

var _utils = require('./utils');

var _proc = require('./proc');

var _proc2 = _interopRequireDefault(_proc);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function runSaga(iterator, _ref) {
  var subscribe = _ref.subscribe;
  var dispatch = _ref.dispatch;
  var getState = _ref.getState;
  var sagaMonitor = _ref.sagaMonitor;
  var logger = _ref.logger;


  (0, _utils.check)(iterator, _utils.is.iterator, "runSaga must be called on an iterator");

  return (0, _proc2.default)(iterator, subscribe, dispatch, getState, { sagaMonitor: sagaMonitor, logger: logger });
}
},{"./proc":147,"./utils":150}],149:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

exports.takeEvery = takeEvery;
exports.takeLatest = takeLatest;
exports.throttle = throttle;

var _channel = require('./channel');

var _utils = require('./utils');

var _io = require('./io');

var _buffers = require('./buffers');

var done = { done: true, value: undefined };
var qEnd = {};

function fsmIterator(fsm, q0) {
  var name = arguments.length <= 2 || arguments[2] === undefined ? 'iterator' : arguments[2];

  var updateState = void 0,
      qNext = q0;

  function next(arg, error) {
    if (qNext === qEnd) {
      return done;
    }

    if (error) {
      qNext = qEnd;
      throw error;
    } else {
      updateState && updateState(arg);

      var _fsm$qNext = fsm[qNext]();

      var _fsm$qNext2 = _slicedToArray(_fsm$qNext, 3);

      var q = _fsm$qNext2[0];
      var output = _fsm$qNext2[1];
      var _updateState = _fsm$qNext2[2];

      qNext = q;
      updateState = _updateState;
      return qNext === qEnd ? done : output;
    }
  }

  return (0, _utils.makeIterator)(next, function (error) {
    return next(null, error);
  }, name, true);
}

function safeName(pattern) {
  if (Array.isArray(pattern)) {
    return String(pattern.map(function (entry) {
      return String(entry);
    }));
  } else {
    return String(pattern);
  }
}

function takeEvery(pattern, worker) {
  for (var _len = arguments.length, args = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
    args[_key - 2] = arguments[_key];
  }

  var yTake = { done: false, value: (0, _io.take)(pattern) };
  var yFork = function yFork(ac) {
    return { done: false, value: _io.fork.apply(undefined, [worker].concat(args, [ac])) };
  };

  var action = void 0,
      setAction = function setAction(ac) {
    return action = ac;
  };

  return fsmIterator({
    q1: function q1() {
      return ['q2', yTake, setAction];
    },
    q2: function q2() {
      return action === _channel.END ? [qEnd] : ['q1', yFork(action)];
    }
  }, 'q1', 'takeEvery(' + safeName(pattern) + ', ' + worker.name + ')');
}

function takeLatest(pattern, worker) {
  for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
    args[_key2 - 2] = arguments[_key2];
  }

  var yTake = { done: false, value: (0, _io.take)(pattern) };
  var yFork = function yFork(ac) {
    return { done: false, value: _io.fork.apply(undefined, [worker].concat(args, [ac])) };
  };
  var yCancel = function yCancel(task) {
    return { done: false, value: (0, _io.cancel)(task) };
  };

  var task = void 0,
      action = void 0;
  var setTask = function setTask(t) {
    return task = t;
  };
  var setAction = function setAction(ac) {
    return action = ac;
  };

  return fsmIterator({
    q1: function q1() {
      return ['q2', yTake, setAction];
    },
    q2: function q2() {
      return action === _channel.END ? [qEnd] : task ? ['q3', yCancel(task)] : ['q1', yFork(action), setTask];
    },
    q3: function q3() {
      return ['q1', yFork(action), setTask];
    }
  }, 'q1', 'takeLatest(' + safeName(pattern) + ', ' + worker.name + ')');
}

function throttle(delayLength, pattern, worker) {
  for (var _len3 = arguments.length, args = Array(_len3 > 3 ? _len3 - 3 : 0), _key3 = 3; _key3 < _len3; _key3++) {
    args[_key3 - 3] = arguments[_key3];
  }

  var action = void 0,
      channel = void 0;

  var yActionChannel = { done: false, value: (0, _io.actionChannel)(pattern, _buffers.buffers.sliding(1)) };
  var yTake = function yTake() {
    return { done: false, value: (0, _io.take)(channel, pattern) };
  };
  var yFork = function yFork(ac) {
    return { done: false, value: _io.fork.apply(undefined, [worker].concat(args, [ac])) };
  };
  var yDelay = { done: false, value: (0, _io.call)(_utils.delay, delayLength) };

  var setAction = function setAction(ac) {
    return action = ac;
  };
  var setChannel = function setChannel(ch) {
    return channel = ch;
  };

  return fsmIterator({
    q1: function q1() {
      return ['q2', yActionChannel, setChannel];
    },
    q2: function q2() {
      return ['q3', yTake(), setAction];
    },
    q3: function q3() {
      return action === _channel.END ? [qEnd] : ['q4', yFork(action)];
    },
    q4: function q4() {
      return ['q2', yDelay];
    }
  }, 'q1', 'throttle(' + safeName(pattern) + ', ' + worker.name + ')');
}
},{"./buffers":143,"./channel":144,"./io":145,"./utils":150}],150:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol ? "symbol" : typeof obj; };

exports.check = check;
exports.remove = remove;
exports.deferred = deferred;
exports.arrayOfDeffered = arrayOfDeffered;
exports.delay = delay;
exports.createMockTask = createMockTask;
exports.autoInc = autoInc;
exports.makeIterator = makeIterator;
exports.log = log;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var sym = exports.sym = function sym(id) {
  return '@@redux-saga/' + id;
};
var TASK = exports.TASK = sym('TASK');
var HELPER = exports.HELPER = sym('HELPER');
var MATCH = exports.MATCH = sym('MATCH');
var CANCEL = exports.CANCEL = sym('cancelPromise');
var konst = exports.konst = function konst(v) {
  return function () {
    return v;
  };
};
var kTrue = exports.kTrue = konst(true);
var kFalse = exports.kFalse = konst(false);
var noop = exports.noop = function noop() {};
var ident = exports.ident = function ident(v) {
  return v;
};

function check(value, predicate, error) {
  if (!predicate(value)) {
    log('error', 'uncaught at check', error);
    throw new Error(error);
  }
}

var is = exports.is = {
  undef: function undef(v) {
    return v === null || v === undefined;
  },
  notUndef: function notUndef(v) {
    return v !== null && v !== undefined;
  },
  func: function func(f) {
    return typeof f === 'function';
  },
  number: function number(n) {
    return typeof n === 'number';
  },
  array: Array.isArray,
  promise: function promise(p) {
    return p && is.func(p.then);
  },
  iterator: function iterator(it) {
    return it && is.func(it.next) && is.func(it.throw);
  },
  task: function task(t) {
    return t && t[TASK];
  },
  observable: function observable(ob) {
    return ob && is.func(ob.subscribe);
  },
  buffer: function buffer(buf) {
    return buf && is.func(buf.isEmpty) && is.func(buf.take) && is.func(buf.put);
  },
  pattern: function pattern(pat) {
    return pat && (typeof pat === 'string' || (typeof pat === 'undefined' ? 'undefined' : _typeof(pat)) === 'symbol' || is.func(pat) || is.array(pat));
  },
  channel: function channel(ch) {
    return ch && is.func(ch.take) && is.func(ch.close);
  },
  helper: function helper(it) {
    return it && it[HELPER];
  }
};

function remove(array, item) {
  var index = array.indexOf(item);
  if (index >= 0) {
    array.splice(index, 1);
  }
}

function deferred() {
  var props = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];

  var def = _extends({}, props);
  var promise = new Promise(function (resolve, reject) {
    def.resolve = resolve;
    def.reject = reject;
  });
  def.promise = promise;
  return def;
}

function arrayOfDeffered(length) {
  var arr = [];
  for (var i = 0; i < length; i++) {
    arr.push(deferred());
  }
  return arr;
}

function delay(ms) {
  var val = arguments.length <= 1 || arguments[1] === undefined ? true : arguments[1];

  var timeoutId = void 0;
  var promise = new Promise(function (resolve) {
    timeoutId = setTimeout(function () {
      return resolve(val);
    }, ms);
  });

  promise[CANCEL] = function () {
    return clearTimeout(timeoutId);
  };

  return promise;
}

function createMockTask() {
  var _ref;

  var running = true;
  var _result = void 0,
      _error = void 0;

  return _ref = {}, _defineProperty(_ref, TASK, true), _defineProperty(_ref, 'isRunning', function isRunning() {
    return running;
  }), _defineProperty(_ref, 'result', function result() {
    return _result;
  }), _defineProperty(_ref, 'error', function error() {
    return _error;
  }), _defineProperty(_ref, 'setRunning', function setRunning(b) {
    return running = b;
  }), _defineProperty(_ref, 'setResult', function setResult(r) {
    return _result = r;
  }), _defineProperty(_ref, 'setError', function setError(e) {
    return _error = e;
  }), _ref;
}

function autoInc() {
  var seed = arguments.length <= 0 || arguments[0] === undefined ? 0 : arguments[0];

  return function () {
    return ++seed;
  };
}

var kThrow = function kThrow(err) {
  throw err;
};
var kReturn = function kReturn(value) {
  return { value: value, done: true };
};
function makeIterator(next) {
  var thro = arguments.length <= 1 || arguments[1] === undefined ? kThrow : arguments[1];
  var name = arguments.length <= 2 || arguments[2] === undefined ? '' : arguments[2];
  var isHelper = arguments[3];

  var iterator = { name: name, next: next, throw: thro, return: kReturn };

  if (isHelper) {
    iterator[HELPER] = true;
  }
  if (typeof Symbol !== 'undefined') {
    iterator[Symbol.iterator] = function () {
      return iterator;
    };
  }
  return iterator;
}

/**
  Print error in a useful way whether in a browser environment
  (with expandable error stack traces), or in a node.js environment
  (text-only log output)
 **/
function log(level, message, error) {
  /*eslint-disable no-console*/
  if (typeof window === 'undefined') {
    console.log('redux-saga ' + level + ': ' + message + '\n' + (error && error.stack || error));
  } else {
    console[level](message, error);
  }
}

var internalErr = exports.internalErr = function internalErr(err) {
  return new Error('\n  redux-saga: Error checking hooks detected an inconsistent state. This is likely a bug\n  in redux-saga code and not yours. Thanks for reporting this in the project\'s github repo.\n  Error: ' + err + '\n');
};
},{}],151:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _utils = require('./internal/utils');

Object.defineProperty(exports, 'TASK', {
  enumerable: true,
  get: function get() {
    return _utils.TASK;
  }
});
Object.defineProperty(exports, 'noop', {
  enumerable: true,
  get: function get() {
    return _utils.noop;
  }
});
Object.defineProperty(exports, 'is', {
  enumerable: true,
  get: function get() {
    return _utils.is;
  }
});
Object.defineProperty(exports, 'deferred', {
  enumerable: true,
  get: function get() {
    return _utils.deferred;
  }
});
Object.defineProperty(exports, 'arrayOfDeffered', {
  enumerable: true,
  get: function get() {
    return _utils.arrayOfDeffered;
  }
});
Object.defineProperty(exports, 'createMockTask', {
  enumerable: true,
  get: function get() {
    return _utils.createMockTask;
  }
});

var _io = require('./internal/io');

Object.defineProperty(exports, 'asEffect', {
  enumerable: true,
  get: function get() {
    return _io.asEffect;
  }
});
},{"./internal/io":145,"./internal/utils":150}],152:[function(require,module,exports){
(function (global){
// This method of obtaining a reference to the global object needs to be
// kept identical to the way it is obtained in runtime.js
var g =
  typeof global === "object" ? global :
  typeof window === "object" ? window :
  typeof self === "object" ? self : this;

// Use `getOwnPropertyNames` because not all browsers support calling
// `hasOwnProperty` on the global `self` object in a worker. See #183.
var hadRuntime = g.regeneratorRuntime &&
  Object.getOwnPropertyNames(g).indexOf("regeneratorRuntime") >= 0;

// Save the old regeneratorRuntime in case it needs to be restored later.
var oldRuntime = hadRuntime && g.regeneratorRuntime;

// Force reevalutation of runtime.js.
g.regeneratorRuntime = undefined;

module.exports = require("./runtime");

if (hadRuntime) {
  // Restore the original runtime.
  g.regeneratorRuntime = oldRuntime;
} else {
  // Remove the global property added by runtime.js.
  try {
    delete g.regeneratorRuntime;
  } catch(e) {
    g.regeneratorRuntime = undefined;
  }
}

}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})

},{"./runtime":153}],153:[function(require,module,exports){
(function (process,global){
/**
 * Copyright (c) 2014, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * https://raw.github.com/facebook/regenerator/master/LICENSE file. An
 * additional grant of patent rights can be found in the PATENTS file in
 * the same directory.
 */

!(function(global) {
  "use strict";

  var hasOwn = Object.prototype.hasOwnProperty;
  var undefined; // More compressible than void 0.
  var $Symbol = typeof Symbol === "function" ? Symbol : {};
  var iteratorSymbol = $Symbol.iterator || "@@iterator";
  var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";

  var inModule = typeof module === "object";
  var runtime = global.regeneratorRuntime;
  if (runtime) {
    if (inModule) {
      // If regeneratorRuntime is defined globally and we're in a module,
      // make the exports object identical to regeneratorRuntime.
      module.exports = runtime;
    }
    // Don't bother evaluating the rest of this file if the runtime was
    // already defined globally.
    return;
  }

  // Define the runtime globally (as expected by generated code) as either
  // module.exports (if we're in a module) or a new, empty object.
  runtime = global.regeneratorRuntime = inModule ? module.exports : {};

  function wrap(innerFn, outerFn, self, tryLocsList) {
    // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
    var generator = Object.create(protoGenerator.prototype);
    var context = new Context(tryLocsList || []);

    // The ._invoke method unifies the implementations of the .next,
    // .throw, and .return methods.
    generator._invoke = makeInvokeMethod(innerFn, self, context);

    return generator;
  }
  runtime.wrap = wrap;

  // Try/catch helper to minimize deoptimizations. Returns a completion
  // record like context.tryEntries[i].completion. This interface could
  // have been (and was previously) designed to take a closure to be
  // invoked without arguments, but in all the cases we care about we
  // already have an existing method we want to call, so there's no need
  // to create a new function object. We can even get away with assuming
  // the method takes exactly one argument, since that happens to be true
  // in every case, so we don't have to touch the arguments object. The
  // only additional allocation required is the completion record, which
  // has a stable shape and so hopefully should be cheap to allocate.
  function tryCatch(fn, obj, arg) {
    try {
      return { type: "normal", arg: fn.call(obj, arg) };
    } catch (err) {
      return { type: "throw", arg: err };
    }
  }

  var GenStateSuspendedStart = "suspendedStart";
  var GenStateSuspendedYield = "suspendedYield";
  var GenStateExecuting = "executing";
  var GenStateCompleted = "completed";

  // Returning this object from the innerFn has the same effect as
  // breaking out of the dispatch switch statement.
  var ContinueSentinel = {};

  // Dummy constructor functions that we use as the .constructor and
  // .constructor.prototype properties for functions that return Generator
  // objects. For full spec compliance, you may wish to configure your
  // minifier not to mangle the names of these two functions.
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}

  var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype;
  GeneratorFunction.prototype = Gp.constructor = GeneratorFunctionPrototype;
  GeneratorFunctionPrototype.constructor = GeneratorFunction;
  GeneratorFunctionPrototype[toStringTagSymbol] = GeneratorFunction.displayName = "GeneratorFunction";

  // Helper for defining the .next, .throw, and .return methods of the
  // Iterator interface in terms of a single ._invoke method.
  function defineIteratorMethods(prototype) {
    ["next", "throw", "return"].forEach(function(method) {
      prototype[method] = function(arg) {
        return this._invoke(method, arg);
      };
    });
  }

  runtime.isGeneratorFunction = function(genFun) {
    var ctor = typeof genFun === "function" && genFun.constructor;
    return ctor
      ? ctor === GeneratorFunction ||
        // For the native GeneratorFunction constructor, the best we can
        // do is to check its .name property.
        (ctor.displayName || ctor.name) === "GeneratorFunction"
      : false;
  };

  runtime.mark = function(genFun) {
    if (Object.setPrototypeOf) {
      Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
    } else {
      genFun.__proto__ = GeneratorFunctionPrototype;
      if (!(toStringTagSymbol in genFun)) {
        genFun[toStringTagSymbol] = "GeneratorFunction";
      }
    }
    genFun.prototype = Object.create(Gp);
    return genFun;
  };

  // Within the body of any async function, `await x` is transformed to
  // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
  // `value instanceof AwaitArgument` to determine if the yielded value is
  // meant to be awaited. Some may consider the name of this method too
  // cutesy, but they are curmudgeons.
  runtime.awrap = function(arg) {
    return new AwaitArgument(arg);
  };

  function AwaitArgument(arg) {
    this.arg = arg;
  }

  function AsyncIterator(generator) {
    function invoke(method, arg, resolve, reject) {
      var record = tryCatch(generator[method], generator, arg);
      if (record.type === "throw") {
        reject(record.arg);
      } else {
        var result = record.arg;
        var value = result.value;
        if (value instanceof AwaitArgument) {
          return Promise.resolve(value.arg).then(function(value) {
            invoke("next", value, resolve, reject);
          }, function(err) {
            invoke("throw", err, resolve, reject);
          });
        }

        return Promise.resolve(value).then(function(unwrapped) {
          // When a yielded Promise is resolved, its final value becomes
          // the .value of the Promise<{value,done}> result for the
          // current iteration. If the Promise is rejected, however, the
          // result for this iteration will be rejected with the same
          // reason. Note that rejections of yielded Promises are not
          // thrown back into the generator function, as is the case
          // when an awaited Promise is rejected. This difference in
          // behavior between yield and await is important, because it
          // allows the consumer to decide what to do with the yielded
          // rejection (swallow it and continue, manually .throw it back
          // into the generator, abandon iteration, whatever). With
          // await, by contrast, there is no opportunity to examine the
          // rejection reason outside the generator function, so the
          // only option is to throw it from the await expression, and
          // let the generator function handle the exception.
          result.value = unwrapped;
          resolve(result);
        }, reject);
      }
    }

    if (typeof process === "object" && process.domain) {
      invoke = process.domain.bind(invoke);
    }

    var previousPromise;

    function enqueue(method, arg) {
      function callInvokeWithMethodAndArg() {
        return new Promise(function(resolve, reject) {
          invoke(method, arg, resolve, reject);
        });
      }

      return previousPromise =
        // If enqueue has been called before, then we want to wait until
        // all previous Promises have been resolved before calling invoke,
        // so that results are always delivered in the correct order. If
        // enqueue has not been called before, then it is important to
        // call invoke immediately, without waiting on a callback to fire,
        // so that the async generator function has the opportunity to do
        // any necessary setup in a predictable way. This predictability
        // is why the Promise constructor synchronously invokes its
        // executor callback, and why async functions synchronously
        // execute code before the first await. Since we implement simple
        // async functions in terms of async generators, it is especially
        // important to get this right, even though it requires care.
        previousPromise ? previousPromise.then(
          callInvokeWithMethodAndArg,
          // Avoid propagating failures to Promises returned by later
          // invocations of the iterator.
          callInvokeWithMethodAndArg
        ) : callInvokeWithMethodAndArg();
    }

    // Define the unified helper method that is used to implement .next,
    // .throw, and .return (see defineIteratorMethods).
    this._invoke = enqueue;
  }

  defineIteratorMethods(AsyncIterator.prototype);

  // Note that simple async functions are implemented on top of
  // AsyncIterator objects; they just return a Promise for the value of
  // the final result produced by the iterator.
  runtime.async = function(innerFn, outerFn, self, tryLocsList) {
    var iter = new AsyncIterator(
      wrap(innerFn, outerFn, self, tryLocsList)
    );

    return runtime.isGeneratorFunction(outerFn)
      ? iter // If outerFn is a generator, return the full iterator.
      : iter.next().then(function(result) {
          return result.done ? result.value : iter.next();
        });
  };

  function makeInvokeMethod(innerFn, self, context) {
    var state = GenStateSuspendedStart;

    return function invoke(method, arg) {
      if (state === GenStateExecuting) {
        throw new Error("Generator is already running");
      }

      if (state === GenStateCompleted) {
        if (method === "throw") {
          throw arg;
        }

        // Be forgiving, per 25.3.3.3.3 of the spec:
        // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
        return doneResult();
      }

      while (true) {
        var delegate = context.delegate;
        if (delegate) {
          if (method === "return" ||
              (method === "throw" && delegate.iterator[method] === undefined)) {
            // A return or throw (when the delegate iterator has no throw
            // method) always terminates the yield* loop.
            context.delegate = null;

            // If the delegate iterator has a return method, give it a
            // chance to clean up.
            var returnMethod = delegate.iterator["return"];
            if (returnMethod) {
              var record = tryCatch(returnMethod, delegate.iterator, arg);
              if (record.type === "throw") {
                // If the return method threw an exception, let that
                // exception prevail over the original return or throw.
                method = "throw";
                arg = record.arg;
                continue;
              }
            }

            if (method === "return") {
              // Continue with the outer return, now that the delegate
              // iterator has been terminated.
              continue;
            }
          }

          var record = tryCatch(
            delegate.iterator[method],
            delegate.iterator,
            arg
          );

          if (record.type === "throw") {
            context.delegate = null;

            // Like returning generator.throw(uncaught), but without the
            // overhead of an extra function call.
            method = "throw";
            arg = record.arg;
            continue;
          }

          // Delegate generator ran and handled its own exceptions so
          // regardless of what the method was, we continue as if it is
          // "next" with an undefined arg.
          method = "next";
          arg = undefined;

          var info = record.arg;
          if (info.done) {
            context[delegate.resultName] = info.value;
            context.next = delegate.nextLoc;
          } else {
            state = GenStateSuspendedYield;
            return info;
          }

          context.delegate = null;
        }

        if (method === "next") {
          // Setting context._sent for legacy support of Babel's
          // function.sent implementation.
          context.sent = context._sent = arg;

        } else if (method === "throw") {
          if (state === GenStateSuspendedStart) {
            state = GenStateCompleted;
            throw arg;
          }

          if (context.dispatchException(arg)) {
            // If the dispatched exception was caught by a catch block,
            // then let that catch block handle the exception normally.
            method = "next";
            arg = undefined;
          }

        } else if (method === "return") {
          context.abrupt("return", arg);
        }

        state = GenStateExecuting;

        var record = tryCatch(innerFn, self, context);
        if (record.type === "normal") {
          // If an exception is thrown from innerFn, we leave state ===
          // GenStateExecuting and loop back for another invocation.
          state = context.done
            ? GenStateCompleted
            : GenStateSuspendedYield;

          var info = {
            value: record.arg,
            done: context.done
          };

          if (record.arg === ContinueSentinel) {
            if (context.delegate && method === "next") {
              // Deliberately forget the last sent value so that we don't
              // accidentally pass it on to the delegate.
              arg = undefined;
            }
          } else {
            return info;
          }

        } else if (record.type === "throw") {
          state = GenStateCompleted;
          // Dispatch the exception by looping back around to the
          // context.dispatchException(arg) call above.
          method = "throw";
          arg = record.arg;
        }
      }
    };
  }

  // Define Generator.prototype.{next,throw,return} in terms of the
  // unified ._invoke helper method.
  defineIteratorMethods(Gp);

  Gp[iteratorSymbol] = function() {
    return this;
  };

  Gp[toStringTagSymbol] = "Generator";

  Gp.toString = function() {
    return "[object Generator]";
  };

  function pushTryEntry(locs) {
    var entry = { tryLoc: locs[0] };

    if (1 in locs) {
      entry.catchLoc = locs[1];
    }

    if (2 in locs) {
      entry.finallyLoc = locs[2];
      entry.afterLoc = locs[3];
    }

    this.tryEntries.push(entry);
  }

  function resetTryEntry(entry) {
    var record = entry.completion || {};
    record.type = "normal";
    delete record.arg;
    entry.completion = record;
  }

  function Context(tryLocsList) {
    // The root entry object (effectively a try statement without a catch
    // or a finally block) gives us a place to store values thrown from
    // locations where there is no enclosing try statement.
    this.tryEntries = [{ tryLoc: "root" }];
    tryLocsList.forEach(pushTryEntry, this);
    this.reset(true);
  }

  runtime.keys = function(object) {
    var keys = [];
    for (var key in object) {
      keys.push(key);
    }
    keys.reverse();

    // Rather than returning an object with a next method, we keep
    // things simple and return the next function itself.
    return function next() {
      while (keys.length) {
        var key = keys.pop();
        if (key in object) {
          next.value = key;
          next.done = false;
          return next;
        }
      }

      // To avoid creating an additional object, we just hang the .value
      // and .done properties off the next function object itself. This
      // also ensures that the minifier will not anonymize the function.
      next.done = true;
      return next;
    };
  };

  function values(iterable) {
    if (iterable) {
      var iteratorMethod = iterable[iteratorSymbol];
      if (iteratorMethod) {
        return iteratorMethod.call(iterable);
      }

      if (typeof iterable.next === "function") {
        return iterable;
      }

      if (!isNaN(iterable.length)) {
        var i = -1, next = function next() {
          while (++i < iterable.length) {
            if (hasOwn.call(iterable, i)) {
              next.value = iterable[i];
              next.done = false;
              return next;
            }
          }

          next.value = undefined;
          next.done = true;

          return next;
        };

        return next.next = next;
      }
    }

    // Return an iterator with no values.
    return { next: doneResult };
  }
  runtime.values = values;

  function doneResult() {
    return { value: undefined, done: true };
  }

  Context.prototype = {
    constructor: Context,

    reset: function(skipTempReset) {
      this.prev = 0;
      this.next = 0;
      // Resetting context._sent for legacy support of Babel's
      // function.sent implementation.
      this.sent = this._sent = undefined;
      this.done = false;
      this.delegate = null;

      this.tryEntries.forEach(resetTryEntry);

      if (!skipTempReset) {
        for (var name in this) {
          // Not sure about the optimal order of these conditions:
          if (name.charAt(0) === "t" &&
              hasOwn.call(this, name) &&
              !isNaN(+name.slice(1))) {
            this[name] = undefined;
          }
        }
      }
    },

    stop: function() {
      this.done = true;

      var rootEntry = this.tryEntries[0];
      var rootRecord = rootEntry.completion;
      if (rootRecord.type === "throw") {
        throw rootRecord.arg;
      }

      return this.rval;
    },

    dispatchException: function(exception) {
      if (this.done) {
        throw exception;
      }

      var context = this;
      function handle(loc, caught) {
        record.type = "throw";
        record.arg = exception;
        context.next = loc;
        return !!caught;
      }

      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        var record = entry.completion;

        if (entry.tryLoc === "root") {
          // Exception thrown outside of any try block that could handle
          // it, so set the completion value of the entire function to
          // throw the exception.
          return handle("end");
        }

        if (entry.tryLoc <= this.prev) {
          var hasCatch = hasOwn.call(entry, "catchLoc");
          var hasFinally = hasOwn.call(entry, "finallyLoc");

          if (hasCatch && hasFinally) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            } else if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else if (hasCatch) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            }

          } else if (hasFinally) {
            if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else {
            throw new Error("try statement without catch or finally");
          }
        }
      }
    },

    abrupt: function(type, arg) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc <= this.prev &&
            hasOwn.call(entry, "finallyLoc") &&
            this.prev < entry.finallyLoc) {
          var finallyEntry = entry;
          break;
        }
      }

      if (finallyEntry &&
          (type === "break" ||
           type === "continue") &&
          finallyEntry.tryLoc <= arg &&
          arg <= finallyEntry.finallyLoc) {
        // Ignore the finally entry if control is not jumping to a
        // location outside the try/catch block.
        finallyEntry = null;
      }

      var record = finallyEntry ? finallyEntry.completion : {};
      record.type = type;
      record.arg = arg;

      if (finallyEntry) {
        this.next = finallyEntry.finallyLoc;
      } else {
        this.complete(record);
      }

      return ContinueSentinel;
    },

    complete: function(record, afterLoc) {
      if (record.type === "throw") {
        throw record.arg;
      }

      if (record.type === "break" ||
          record.type === "continue") {
        this.next = record.arg;
      } else if (record.type === "return") {
        this.rval = record.arg;
        this.next = "end";
      } else if (record.type === "normal" && afterLoc) {
        this.next = afterLoc;
      }
    },

    finish: function(finallyLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.finallyLoc === finallyLoc) {
          this.complete(entry.completion, entry.afterLoc);
          resetTryEntry(entry);
          return ContinueSentinel;
        }
      }
    },

    "catch": function(tryLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc === tryLoc) {
          var record = entry.completion;
          if (record.type === "throw") {
            var thrown = record.arg;
            resetTryEntry(entry);
          }
          return thrown;
        }
      }

      // The context.catch method must only be called with a location
      // argument that corresponds to a known catch block.
      throw new Error("illegal catch attempt");
    },

    delegateYield: function(iterable, resultName, nextLoc) {
      this.delegate = {
        iterator: values(iterable),
        resultName: resultName,
        nextLoc: nextLoc
      };

      return ContinueSentinel;
    }
  };
})(
  // Among the various tricks for obtaining a reference to the global
  // object, this seems to be the most reliable technique that does not
  // use indirect eval (which violates Content Security Policy).
  typeof global === "object" ? global :
  typeof window === "object" ? window :
  typeof self === "object" ? self : this
);

}).call(this,require('_process'),typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})

},{"_process":138}],154:[function(require,module,exports){
/*!
  * Reqwest! A general purpose XHR connection manager
  * license MIT (c) Dustin Diaz 2015
  * https://github.com/ded/reqwest
  */

!function (name, context, definition) {
  if (typeof module != 'undefined' && module.exports) module.exports = definition()
  else if (typeof define == 'function' && define.amd) define(definition)
  else context[name] = definition()
}('reqwest', this, function () {

  var context = this

  if ('window' in context) {
    var doc = document
      , byTag = 'getElementsByTagName'
      , head = doc[byTag]('head')[0]
  } else {
    var XHR2
    try {
      XHR2 = require('xhr2')
    } catch (ex) {
      throw new Error('Peer dependency `xhr2` required! Please npm install xhr2')
    }
  }


  var httpsRe = /^http/
    , protocolRe = /(^\w+):\/\//
    , twoHundo = /^(20\d|1223)$/ //http://stackoverflow.com/questions/10046972/msie-returns-status-code-of-1223-for-ajax-request
    , readyState = 'readyState'
    , contentType = 'Content-Type'
    , requestedWith = 'X-Requested-With'
    , uniqid = 0
    , callbackPrefix = 'reqwest_' + (+new Date())
    , lastValue // data stored by the most recent JSONP callback
    , xmlHttpRequest = 'XMLHttpRequest'
    , xDomainRequest = 'XDomainRequest'
    , noop = function () {}

    , isArray = typeof Array.isArray == 'function'
        ? Array.isArray
        : function (a) {
            return a instanceof Array
          }

    , defaultHeaders = {
          'contentType': 'application/x-www-form-urlencoded'
        , 'requestedWith': xmlHttpRequest
        , 'accept': {
              '*':  'text/javascript, text/html, application/xml, text/xml, */*'
            , 'xml':  'application/xml, text/xml'
            , 'html': 'text/html'
            , 'text': 'text/plain'
            , 'json': 'application/json, text/javascript'
            , 'js':   'application/javascript, text/javascript'
          }
      }

    , xhr = function(o) {
        // is it x-domain
        if (o['crossOrigin'] === true) {
          var xhr = context[xmlHttpRequest] ? new XMLHttpRequest() : null
          if (xhr && 'withCredentials' in xhr) {
            return xhr
          } else if (context[xDomainRequest]) {
            return new XDomainRequest()
          } else {
            throw new Error('Browser does not support cross-origin requests')
          }
        } else if (context[xmlHttpRequest]) {
          return new XMLHttpRequest()
        } else if (XHR2) {
          return new XHR2()
        } else {
          return new ActiveXObject('Microsoft.XMLHTTP')
        }
      }
    , globalSetupOptions = {
        dataFilter: function (data) {
          return data
        }
      }

  function succeed(r) {
    var protocol = protocolRe.exec(r.url)
    protocol = (protocol && protocol[1]) || context.location.protocol
    return httpsRe.test(protocol) ? twoHundo.test(r.request.status) : !!r.request.response
  }

  function handleReadyState(r, success, error) {
    return function () {
      // use _aborted to mitigate against IE err c00c023f
      // (can't read props on aborted request objects)
      if (r._aborted) return error(r.request)
      if (r._timedOut) return error(r.request, 'Request is aborted: timeout')
      if (r.request && r.request[readyState] == 4) {
        r.request.onreadystatechange = noop
        if (succeed(r)) success(r.request)
        else
          error(r.request)
      }
    }
  }

  function setHeaders(http, o) {
    var headers = o['headers'] || {}
      , h

    headers['Accept'] = headers['Accept']
      || defaultHeaders['accept'][o['type']]
      || defaultHeaders['accept']['*']

    var isAFormData = typeof FormData !== 'undefined' && (o['data'] instanceof FormData);
    // breaks cross-origin requests with legacy browsers
    if (!o['crossOrigin'] && !headers[requestedWith]) headers[requestedWith] = defaultHeaders['requestedWith']
    if (!headers[contentType] && !isAFormData) headers[contentType] = o['contentType'] || defaultHeaders['contentType']
    for (h in headers)
      headers.hasOwnProperty(h) && 'setRequestHeader' in http && http.setRequestHeader(h, headers[h])
  }

  function setCredentials(http, o) {
    if (typeof o['withCredentials'] !== 'undefined' && typeof http.withCredentials !== 'undefined') {
      http.withCredentials = !!o['withCredentials']
    }
  }

  function generalCallback(data) {
    lastValue = data
  }

  function urlappend (url, s) {
    return url + (/\?/.test(url) ? '&' : '?') + s
  }

  function handleJsonp(o, fn, err, url) {
    var reqId = uniqid++
      , cbkey = o['jsonpCallback'] || 'callback' // the 'callback' key
      , cbval = o['jsonpCallbackName'] || reqwest.getcallbackPrefix(reqId)
      , cbreg = new RegExp('((^|\\?|&)' + cbkey + ')=([^&]+)')
      , match = url.match(cbreg)
      , script = doc.createElement('script')
      , loaded = 0
      , isIE10 = navigator.userAgent.indexOf('MSIE 10.0') !== -1

    if (match) {
      if (match[3] === '?') {
        url = url.replace(cbreg, '$1=' + cbval) // wildcard callback func name
      } else {
        cbval = match[3] // provided callback func name
      }
    } else {
      url = urlappend(url, cbkey + '=' + cbval) // no callback details, add 'em
    }

    context[cbval] = generalCallback

    script.type = 'text/javascript'
    script.src = url
    script.async = true
    if (typeof script.onreadystatechange !== 'undefined' && !isIE10) {
      // need this for IE due to out-of-order onreadystatechange(), binding script
      // execution to an event listener gives us control over when the script
      // is executed. See http://jaubourg.net/2010/07/loading-script-as-onclick-handler-of.html
      script.htmlFor = script.id = '_reqwest_' + reqId
    }

    script.onload = script.onreadystatechange = function () {
      if ((script[readyState] && script[readyState] !== 'complete' && script[readyState] !== 'loaded') || loaded) {
        return false
      }
      script.onload = script.onreadystatechange = null
      script.onclick && script.onclick()
      // Call the user callback with the last value stored and clean up values and scripts.
      fn(lastValue)
      lastValue = undefined
      head.removeChild(script)
      loaded = 1
    }

    // Add the script to the DOM head
    head.appendChild(script)

    // Enable JSONP timeout
    return {
      abort: function () {
        script.onload = script.onreadystatechange = null
        err({}, 'Request is aborted: timeout', {})
        lastValue = undefined
        head.removeChild(script)
        loaded = 1
      }
    }
  }

  function getRequest(fn, err) {
    var o = this.o
      , method = (o['method'] || 'GET').toUpperCase()
      , url = typeof o === 'string' ? o : o['url']
      // convert non-string objects to query-string form unless o['processData'] is false
      , data = (o['processData'] !== false && o['data'] && typeof o['data'] !== 'string')
        ? reqwest.toQueryString(o['data'])
        : (o['data'] || null)
      , http
      , sendWait = false

    // if we're working on a GET request and we have data then we should append
    // query string to end of URL and not post data
    if ((o['type'] == 'jsonp' || method == 'GET') && data) {
      url = urlappend(url, data)
      data = null
    }

    if (o['type'] == 'jsonp') return handleJsonp(o, fn, err, url)

    // get the xhr from the factory if passed
    // if the factory returns null, fall-back to ours
    http = (o.xhr && o.xhr(o)) || xhr(o)

    http.open(method, url, o['async'] === false ? false : true)
    setHeaders(http, o)
    setCredentials(http, o)
    if (context[xDomainRequest] && http instanceof context[xDomainRequest]) {
        http.onload = fn
        http.onerror = err
        // NOTE: see
        // http://social.msdn.microsoft.com/Forums/en-US/iewebdevelopment/thread/30ef3add-767c-4436-b8a9-f1ca19b4812e
        http.onprogress = function() {}
        sendWait = true
    } else {
      http.onreadystatechange = handleReadyState(this, fn, err)
    }
    o['before'] && o['before'](http)
    if (sendWait) {
      setTimeout(function () {
        http.send(data)
      }, 200)
    } else {
      http.send(data)
    }
    return http
  }

  function Reqwest(o, fn) {
    this.o = o
    this.fn = fn

    init.apply(this, arguments)
  }

  function setType(header) {
    // json, javascript, text/plain, text/html, xml
    if (header === null) return undefined; //In case of no content-type.
    if (header.match('json')) return 'json'
    if (header.match('javascript')) return 'js'
    if (header.match('text')) return 'html'
    if (header.match('xml')) return 'xml'
  }

  function init(o, fn) {

    this.url = typeof o == 'string' ? o : o['url']
    this.timeout = null

    // whether request has been fulfilled for purpose
    // of tracking the Promises
    this._fulfilled = false
    // success handlers
    this._successHandler = function(){}
    this._fulfillmentHandlers = []
    // error handlers
    this._errorHandlers = []
    // complete (both success and fail) handlers
    this._completeHandlers = []
    this._erred = false
    this._responseArgs = {}

    var self = this

    fn = fn || function () {}

    if (o['timeout']) {
      this.timeout = setTimeout(function () {
        timedOut()
      }, o['timeout'])
    }

    if (o['success']) {
      this._successHandler = function () {
        o['success'].apply(o, arguments)
      }
    }

    if (o['error']) {
      this._errorHandlers.push(function () {
        o['error'].apply(o, arguments)
      })
    }

    if (o['complete']) {
      this._completeHandlers.push(function () {
        o['complete'].apply(o, arguments)
      })
    }

    function complete (resp) {
      o['timeout'] && clearTimeout(self.timeout)
      self.timeout = null
      while (self._completeHandlers.length > 0) {
        self._completeHandlers.shift()(resp)
      }
    }

    function success (resp) {
      var type = o['type'] || resp && setType(resp.getResponseHeader('Content-Type')) // resp can be undefined in IE
      resp = (type !== 'jsonp') ? self.request : resp
      // use global data filter on response text
      var filteredResponse = globalSetupOptions.dataFilter(resp.responseText, type)
        , r = filteredResponse
      try {
        resp.responseText = r
      } catch (e) {
        // can't assign this in IE<=8, just ignore
      }
      if (r) {
        switch (type) {
        case 'json':
          try {
            resp = context.JSON ? context.JSON.parse(r) : eval('(' + r + ')')
          } catch (err) {
            return error(resp, 'Could not parse JSON in response', err)
          }
          break
        case 'js':
          resp = eval(r)
          break
        case 'html':
          resp = r
          break
        case 'xml':
          resp = resp.responseXML
              && resp.responseXML.parseError // IE trololo
              && resp.responseXML.parseError.errorCode
              && resp.responseXML.parseError.reason
            ? null
            : resp.responseXML
          break
        }
      }

      self._responseArgs.resp = resp
      self._fulfilled = true
      fn(resp)
      self._successHandler(resp)
      while (self._fulfillmentHandlers.length > 0) {
        resp = self._fulfillmentHandlers.shift()(resp)
      }

      complete(resp)
    }

    function timedOut() {
      self._timedOut = true
      self.request.abort()
    }

    function error(resp, msg, t) {
      resp = self.request
      self._responseArgs.resp = resp
      self._responseArgs.msg = msg
      self._responseArgs.t = t
      self._erred = true
      while (self._errorHandlers.length > 0) {
        self._errorHandlers.shift()(resp, msg, t)
      }
      complete(resp)
    }

    this.request = getRequest.call(this, success, error)
  }

  Reqwest.prototype = {
    abort: function () {
      this._aborted = true
      this.request.abort()
    }

  , retry: function () {
      init.call(this, this.o, this.fn)
    }

    /**
     * Small deviation from the Promises A CommonJs specification
     * http://wiki.commonjs.org/wiki/Promises/A
     */

    /**
     * `then` will execute upon successful requests
     */
  , then: function (success, fail) {
      success = success || function () {}
      fail = fail || function () {}
      if (this._fulfilled) {
        this._responseArgs.resp = success(this._responseArgs.resp)
      } else if (this._erred) {
        fail(this._responseArgs.resp, this._responseArgs.msg, this._responseArgs.t)
      } else {
        this._fulfillmentHandlers.push(success)
        this._errorHandlers.push(fail)
      }
      return this
    }

    /**
     * `always` will execute whether the request succeeds or fails
     */
  , always: function (fn) {
      if (this._fulfilled || this._erred) {
        fn(this._responseArgs.resp)
      } else {
        this._completeHandlers.push(fn)
      }
      return this
    }

    /**
     * `fail` will execute when the request fails
     */
  , fail: function (fn) {
      if (this._erred) {
        fn(this._responseArgs.resp, this._responseArgs.msg, this._responseArgs.t)
      } else {
        this._errorHandlers.push(fn)
      }
      return this
    }
  , 'catch': function (fn) {
      return this.fail(fn)
    }
  }

  function reqwest(o, fn) {
    return new Reqwest(o, fn)
  }

  // normalize newline variants according to spec -> CRLF
  function normalize(s) {
    return s ? s.replace(/\r?\n/g, '\r\n') : ''
  }

  function serial(el, cb) {
    var n = el.name
      , t = el.tagName.toLowerCase()
      , optCb = function (o) {
          // IE gives value="" even where there is no value attribute
          // 'specified' ref: http://www.w3.org/TR/DOM-Level-3-Core/core.html#ID-862529273
          if (o && !o['disabled'])
            cb(n, normalize(o['attributes']['value'] && o['attributes']['value']['specified'] ? o['value'] : o['text']))
        }
      , ch, ra, val, i

    // don't serialize elements that are disabled or without a name
    if (el.disabled || !n) return

    switch (t) {
    case 'input':
      if (!/reset|button|image|file/i.test(el.type)) {
        ch = /checkbox/i.test(el.type)
        ra = /radio/i.test(el.type)
        val = el.value
        // WebKit gives us "" instead of "on" if a checkbox has no value, so correct it here
        ;(!(ch || ra) || el.checked) && cb(n, normalize(ch && val === '' ? 'on' : val))
      }
      break
    case 'textarea':
      cb(n, normalize(el.value))
      break
    case 'select':
      if (el.type.toLowerCase() === 'select-one') {
        optCb(el.selectedIndex >= 0 ? el.options[el.selectedIndex] : null)
      } else {
        for (i = 0; el.length && i < el.length; i++) {
          el.options[i].selected && optCb(el.options[i])
        }
      }
      break
    }
  }

  // collect up all form elements found from the passed argument elements all
  // the way down to child elements; pass a '<form>' or form fields.
  // called with 'this'=callback to use for serial() on each element
  function eachFormElement() {
    var cb = this
      , e, i
      , serializeSubtags = function (e, tags) {
          var i, j, fa
          for (i = 0; i < tags.length; i++) {
            fa = e[byTag](tags[i])
            for (j = 0; j < fa.length; j++) serial(fa[j], cb)
          }
        }

    for (i = 0; i < arguments.length; i++) {
      e = arguments[i]
      if (/input|select|textarea/i.test(e.tagName)) serial(e, cb)
      serializeSubtags(e, [ 'input', 'select', 'textarea' ])
    }
  }

  // standard query string style serialization
  function serializeQueryString() {
    return reqwest.toQueryString(reqwest.serializeArray.apply(null, arguments))
  }

  // { 'name': 'value', ... } style serialization
  function serializeHash() {
    var hash = {}
    eachFormElement.apply(function (name, value) {
      if (name in hash) {
        hash[name] && !isArray(hash[name]) && (hash[name] = [hash[name]])
        hash[name].push(value)
      } else hash[name] = value
    }, arguments)
    return hash
  }

  // [ { name: 'name', value: 'value' }, ... ] style serialization
  reqwest.serializeArray = function () {
    var arr = []
    eachFormElement.apply(function (name, value) {
      arr.push({name: name, value: value})
    }, arguments)
    return arr
  }

  reqwest.serialize = function () {
    if (arguments.length === 0) return ''
    var opt, fn
      , args = Array.prototype.slice.call(arguments, 0)

    opt = args.pop()
    opt && opt.nodeType && args.push(opt) && (opt = null)
    opt && (opt = opt.type)

    if (opt == 'map') fn = serializeHash
    else if (opt == 'array') fn = reqwest.serializeArray
    else fn = serializeQueryString

    return fn.apply(null, args)
  }

  reqwest.toQueryString = function (o, trad) {
    var prefix, i
      , traditional = trad || false
      , s = []
      , enc = encodeURIComponent
      , add = function (key, value) {
          // If value is a function, invoke it and return its value
          value = ('function' === typeof value) ? value() : (value == null ? '' : value)
          s[s.length] = enc(key) + '=' + enc(value)
        }
    // If an array was passed in, assume that it is an array of form elements.
    if (isArray(o)) {
      for (i = 0; o && i < o.length; i++) add(o[i]['name'], o[i]['value'])
    } else {
      // If traditional, encode the "old" way (the way 1.3.2 or older
      // did it), otherwise encode params recursively.
      for (prefix in o) {
        if (o.hasOwnProperty(prefix)) buildParams(prefix, o[prefix], traditional, add)
      }
    }

    // spaces should be + according to spec
    return s.join('&').replace(/%20/g, '+')
  }

  function buildParams(prefix, obj, traditional, add) {
    var name, i, v
      , rbracket = /\[\]$/

    if (isArray(obj)) {
      // Serialize array item.
      for (i = 0; obj && i < obj.length; i++) {
        v = obj[i]
        if (traditional || rbracket.test(prefix)) {
          // Treat each array item as a scalar.
          add(prefix, v)
        } else {
          buildParams(prefix + '[' + (typeof v === 'object' ? i : '') + ']', v, traditional, add)
        }
      }
    } else if (obj && obj.toString() === '[object Object]') {
      // Serialize object item.
      for (name in obj) {
        buildParams(prefix + '[' + name + ']', obj[name], traditional, add)
      }

    } else {
      // Serialize scalar item.
      add(prefix, obj)
    }
  }

  reqwest.getcallbackPrefix = function () {
    return callbackPrefix
  }

  // jQuery and Zepto compatibility, differences can be remapped here so you can call
  // .ajax.compat(options, callback)
  reqwest.compat = function (o, fn) {
    if (o) {
      o['type'] && (o['method'] = o['type']) && delete o['type']
      o['dataType'] && (o['type'] = o['dataType'])
      o['jsonpCallback'] && (o['jsonpCallbackName'] = o['jsonpCallback']) && delete o['jsonpCallback']
      o['jsonp'] && (o['jsonpCallback'] = o['jsonp'])
    }
    return new Reqwest(o, fn)
  }

  reqwest.ajaxSetup = function (options) {
    options = options || {}
    for (var k in options) {
      globalSetupOptions[k] = options[k]
    }
  }

  return reqwest
});

},{"xhr2":28}],155:[function(require,module,exports){
/*! http://mths.be/startswith v0.2.0 by @mathias */
if (!String.prototype.startsWith) {
	(function() {
		'use strict'; // needed to support `apply`/`call` with `undefined`/`null`
		var defineProperty = (function() {
			// IE 8 only supports `Object.defineProperty` on DOM elements
			try {
				var object = {};
				var $defineProperty = Object.defineProperty;
				var result = $defineProperty(object, object, object) && $defineProperty;
			} catch(error) {}
			return result;
		}());
		var toString = {}.toString;
		var startsWith = function(search) {
			if (this == null) {
				throw TypeError();
			}
			var string = String(this);
			if (search && toString.call(search) == '[object RegExp]') {
				throw TypeError();
			}
			var stringLength = string.length;
			var searchString = String(search);
			var searchLength = searchString.length;
			var position = arguments.length > 1 ? arguments[1] : undefined;
			// `ToInteger`
			var pos = position ? Number(position) : 0;
			if (pos != pos) { // better `isNaN`
				pos = 0;
			}
			var start = Math.min(Math.max(pos, 0), stringLength);
			// Avoid the `indexOf` call if no match is possible
			if (searchLength + start > stringLength) {
				return false;
			}
			var index = -1;
			while (++index < searchLength) {
				if (string.charCodeAt(start + index) != searchString.charCodeAt(index)) {
					return false;
				}
			}
			return true;
		};
		if (defineProperty) {
			defineProperty(String.prototype, 'startsWith', {
				'value': startsWith,
				'configurable': true,
				'writable': true
			});
		} else {
			String.prototype.startsWith = startsWith;
		}
	}());
}

},{}],156:[function(require,module,exports){
var asyncDefine = require('async-define');
asyncDefine(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function (__react,__react_dom,__redux,__react_redux){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _assign = require('babel-runtime/core-js/object/assign');

var _assign2 = _interopRequireDefault(_assign);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var errors = {
  /* signin */
  'signin.generic.error': {
    'signin.password': {
      msg: 'Server error. Please try again later.',
      state: 'error'
    },
    'signin.userName': {
      msg: '',
      state: 'error'
    }
  },
  'signin.denied.error': {
    'signin.password': {
      msg: 'Server error. Please try again later.',
      state: 'error'
    },
    'signin.userName': {
      msg: '',
      state: 'error'
    }
  },
  'signin.unauthorized': {
    'signin.password': {
      msg: 'Sorry, we don\'t recognise your username or password.',
      state: 'error'
    },
    'signin.userName': {
      msg: '',
      state: 'error'
    }
  },
  'signin.generic.banned': {
    'signin.password': {
      msg: 'This user has been banned for an unspecified reason.',
      state: 'error'
    },
    'signin.userName': {
      msg: '',
      state: 'error'
    }
  },
  'signin.banned': {
    'signin.password': {
      msg: 'This user has been banned.',
      state: 'error'
    },
    'signin.userName': {
      msg: '',
      state: 'error'
    }
  },
  'signin.disapproved': {
    'signin.password': {
      msg: 'This user has been disapproved.',
      state: 'error'
    },
    'signin.userName': {
      msg: '',
      state: 'error'
    }
  },
  'signin.possible spam activity': {
    'signin.password': {
      msg: 'This user has been identified as possible spammer.',
      state: 'error'
    },
    'signin.userName': {
      msg: '',
      state: 'error'
    }
  },
  'signin.locked out': {
    'signin.password': {
      msg: 'This user has been locked out.',
      state: 'error'
    },
    'signin.userName': {
      msg: '',
      state: 'error'
    }
  },
  'signin.identification.any.empty': {
    'signin.userName': {
      msg: 'Please enter your username.',
      state: 'error'
    }
  },
  'signin.password.any.empty': {
    'signin.password': {
      msg: 'Please enter your password.',
      state: 'error'
    }
  },
  /* registration */
  'registration.generic.error': {
    'registration.password': {
      msg: 'Server error. Please try again later.',
      state: 'error'
    }
  },
  'registration.denied.error': {
    'registration.password': {
      msg: 'This user is not allowed to register. Please contact customer support.',
      state: 'error'
    }
  },
  'registration..spam': {
    'registration.password': {
      msg: 'Contact customer support',
      state: 'error'
    }
  },
  'registration.username.any.empty': {
    'registration.username': {
      msg: 'Please choose a username.',
      state: 'error'
    }
  },
  'registration.username.string.min': {
    'registration.username': {
      msg: 'Usernames must be at least three characters long.',
      state: 'error'
    }
  },
  'registration.username.string.max': {
    'registration.username': {
      msg: 'Usernames must be no more than 30 characters long.',
      state: 'error'
    }
  },
  'registration.email.duplicate': {
    'registration.email': {
      msg: 'This email address has already been registered.',
      state: 'error'
    }
  },
  'registration.email.string.email': {
    'registration.email': {
      msg: 'Please enter a valid email address.',
      state: 'error'
    }
  },
  'registration.email.any.empty': {
    'registration.email': {
      msg: 'Please enter an email address.',
      state: 'error'
    }
  },
  'registration.username.string.regex.base': {
    'registration.username': {
      msg: 'Usernames can only contain letters, numbers and the characters _ or -.',
      state: 'error'
    }
  },
  'registration.username.duplicate': {
    'registration.username': {
      msg: 'This username has already been taken.',
      state: 'error'
    }
  },
  'registration.password.any.empty': {
    'registration.password': {
      msg: 'Please choose a password.',
      state: 'error'
    }
  },
  'registration.password.string.min': {
    'registration.password': {
      msg: 'Your password must be at least six characters long.',
      state: 'error'
    }
  },
  'registration.firstName.any.empty': {
    'registration.firstName': {
      msg: 'Please tell us your first name.',
      state: 'error'
    }
  },
  'registration.lastName.any.empty': {
    'registration.lastName': {
      msg: 'Please tell us your last name.',
      state: 'error'
    }
  },
  /* google */
  'google.generic.error': {
    'generic.googlebutton': {
      msg: 'Google error.',
      state: 'error'
    }
  },
  'google.unauthorized': {
    'generic.googlebutton': {
      msg: 'Sorry, Google couldn\'t authorise this user.',
      state: 'error'
    }
  },
  'google.popup.closed': {
    'generic.googlebutton': {
      msg: 'The Google popup has been closed.',
      state: 'error'
    }
  },
  'google.popup.blocked': {
    'generic.googlebutton': {
      msg: 'The Google popup may have been blocked by your browser. Please check your settings.',
      state: 'error'
    }
  },
  'google.usererror': {
    'generic.googlebutton': {
      msg: 'Sorry, Google couldn\'t register or log in this user.',
      state: 'error'
    }
  },
  /* forgot-password */
  'forgot-password.generic.error': {
    'forgot-password.identification': {
      msg: 'Server error. Please try again later.',
      state: 'error'
    }
  },
  'forgot-password.denied.error': {
    'forgot-password.identification': {
      msg: 'This user is not allowed to reset the password. Please contact customer support.',
      state: 'error'
    }
  },
  'forgot-password.email.string.email': {
    'forgot-password.identification': {
      msg: 'Please enter your email address.',
      state: 'error'
    }
  },
  'forgot-password.email.any.empty': {
    'forgot-password.identification': {
      msg: 'Please enter your email address.',
      state: 'error'
    }
  },
  'forgot-password.user.not-found': {
    'forgot-password.identification': {
      msg: 'Sorry, we don\'t recognise that email address.',
      state: 'error'
    }
  },
  'forgot-password.generic.banned': {
    'forgot-password.identification': {
      msg: 'This user has been banned for an unspecified reason.',
      state: 'error'
    }
  },
  'forgot-password.banned': {
    'forgot-password.identification': {
      msg: 'This user has been banned.',
      state: 'error'
    }
  },
  'forgot-password.disapproved': {
    'forgot-password.identification': {
      msg: 'This user has been disapproved.',
      state: 'error'
    }
  },
  'forgot-password.possible spam activity': {
    'forgot-password.identification': {
      msg: 'This user has been identified as possible spammer.',
      state: 'error'
    }
  },
  'forgot-password.locked out': {
    'forgot-password.identification': {
      msg: 'This user has been locked out.',
      state: 'error'
    }
  },
  /* resend-confirmation-email */
  'resend-confirmation-email.generic.error': {
    submitted: true,
    'resend-confirmation-email': {
      msg: 'Server error. Please try again later.',
      state: 'error'
    }
  },
  'resend-confirmation-email.email.any.empty': {
    submitted: true,
    'resend-confirmation-email': {
      msg: 'Please enter an email address.',
      state: 'error'
    }
  },
  'resend-confirmation-email.email.string.email': {
    submitted: true,
    'resend-confirmation-email': {
      msg: 'Please enter a valid email address.',
      state: 'error'
    }
  },
  'resend-confirmation-email.generic-success': {
    submitted: true,
    success: true
  },
  'reset-password.invalid-token': {
    submitted: true,
    'reset-password': {
      msg: 'Sorry, that reset link didn\'t work. Please try a new one.',
      state: 'error'
    }
  },
  /* reset-password */
  'reset-password.generic.error': {
    submitted: true,
    'reset-password': {
      msg: 'Sorry, we weren\'t able to change your password. Please try again later.',
      state: 'error'
    }
  },
  'reset-password.server-error': {
    submitted: true,
    'reset-password': {
      msg: 'Sorry, we weren\'t able to change your password. Please try again later.',
      state: 'error'
    }
  },
  'reset-password.token-error': {
    submitted: true,
    'reset-password': {
      msg: 'Sorry, this link is not valid any more. Can you ask for a new one?',
      state: 'error'
    }
  },
  'reset-password.unable': {
    submitted: true,
    'reset-password': {
      msg: 'Sorry, We are unable to change the password, have you already changed it?',
      state: 'error'
    }
  },
  'reset-password.blocked': {
    submitted: true,
    'reset-password': {
      msg: 'Sorry, This user is blocked/banned. Contact customer support.',
      state: 'error'
    }
  },
  'reset-password.generic-success': {
    submitted: true,
    success: true
  },
  'edit-account.generic.error': {
    'edit-account.userType': {
      msg: 'Sorry, we weren\'t able to update your account. Please try again later.',
      state: 'error'
    },
    'edit-account.message': {
      msg: 'Sorry, we weren\'t able to update your account. Please try again later.',
      state: 'error'
    }
  },
  'edit-account.userType.any.allowOnly': {
    'edit-account.userType': {
      msg: 'The user type is not correct, please pick one',
      state: 'error'
    }
  },
  'edit-account.firstName.any.empty': {
    'edit-account.firstName': {
      msg: 'Please tell us your first name.',
      state: 'error'
    }
  },
  'edit-account.lastName.any.empty': {
    'edit-account.lastName': {
      msg: 'Please tell us your last name.',
      state: 'error'
    }
  },
  'edit-account.email.duplicate': {
    'edit-account.email': {
      msg: 'This email address has already been registered.',
      state: 'error'
    }
  },
  'edit-account.email.string.email': {
    'edit-account.email': {
      msg: 'Please enter a valid email address.',
      state: 'error'
    }
  },
  'edit-account.email.any.empty': {
    'edit-account.email': {
      msg: 'Please enter your email address.',
      state: 'error'
    }
  },
  'change-password.generic.error': {
    'change-password.password': {
      msg: 'Sorry, we weren\'t able to update your account. Please try again later.',
      state: 'error'
    }
  },
  'change-password.password.string.min': {
    'change-password.password': {
      msg: 'Your password must be at least six characters long.',
      state: 'error'
    }
  },
  'change-password.oldpassword.wrong': {
    'change-password.oldPassword': {
      msg: 'Your password is not correct, please try entering it again.',
      state: 'error'
    }
  },
  'change-password.samepassword': {
    'change-password.password': {
      msg: 'The new password is the same as the previous password.',
      state: 'error'
    }
  },
  'change-password.ok': {
    'change-password.message': {
      msg: 'You have succesfully changed your password.',
      state: 'success'
    }
  }
};

exports.default = function (codes) {
  if (!codes) return {};
  var errorCodes = codes.split(',');
  var validErrorCodes = errorCodes.filter(function (code) {
    return code in errors;
  });

  if (validErrorCodes.length === 0) {
    var prefix = errorCodes[0].split('.', 1);
    validErrorCodes.push(prefix + '.generic.error');
  }

  return validErrorCodes.map(function (code) {
    return errors[code];
  }).reduce(function (previous, current) {
    return (0, _assign2.default)({}, previous, current);
  }, {});
};

});
},{"async-define":8,"babel-runtime/core-js/object/assign":12}],157:[function(require,module,exports){
var asyncDefine = require('async-define');
asyncDefine(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function (__react,__react_dom,__redux,__react_redux){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.App = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __react;

var _react2 = _interopRequireDefault(_react);

var _Signin = require('./Signin');

var _Signin2 = _interopRequireDefault(_Signin);

var _ForgotPassword = require('./ForgotPassword');

var _ForgotPassword2 = _interopRequireDefault(_ForgotPassword);

var _SelectPosition = require('./SelectPosition');

var _SelectPosition2 = _interopRequireDefault(_SelectPosition);

var _Select = require('./Select');

var _Select2 = _interopRequireDefault(_Select);

var _LoggedInSelect = require('./LoggedInSelect');

var _LoggedInSelect2 = _interopRequireDefault(_LoggedInSelect);

var _LoggedInUpdate = require('./LoggedInUpdate');

var _LoggedInUpdate2 = _interopRequireDefault(_LoggedInUpdate);

var _Register = require('./Register');

var _Register2 = _interopRequireDefault(_Register);

var _reactRedux = __react_redux;

var _redux = __redux;

var _actions = require('../reducers/actions');

var actionCreators = _interopRequireWildcard(_actions);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function TesModalContainer(_ref) {
  var hasWrapper = _ref.hasWrapper,
      noWrapperStyle = _ref.noWrapperStyle,
      children = _ref.children;

  if (!hasWrapper) return _react2.default.createElement(
    'div',
    { style: noWrapperStyle },
    children
  );
  return _react2.default.createElement(
    'div',
    { className: 'tes-modal__body' },
    children
  );
}

TesModalContainer.propTypes = {
  hasWrapper: _react.PropTypes.bool,
  noWrapperStyle: _react.PropTypes.object
};

var App = exports.App = function (_Component) {
  (0, _inherits3.default)(App, _Component);

  function App() {
    (0, _classCallCheck3.default)(this, App);
    return (0, _possibleConstructorReturn3.default)(this, (App.__proto__ || (0, _getPrototypeOf2.default)(App)).apply(this, arguments));
  }

  (0, _createClass3.default)(App, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.props.actions.trackDisplay(this.props.common.formType);
      if (!this.props.common.isModal && !this.props.common.isInline) {
        this.props.actions.failRegister(this.props.errors);
        this.props.actions.failSignIn(this.props.errors);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props$common = this.props.common,
          isModal = _props$common.isModal,
          isSelectPosition = _props$common.isSelectPosition;

      var borderStyle = {
        border: '1px solid #c4c4c4',
        borderRadius: '4px'
      };
      var components = {
        'sign-in': _react2.default.createElement(
          TesModalContainer,
          { hasWrapper: isModal },
          _react2.default.createElement(_Signin2.default, null)
        ),
        register: _react2.default.createElement(
          TesModalContainer,
          { hasWrapper: isModal },
          _react2.default.createElement(_Register2.default, null)
        ),
        'forgot-password': _react2.default.createElement(
          TesModalContainer,
          { hasWrapper: isModal },
          _react2.default.createElement(_ForgotPassword2.default, null)
        ),
        select: isSelectPosition ? _react2.default.createElement(
          TesModalContainer,
          { hasWrapper: false, noWrapperStyle: isModal ? {} : borderStyle },
          _react2.default.createElement(_SelectPosition2.default, { onClick: function onClick() {}, action: '', method: '' })
        ) : _react2.default.createElement(
          TesModalContainer,
          { hasWrapper: isModal },
          _react2.default.createElement(_Select2.default, null)
        ),
        'logged-in-select': _react2.default.createElement(
          TesModalContainer,
          { hasWrapper: isModal },
          _react2.default.createElement(_LoggedInSelect2.default, null)
        ),
        'logged-in-update': _react2.default.createElement(
          TesModalContainer,
          { hasWrapper: isModal },
          _react2.default.createElement(_LoggedInUpdate2.default, null)
        )
      };
      var component = components[this.props.common.formType];
      return component;
    }
  }]);
  return App;
}(_react.Component);

App.propTypes = {
  common: _react.PropTypes.object.isRequired,
  errors: _react.PropTypes.object.isRequired,
  signIn: _react.PropTypes.object.isRequired,
  register: _react.PropTypes.object.isRequired,
  forgotPassword: _react.PropTypes.object.isRequired
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    actions: (0, _redux.bindActionCreators)(actionCreators, dispatch)
  };
};

exports.default = (0, _reactRedux.connect)(function (state) {
  return {
    common: state.common,
    errors: state.errors,
    signIn: state.signIn,
    register: state.register,
    forgotPassword: state.forgotPassword
  };
}, mapDispatchToProps)(App);

});
},{"../reducers/actions":176,"./ForgotPassword":158,"./LoggedInSelect":159,"./LoggedInUpdate":160,"./Register":161,"./Select":162,"./SelectPosition":165,"./Signin":166,"async-define":8,"babel-runtime/core-js/object/get-prototype-of":15,"babel-runtime/helpers/classCallCheck":21,"babel-runtime/helpers/createClass":22,"babel-runtime/helpers/inherits":23,"babel-runtime/helpers/possibleConstructorReturn":24}],158:[function(require,module,exports){
var asyncDefine = require('async-define');
asyncDefine(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function (__react,__react_dom,__redux,__react_redux){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ForgotPassword = undefined;

var _keys = require('babel-runtime/core-js/object/keys');

var _keys2 = _interopRequireDefault(_keys);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __react;

var _react2 = _interopRequireDefault(_react);

var _getErrorFromPrefix = require('../lib/getErrorFromPrefix');

var _reactRedux = __react_redux;

var _redux = __redux;

var _actions = require('../reducers/actions');

var actionCreators = _interopRequireWildcard(_actions);

var _WidgetLink = require('./lib/WidgetLink');

var _WidgetLink2 = _interopRequireDefault(_WidgetLink);

var _HiddenInputs = require('./lib/HiddenInputs');

var _HiddenInputs2 = _interopRequireDefault(_HiddenInputs);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getErrorMsg = (0, _getErrorFromPrefix.getErrorMsgFromPrefix)('forgot-password');
var getErrorCls = (0, _getErrorFromPrefix.getErrorClsFromPrefix)('forgot-password');

var ForgotPassword = exports.ForgotPassword = function (_Component) {
  (0, _inherits3.default)(ForgotPassword, _Component);

  function ForgotPassword() {
    (0, _classCallCheck3.default)(this, ForgotPassword);
    return (0, _possibleConstructorReturn3.default)(this, (ForgotPassword.__proto__ || (0, _getPrototypeOf2.default)(ForgotPassword)).apply(this, arguments));
  }

  (0, _createClass3.default)(ForgotPassword, [{
    key: 'handleSubmit',
    value: function handleSubmit(e) {
      e.preventDefault();
      this.props.actions.initForgotPassword();
    }
  }, {
    key: 'handleContinue',
    value: function handleContinue(e) {
      e.preventDefault();
      this.props.actions.successForgotPassword();
    }
  }, {
    key: 'hasError',
    value: function hasError() {
      return this.props.errors ? (0, _keys2.default)(this.props.errors).filter(function (n) {
        return n.startsWith('forgot-password.');
      }).length > 0 : false;
    }
  }, {
    key: 'changeField',
    value: function changeField(namepar, depspar) {
      var _this2 = this;

      var name = 'forgot-password.' + namepar;
      var deps = depspar.map(function (n) {
        return 'forgotpassword.' + n;
      }) || [];
      return function (e) {
        var target = e.target;
        _this2.props.actions.setField('forgotPassword', target.name, target.value);
        _this2.props.actions.changeField(name, deps);
      };
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var err = this.props.errors;

      var content = void 0;
      if (this.props.forgotPassword.state === 'sent') {
        content = _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement(
            'p',
            null,
            _react2.default.createElement(
              'strong',
              null,
              'Email sent! Please now check your inbox'
            )
          ),
          _react2.default.createElement(
            'p',
            null,
            'These emails can get caught in spam - please also check your spam folder.'
          ),
          _react2.default.createElement(
            'button',
            { onClick: function onClick(e) {
                return _this3.handleContinue(e);
              }, className: 'tes-btn tes-btn--lg tes-btn--icon tes-btn--block tes-btn--primary' },
            'Continue',
            _react2.default.createElement('span', { 'aria-hidden': 'true' })
          )
        );
      } else {
        content = _react2.default.createElement(
          'form',
          { onSubmit: function onSubmit(e) {
              return _this3.handleSubmit(e);
            }, role: 'form', method: 'post', className: 't-forgot-password-form' },
          _react2.default.createElement(_HiddenInputs2.default, null),
          _react2.default.createElement(
            'div',
            { className: getErrorCls('identification')(err) },
            _react2.default.createElement(
              'div',
              { className: 'tes-input-group' },
              _react2.default.createElement(
                'span',
                { className: 'tes-input-group__addon' },
                _react2.default.createElement('i', { className: 'icon icon-user' })
              ),
              _react2.default.createElement('input', { type: 'text', onChange: this.changeField('identification', []),
                name: 'identification',
                autoFocus: 'true',
                placeholder: 'email',
                value: this.props.forgotPassword.identification,
                className: 'tes-control tes-control--group identification-field t-identification'
              })
            ),
            _react2.default.createElement(
              'div',
              { className: 'tes-help-block' },
              getErrorMsg('identification')(err)
            )
          ),
          _react2.default.createElement(
            'div',
            { className: 'margin-top-md margin-bottom-sm' },
            _react2.default.createElement(
              'button',
              { disabled: this.props.forgotPassword.state === 'wait' ? 'disabled' : null, type: 'submit', className: 'tes-btn tes-btn--lg tes-btn--icon tes-btn--block tes-btn--primary forgot-password-submit' },
              this.props.forgotPassword.state === 'wait' ? _react2.default.createElement('i', { className: 'icon-spin icon-spinner icon-white' }) : 'Send'
            )
          )
        );
      }
      return _react2.default.createElement(
        'div',
        { id: 'sign-in', className: 'padding-left-md padding-right-md padding-bottom-xs margin-bottom-xs' },
        _react2.default.createElement(
          'div',
          { className: 'heading-main margin-bottom-md text-center' },
          _react2.default.createElement(
            'h3',
            { className: 'tes-modal__heading' },
            'Recover your password'
          ),
          _react2.default.createElement(
            'p',
            null,
            'Send us your email and we will send you instructions to reset your password.'
          )
        ),
        content,
        _react2.default.createElement(
          'div',
          { className: 'clearfix' },
          _react2.default.createElement(
            'div',
            { className: 'more-info text-center text-sm padding-top-sm border-top' },
            _react2.default.createElement(
              'span',
              null,
              'Remember your password?'
            ),
            _react2.default.createElement(
              'span',
              null,
              ' '
            ),
            _react2.default.createElement(
              _WidgetLink2.default,
              { formType: 'signIn' },
              'Log in now!'
            )
          )
        )
      );
    }
  }]);
  return ForgotPassword;
}(_react.Component);

ForgotPassword.propTypes = {
  common: _react.PropTypes.object.isRequired,
  errors: _react.PropTypes.object.isRequired,
  signIn: _react.PropTypes.object.isRequired,
  register: _react.PropTypes.object.isRequired,
  forgotPassword: _react.PropTypes.object.isRequired
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    actions: (0, _redux.bindActionCreators)(actionCreators, dispatch)
  };
};

exports.default = (0, _reactRedux.connect)(function (state) {
  return {
    common: state.common,
    errors: state.errors,
    signIn: state.signIn,
    register: state.register,
    forgotPassword: state.forgotPassword
  };
}, mapDispatchToProps)(ForgotPassword);

});
},{"../lib/getErrorFromPrefix":172,"../reducers/actions":176,"./lib/HiddenInputs":167,"./lib/WidgetLink":169,"async-define":8,"babel-runtime/core-js/object/get-prototype-of":15,"babel-runtime/core-js/object/keys":16,"babel-runtime/helpers/classCallCheck":21,"babel-runtime/helpers/createClass":22,"babel-runtime/helpers/inherits":23,"babel-runtime/helpers/possibleConstructorReturn":24}],159:[function(require,module,exports){
var asyncDefine = require('async-define');
asyncDefine(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function (__react,__react_dom,__redux,__react_redux){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LoggedInSelect = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __react;

var _react2 = _interopRequireDefault(_react);

var _SelectForm = require('./SelectForm');

var _SelectForm2 = _interopRequireDefault(_SelectForm);

var _reactRedux = __react_redux;

var _redux = __redux;

var _actions = require('../reducers/actions');

var actionCreators = _interopRequireWildcard(_actions);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LoggedInSelect = exports.LoggedInSelect = function (_Component) {
  (0, _inherits3.default)(LoggedInSelect, _Component);

  function LoggedInSelect() {
    (0, _classCallCheck3.default)(this, LoggedInSelect);
    return (0, _possibleConstructorReturn3.default)(this, (LoggedInSelect.__proto__ || (0, _getPrototypeOf2.default)(LoggedInSelect)).apply(this, arguments));
  }

  (0, _createClass3.default)(LoggedInSelect, [{
    key: 'setTo',
    value: function setTo(e, userType) {
      if (!this.props.common.isModal && !this.props.common.isInline) return;
      e.preventDefault();
      this.props.actions.updateUserData({ userType: userType });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      return _react2.default.createElement(_SelectForm2.default, {
        onStudentClick: function onStudentClick(e) {
          return _this2.setTo(e, 'student');
        },
        onTeacherClick: function onTeacherClick(e) {
          return _this2.setTo(e, 'teacher');
        },
        onOtherClick: function onOtherClick(e) {
          return _this2.setTo(e, 'other');
        },
        action: '/api/authn/edit-account',
        method: 'post'
      });
    }
  }]);
  return LoggedInSelect;
}(_react.Component);

LoggedInSelect.propTypes = {
  common: _react.PropTypes.object.isRequired
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    actions: (0, _redux.bindActionCreators)(actionCreators, dispatch)
  };
};

exports.default = (0, _reactRedux.connect)(function (state) {
  return {
    common: state.common
  };
}, mapDispatchToProps)(LoggedInSelect);

});
},{"../reducers/actions":176,"./SelectForm":163,"async-define":8,"babel-runtime/core-js/object/get-prototype-of":15,"babel-runtime/helpers/classCallCheck":21,"babel-runtime/helpers/createClass":22,"babel-runtime/helpers/inherits":23,"babel-runtime/helpers/possibleConstructorReturn":24}],160:[function(require,module,exports){
var asyncDefine = require('async-define');
asyncDefine(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function (__react,__react_dom,__redux,__react_redux){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LoggedInUpdate = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __react;

var _react2 = _interopRequireDefault(_react);

var _getErrorFromPrefix = require('../lib/getErrorFromPrefix');

var _reactRedux = __react_redux;

var _redux = __redux;

var _actions = require('../reducers/actions');

var actionCreators = _interopRequireWildcard(_actions);

var _InputField = require('./lib/InputField');

var _InputField2 = _interopRequireDefault(_InputField);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getErrorMsg = (0, _getErrorFromPrefix.getErrorMsgFromPrefix)('edit-account');
var getErrorCls = (0, _getErrorFromPrefix.getErrorClsFromPrefix)('edit-account');

var LoggedInUpdate = exports.LoggedInUpdate = function (_Component) {
  (0, _inherits3.default)(LoggedInUpdate, _Component);

  function LoggedInUpdate(props) {
    (0, _classCallCheck3.default)(this, LoggedInUpdate);

    var _this = (0, _possibleConstructorReturn3.default)(this, (LoggedInUpdate.__proto__ || (0, _getPrototypeOf2.default)(LoggedInUpdate)).call(this, props));

    _this.state = {
      firstName: '',
      lastName: '',
      email: '',
      userType: _this.props.common.userType
    };
    return _this;
  }

  (0, _createClass3.default)(LoggedInUpdate, [{
    key: 'onChange',
    value: function onChange(e, name) {
      var data = {};
      data[name] = e.target.value;
      this.setState(data);
    }
  }, {
    key: 'getActiveFields',
    value: function getActiveFields() {
      var variants = {
        fullname: {
          title: 'Please add your full name',
          helpLink: 'Why are you being asked for your name?',
          helpText: 'This section of our site requires your name as you will be interacting with schools, institutions or other members of TES in a professional context. Using your actual name here improves the service and will allow you to interact with others with greater transparency and trust.',
          validFields: ['firstName', 'lastName']
        },
        email: {
          title: 'Please add your email',
          validFields: ['email', 'userType']
        }
      };

      if (!variants[this.props.common.variant]) {
        return variants.fullname;
      }
      return variants[this.props.common.variant];
    }
  }, {
    key: 'handleSubmit',
    value: function handleSubmit(e) {
      if (!this.props.common.isModal && !this.props.common.isInline) return;
      e.preventDefault();

      var activeFields = this.getActiveFields();
      var hasField = function hasField(name) {
        return activeFields.validFields.indexOf(name) !== -1;
      };

      var data = {};
      if (hasField('firstName')) {
        data.firstName = this.state.firstName;
      }
      if (hasField('lastName')) {
        data.lastName = this.state.lastName;
      }
      if (hasField('email')) {
        data.email = this.state.email;
      }
      if (hasField('userType')) {
        data.userType = this.state.userType;
      }
      this.props.actions.resetErrors();
      this.props.actions.updateUserData(data);
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var err = this.props.errors;
      var activeFields = this.getActiveFields();
      var hasField = function hasField(name) {
        return activeFields.validFields.indexOf(name) !== -1;
      };

      return _react2.default.createElement(
        'div',
        { id: 'logged-in-update', className: 'padding-left-md padding-right-md padding-bottom-xs margin-bottom-xs' },
        _react2.default.createElement(
          'div',
          { className: 'heading-main margin-bottom-md text-center' },
          _react2.default.createElement(
            'h3',
            { className: 'tes-modal__heading' },
            activeFields.title
          )
        ),
        _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement(
            'form',
            { autoComplete: 'off', role: 'form', onSubmit: function onSubmit(e) {
                return _this2.handleSubmit(e);
              }, className: 't-logged-in-update margin-bottom-md', method: 'post', action: '/api/authn/edit-account' },
            this.props.common.rtn ? _react2.default.createElement('input', { type: 'hidden', name: 'rtn', value: encodeURIComponent(this.props.common.rtn) }) : null,
            hasField('userType') && this.props.common.userType ? _react2.default.createElement('input', { className: 't-user-type', type: 'hidden', name: 'userType', ref: 'userType', value: this.props.common.userType }) : null,
            _react2.default.createElement('input', { type: 'hidden', name: 'appId', value: this.props.common.appId }),
            _react2.default.createElement('input', { type: 'hidden', name: '_CSRF_TOKEN', value: this.props.common.csrfToken }),
            _react2.default.createElement(
              'div',
              { className: 'row' },
              _react2.default.createElement(
                'div',
                { className: 'col-xs-12 col-sm-6' },
                hasField('firstName') ? _react2.default.createElement(_InputField2.default, {
                  name: 'firstName', label: 'First name', value: this.state.firstName,
                  errorClass: getErrorCls('firstName')(err),
                  errorMessage: getErrorMsg('firstName')(err),
                  onChange: function onChange(e) {
                    return _this2.onChange(e, 'firstName');
                  },
                  autoFocus: 'true'
                }) : null
              ),
              _react2.default.createElement(
                'div',
                { className: 'col-xs-12 col-sm-6' },
                hasField('lastName') ? _react2.default.createElement(_InputField2.default, {
                  name: 'firstName', label: 'Last name', value: this.state.lastName,
                  errorClass: getErrorCls('lastName')(err),
                  errorMessage: getErrorMsg('lastName')(err),
                  onChange: function onChange(e) {
                    return _this2.onChange(e, 'lastName');
                  }
                }) : null
              )
            ),
            hasField('email') ? _react2.default.createElement(_InputField2.default, {
              name: 'email',
              label: this.props.common.userType === 'student' ? 'Email (optional)' : 'Email',
              value: this.state.email,
              errorClass: getErrorCls('email')(err),
              errorMessage: getErrorMsg('email')(err),
              onChange: function onChange(e) {
                return _this2.onChange(e, 'email');
              }
            }) : null,
            activeFields.helpLink ? _react2.default.createElement(
              'div',
              { className: 'margin-bottom-xs' },
              _react2.default.createElement(
                'span',
                { className: 'link link--colored text-xs', title: activeFields.helpText },
                activeFields.helpLink
              )
            ) : null,
            _react2.default.createElement(
              'div',
              null,
              _react2.default.createElement(
                'button',
                { type: 'submit', className: 'tes-btn tes-btn--icon tes-btn--lg tes-btn--block tes-btn--primary' },
                'Confirm'
              )
            )
          )
        )
      );
    }
  }]);
  return LoggedInUpdate;
}(_react.Component);

LoggedInUpdate.propTypes = {
  common: _react.PropTypes.object.isRequired,
  errors: _react.PropTypes.object.isRequired
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    actions: (0, _redux.bindActionCreators)(actionCreators, dispatch)
  };
};

exports.default = (0, _reactRedux.connect)(function (state) {
  return {
    common: state.common,
    errors: state.errors
  };
}, mapDispatchToProps)(LoggedInUpdate);

});
},{"../lib/getErrorFromPrefix":172,"../reducers/actions":176,"./lib/InputField":168,"async-define":8,"babel-runtime/core-js/object/get-prototype-of":15,"babel-runtime/helpers/classCallCheck":21,"babel-runtime/helpers/createClass":22,"babel-runtime/helpers/inherits":23,"babel-runtime/helpers/possibleConstructorReturn":24}],161:[function(require,module,exports){
var asyncDefine = require('async-define');
asyncDefine(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function (__react,__react_dom,__redux,__react_redux){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Register = undefined;

var _keys = require('babel-runtime/core-js/object/keys');

var _keys2 = _interopRequireDefault(_keys);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __react;

var _react2 = _interopRequireDefault(_react);

var _getErrorFromPrefix = require('../lib/getErrorFromPrefix');

var _reactRedux = __react_redux;

var _redux = __redux;

var _actions = require('../reducers/actions');

var actionCreators = _interopRequireWildcard(_actions);

var _WidgetLink = require('./lib/WidgetLink');

var _WidgetLink2 = _interopRequireDefault(_WidgetLink);

var _HiddenInputs = require('./lib/HiddenInputs');

var _HiddenInputs2 = _interopRequireDefault(_HiddenInputs);

var _InputField = require('./lib/InputField');

var _InputField2 = _interopRequireDefault(_InputField);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getErrorMsg = (0, _getErrorFromPrefix.getErrorMsgFromPrefix)('registration');
var getErrorCls = (0, _getErrorFromPrefix.getErrorClsFromPrefix)('registration');
var getGenericErrorMsg = (0, _getErrorFromPrefix.getErrorMsgFromPrefix)('generic');
var getGenericErrorCls = (0, _getErrorFromPrefix.getErrorClsFromPrefix)('generic');

var Register = exports.Register = function (_Component) {
  (0, _inherits3.default)(Register, _Component);

  function Register() {
    (0, _classCallCheck3.default)(this, Register);
    return (0, _possibleConstructorReturn3.default)(this, (Register.__proto__ || (0, _getPrototypeOf2.default)(Register)).apply(this, arguments));
  }

  (0, _createClass3.default)(Register, [{
    key: 'getGoogleLogoURL',
    value: function getGoogleLogoURL() {
      return this.props.common.cdnUrl + 'img/google-logo-g.png';
    }
  }, {
    key: 'changeField',
    value: function changeField(namepar, depspar) {
      var _this2 = this;

      var name = 'registration.' + namepar;
      var deps = depspar.map(function (n) {
        return 'registration.' + n;
      }) || [];
      return function (e) {
        var target = e.target;
        _this2.props.actions.setField('register', target.name, target.type === 'checkbox' || target.type === 'radio' ? target.checked : target.value);
        _this2.props.actions.changeField(name, deps);
        _this2.props.actions.validateField(name);
      };
    }
  }, {
    key: 'hasError',
    value: function hasError() {
      return this.props.errors ? (0, _keys2.default)(this.props.errors).filter(function (n) {
        return n.startsWith('registration.');
      }).length > 0 : false;
    }
  }, {
    key: 'handleGoogle',
    value: function handleGoogle() {
      this.props.actions.initGoogleSignIn();
    }
  }, {
    key: 'handleSubmit',
    value: function handleSubmit(e) {
      e.preventDefault();
      var target = e.target;
      this.props.actions.initRegister(function () {
        target.submit(); // only called for pages
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var err = this.props.errors;
      var hasName = !this.props.common.omitName;

      return _react2.default.createElement(
        'div',
        { id: 'sign-in', className: 'padding-left-md padding-right-md padding-bottom-xs margin-bottom-xs' },
        _react2.default.createElement(
          'div',
          { className: 'heading-main margin-bottom-md text-center' },
          _react2.default.createElement(
            'h3',
            { className: 'tes-modal__heading' },
            'Join TES for free'
          )
        ),
        _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement(
            'div',
            { className: 'row' },
            _react2.default.createElement(
              'div',
              { className: 'col-xs-12' },
              _react2.default.createElement(
                'button',
                {
                  disabled: this.props.register.state === 'wait' || this.props.common.googleState === 'wait' ? 'disabled' : null,
                  onClick: function onClick(e) {
                    return _this3.handleGoogle(e);
                  },
                  className: 'tes-btn tes-btn--secondary tes-btn--icon tes-btn--block'
                },
                this.props.common.googleState === 'wait' ? _react2.default.createElement('i', { className: 'icon-spin icon-spinner tes-btn__icon' }) : _react2.default.createElement(
                  'span',
                  { className: 'text-sm' },
                  _react2.default.createElement('img', { style: { padding: '0 6px 2px 0' }, src: this.getGoogleLogoURL() }),
                  ' Register with Google'
                )
              )
            )
          ),
          _react2.default.createElement(
            'form',
            { autoComplete: 'off', role: 'form', onSubmit: function onSubmit(e) {
                return _this3.handleSubmit(e);
              }, className: 't-register-form margin-bottom-md', method: 'post', action: '/api/authn/register-redirect' },
            _react2.default.createElement(_HiddenInputs2.default, null),
            _react2.default.createElement(
              'div',
              { className: 'separator' },
              _react2.default.createElement(
                'span',
                { className: 'separator--text bg-light' },
                'or'
              )
            ),
            hasName ? _react2.default.createElement(
              'div',
              { className: 'row' },
              _react2.default.createElement(
                'div',
                { className: 'col-xs-12 col-sm-6' },
                _react2.default.createElement(_InputField2.default, {
                  name: 'firstName', label: 'First name', value: this.props.register.firstName,
                  errorClass: getErrorCls('firstName')(err),
                  errorMessage: getErrorMsg('firstName')(err),
                  onChange: this.changeField('firstName', [])
                })
              ),
              _react2.default.createElement(
                'div',
                { className: 'col-xs-12 col-sm-6' },
                _react2.default.createElement(_InputField2.default, {
                  name: 'lastName', label: 'Last name', value: this.props.register.lastName,
                  errorClass: getErrorCls('lastName')(err),
                  errorMessage: getErrorMsg('lastName')(err),
                  onChange: this.changeField('lastName', [])
                })
              )
            ) : null,
            _react2.default.createElement(_InputField2.default, {
              name: 'email',
              label: this.props.common.userType === 'student' ? 'Email (optional)' : 'Email',
              value: this.props.register.email,
              errorClass: getErrorCls('email')(err),
              errorMessage: getErrorMsg('email')(err),
              onChange: this.changeField('email', []),
              type: 'email'
            }),
            _react2.default.createElement(_InputField2.default, {
              name: 'username',
              label: 'Username',
              value: this.props.register.username,
              errorClass: getErrorCls('username')(err),
              errorMessage: getErrorMsg('username')(err),
              onChange: this.changeField('username', [])
            }),
            _react2.default.createElement(_InputField2.default, {
              name: 'password',
              label: 'password',
              value: this.props.register.password,
              errorClass: getErrorCls('password')(err),
              errorMessage: getErrorMsg('password')(err),
              onChange: this.changeField('password', []),
              type: 'password'
            }),
            this.props.common.userType !== 'student' ? _react2.default.createElement(
              'div',
              { className: 'tes-checkbox tes-checkbox--inline text-sm margin-bottom-sm' },
              _react2.default.createElement(
                'label',
                { className: 'tes-control-label text-xs' },
                _react2.default.createElement('input', { onChange: this.changeField('newsletter', []),
                  type: 'checkbox', name: 'newsletter',
                  className: 't-newsletter',
                  value: 'true',
                  checked: this.props.register.newsletter
                }),
                ' Uncheck this box if you do not want to receive news and updates from TES'
              )
            ) : null,
            _react2.default.createElement(
              'div',
              null,
              _react2.default.createElement(
                'button',
                { disabled: this.props.register.state === 'wait' || this.props.common.googleState === 'wait' ? 'disabled' : null,
                  type: 'submit', className: 'tes-btn tes-btn--icon tes-btn--lg sign-up-submit tes-btn--block tes-btn--primary'
                },
                this.props.register.state === 'wait' ? _react2.default.createElement('i', { className: 'icon-spin icon-spinner icon-white tes-btn__icon' }) : 'Register'
              )
            )
          ),
          _react2.default.createElement(
            'div',
            { className: 'row' },
            _react2.default.createElement(
              'div',
              { className: 'text-secondary col-xs-12', style: { paddingRight: 0 } },
              _react2.default.createElement(
                'div',
                { className: 'margin-bottom-md' },
                'By registering, you are agreeing to our ',
                _react2.default.createElement(
                  'a',
                  { target: '_blank', href: 'https://www.tes.com/content/terms-and-conditions' },
                  'terms and conditions'
                ),
                ' and ',
                _react2.default.createElement(
                  'a',
                  { target: '_blank', href: 'https://www.tes.com/us/privacy-policy' },
                  'privacy policy'
                )
              )
            )
          ),
          getGenericErrorCls('googlebutton')(err) ? _react2.default.createElement(
            'div',
            { className: 'row' },
            _react2.default.createElement(
              'div',
              { className: 'tes-has-error col-xs-12' },
              _react2.default.createElement(
                'div',
                { className: 'tes-help-block' },
                getGenericErrorMsg('googlebutton')(err)
              )
            )
          ) : null
        ),
        _react2.default.createElement(
          'div',
          { className: 'clearfix' },
          _react2.default.createElement(
            'div',
            { className: 'more-info text-center text-sm padding-top-md border-top' },
            _react2.default.createElement(
              'span',
              null,
              'Already have a TES account?'
            ),
            _react2.default.createElement(
              'span',
              null,
              ' '
            ),
            _react2.default.createElement(
              _WidgetLink2.default,
              { formType: 'signIn' },
              'Log in now!'
            )
          )
        )
      );
    }
  }]);
  return Register;
}(_react.Component);

Register.propTypes = {
  common: _react.PropTypes.object.isRequired,
  errors: _react.PropTypes.object.isRequired,
  register: _react.PropTypes.object.isRequired
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    actions: (0, _redux.bindActionCreators)(actionCreators, dispatch)
  };
};

exports.default = (0, _reactRedux.connect)(function (state) {
  return {
    common: state.common,
    errors: state.errors,
    register: state.register
  };
}, mapDispatchToProps)(Register);

});
},{"../lib/getErrorFromPrefix":172,"../reducers/actions":176,"./lib/HiddenInputs":167,"./lib/InputField":168,"./lib/WidgetLink":169,"async-define":8,"babel-runtime/core-js/object/get-prototype-of":15,"babel-runtime/core-js/object/keys":16,"babel-runtime/helpers/classCallCheck":21,"babel-runtime/helpers/createClass":22,"babel-runtime/helpers/inherits":23,"babel-runtime/helpers/possibleConstructorReturn":24}],162:[function(require,module,exports){
var asyncDefine = require('async-define');
asyncDefine(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function (__react,__react_dom,__redux,__react_redux){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Select = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __react;

var _react2 = _interopRequireDefault(_react);

var _SelectForm = require('./SelectForm');

var _SelectForm2 = _interopRequireDefault(_SelectForm);

var _reactRedux = __react_redux;

var _redux = __redux;

var _actions = require('../reducers/actions');

var actionCreators = _interopRequireWildcard(_actions);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Select = exports.Select = function (_Component) {
  (0, _inherits3.default)(Select, _Component);

  function Select() {
    (0, _classCallCheck3.default)(this, Select);
    return (0, _possibleConstructorReturn3.default)(this, (Select.__proto__ || (0, _getPrototypeOf2.default)(Select)).apply(this, arguments));
  }

  (0, _createClass3.default)(Select, [{
    key: 'switchTo',
    value: function switchTo(e, userType) {
      if (!this.props.common.isModal && !this.props.common.isInline) return;
      e.preventDefault();
      this.props.actions.setUserType(userType);
      this.props.actions.initSetFormType('register');
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      return _react2.default.createElement(_SelectForm2.default, {
        onStudentClick: function onStudentClick(e) {
          return _this2.switchTo(e, 'student');
        },
        onTeacherClick: function onTeacherClick(e) {
          return _this2.switchTo(e, 'teacher');
        },
        onOtherClick: function onOtherClick(e) {
          return _this2.switchTo(e, 'other');
        },
        action: '/authn/register',
        method: 'get'
      });
    }
  }]);
  return Select;
}(_react.Component);

Select.propTypes = {
  common: _react.PropTypes.object.isRequired
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    actions: (0, _redux.bindActionCreators)(actionCreators, dispatch)
  };
};

exports.default = (0, _reactRedux.connect)(function (state) {
  return {
    common: state.common
  };
}, mapDispatchToProps)(Select);

});
},{"../reducers/actions":176,"./SelectForm":163,"async-define":8,"babel-runtime/core-js/object/get-prototype-of":15,"babel-runtime/helpers/classCallCheck":21,"babel-runtime/helpers/createClass":22,"babel-runtime/helpers/inherits":23,"babel-runtime/helpers/possibleConstructorReturn":24}],163:[function(require,module,exports){
var asyncDefine = require('async-define');
asyncDefine(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function (__react,__react_dom,__redux,__react_redux){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SelectForm = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __react;

var _react2 = _interopRequireDefault(_react);

var _getErrorFromPrefix = require('../lib/getErrorFromPrefix');

var _reactRedux = __react_redux;

var _redux = __redux;

var _actions = require('../reducers/actions');

var actionCreators = _interopRequireWildcard(_actions);

var _HiddenInputs = require('./lib/HiddenInputs');

var _HiddenInputs2 = _interopRequireDefault(_HiddenInputs);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getErrorMsg = (0, _getErrorFromPrefix.getErrorMsgFromPrefix)('edit-account');
var getErrorCls = (0, _getErrorFromPrefix.getErrorClsFromPrefix)('edit-account');

var SelectForm = exports.SelectForm = function (_Component) {
  (0, _inherits3.default)(SelectForm, _Component);

  function SelectForm() {
    (0, _classCallCheck3.default)(this, SelectForm);
    return (0, _possibleConstructorReturn3.default)(this, (SelectForm.__proto__ || (0, _getPrototypeOf2.default)(SelectForm)).apply(this, arguments));
  }

  (0, _createClass3.default)(SelectForm, [{
    key: 'onMouseOver',
    value: function onMouseOver(evt) {
      evt.target.style.opacity = '0.9';
    }
  }, {
    key: 'onMouseOut',
    value: function onMouseOut(evt) {
      evt.target.style.opacity = '1';
    }
  }, {
    key: 'render',
    value: function render() {
      var err = this.props.errors;
      var buttonStyle = { position: 'relative', marginTop: -25 };
      var imgStyle = { width: '100%' }; // for FF on MAC

      return _react2.default.createElement(
        'div',
        { className: 'padding-left-md padding-right-md t-select-form' },
        _react2.default.createElement(
          'div',
          { className: 'row' },
          _react2.default.createElement(
            'div',
            { className: 'col-xs-6' },
            _react2.default.createElement(
              'form',
              { className: 't-student-form app-authentication-select-form',
                action: this.props.action, method: this.props.method,
                onSubmit: this.props.onStudentClick
              },
              _react2.default.createElement('input', { className: 't-userType', type: 'hidden', name: 'userType', value: 'student' }),
              _react2.default.createElement(_HiddenInputs2.default, { isGetRequest: this.props.method.toLowerCase() === 'get', noUserType: true }),
              _react2.default.createElement(
                'button',
                { className: 'tes-btn' },
                _react2.default.createElement('img', {
                  onMouseOver: this.onMouseOver,
                  onMouseOut: this.onMouseOut,
                  height: '442',
                  width: '370',
                  className: 'img-responsive',
                  title: 'Student',
                  alt: 'Student',
                  style: imgStyle,
                  src: this.props.common.cdnUrl + 'img/student2x.png'
                })
              ),
              _react2.default.createElement(
                'button',
                {
                  className: 'tes-btn tes-btn--primary tes-btn--block tes-btn--xl hidden-xs t-switch-student',
                  style: buttonStyle
                },
                _react2.default.createElement(
                  'strong',
                  null,
                  'I\'m a student'
                )
              ),
              _react2.default.createElement(
                'button',
                {
                  className: 'tes-btn tes-btn--primary tes-btn--block tes-btn--sm visible-xs',
                  style: buttonStyle
                },
                _react2.default.createElement(
                  'strong',
                  null,
                  'I\'m a student'
                )
              )
            )
          ),
          _react2.default.createElement(
            'div',
            { className: 'col-xs-6' },
            _react2.default.createElement(
              'form',
              { className: 't-teacher-form app-authentication-select-form',
                action: this.props.action, method: this.props.method,
                onSubmit: this.props.onTeacherClick
              },
              _react2.default.createElement('input', { className: 't-userType', type: 'hidden', name: 'userType', value: 'teacher' }),
              _react2.default.createElement(_HiddenInputs2.default, { isGetRequest: this.props.method.toLowerCase() === 'get', noUserType: true }),
              _react2.default.createElement(
                'button',
                { className: 'tes-btn' },
                _react2.default.createElement('img', {
                  onMouseOver: this.onMouseOver,
                  onMouseOut: this.onMouseOut,
                  height: '442',
                  width: '370',
                  className: 'img-responsive',
                  title: 'Teacher',
                  alt: 'Teacher',
                  style: imgStyle,
                  src: this.props.common.cdnUrl + 'img/teacher2x.png'
                })
              ),
              _react2.default.createElement(
                'button',
                {
                  className: 'tes-btn tes-btn--primary tes-btn--block tes-btn--xl hidden-xs t-switch-teacher',
                  style: buttonStyle
                },
                _react2.default.createElement(
                  'strong',
                  null,
                  'I\'m a teacher'
                )
              ),
              _react2.default.createElement(
                'button',
                {
                  className: 'tes-btn tes-btn--primary tes-btn--block tes-btn--sm visible-xs',
                  style: buttonStyle
                },
                _react2.default.createElement(
                  'strong',
                  null,
                  'I\'m a teacher'
                )
              )
            )
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'row' },
          _react2.default.createElement(
            'div',
            { className: 'col-xs-12 text-center text-sm' },
            _react2.default.createElement(
              'div',
              { className: 'border-top padding-top-sm margin-top-md' },
              _react2.default.createElement(
                'form',
                { className: 'app-authentication-select-form t-other-form',
                  action: this.props.action, method: this.props.method,
                  onSubmit: this.props.onOtherClick
                },
                _react2.default.createElement('input', { className: 't-userType', type: 'hidden', name: 'userType', value: 'other' }),
                _react2.default.createElement(_HiddenInputs2.default, { isGetRequest: this.props.method.toLowerCase() === 'get', noUserType: true }),
                _react2.default.createElement(
                  'button',
                  { className: 'tes-btn link link--coloured t-switch-other' },
                  'I\'m a parent, school leader, student teacher, or someone else'
                )
              )
            )
          )
        ),
        _react2.default.createElement(
          'div',
          { className: getErrorCls('message')(err) },
          _react2.default.createElement(
            'div',
            { className: 'tes-help-block text-center' },
            getErrorMsg('message')(err)
          )
        )
      );
    }
  }]);
  return SelectForm;
}(_react.Component);

SelectForm.propTypes = {
  common: _react.PropTypes.object.isRequired,
  errors: _react.PropTypes.object.isRequired,
  onStudentClick: _react.PropTypes.func.isRequired,
  onTeacherClick: _react.PropTypes.func.isRequired,
  onOtherClick: _react.PropTypes.func.isRequired,
  action: _react.PropTypes.string.isRequired,
  method: _react.PropTypes.string.isRequired
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    actions: (0, _redux.bindActionCreators)(actionCreators, dispatch)
  };
};

exports.default = (0, _reactRedux.connect)(function (state) {
  return {
    common: state.common,
    errors: state.errors
  };
}, mapDispatchToProps)(SelectForm);

});
},{"../lib/getErrorFromPrefix":172,"../reducers/actions":176,"./lib/HiddenInputs":167,"async-define":8,"babel-runtime/core-js/object/get-prototype-of":15,"babel-runtime/helpers/classCallCheck":21,"babel-runtime/helpers/createClass":22,"babel-runtime/helpers/inherits":23,"babel-runtime/helpers/possibleConstructorReturn":24}],164:[function(require,module,exports){
var asyncDefine = require('async-define');
asyncDefine(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function (__react,__react_dom,__redux,__react_redux){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SelectFormPosition = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __react;

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __react_redux;

var _redux = __redux;

var _actions = require('../reducers/actions');

var actionCreators = _interopRequireWildcard(_actions);

var _HiddenInputs = require('./lib/HiddenInputs');

var _HiddenInputs2 = _interopRequireDefault(_HiddenInputs);

var _WidgetLink = require('./lib/WidgetLink');

var _WidgetLink2 = _interopRequireDefault(_WidgetLink);

var _positionFilter = require('../lib/position-filter');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SelectFormPosition = exports.SelectFormPosition = function (_Component) {
  (0, _inherits3.default)(SelectFormPosition, _Component);

  function SelectFormPosition(props) {
    (0, _classCallCheck3.default)(this, SelectFormPosition);

    var _this = (0, _possibleConstructorReturn3.default)(this, (SelectFormPosition.__proto__ || (0, _getPrototypeOf2.default)(SelectFormPosition)).call(this, props));

    var positions = props.refdata.positions;
    var careers = props.refdata.careers;
    var currentPosition = props.common.position;
    var currentCareerObj = (0, _positionFilter.careerFinder)(positions, careers, currentPosition);

    _this.state = { currentCareerObj: currentCareerObj };
    return _this;
  }

  (0, _createClass3.default)(SelectFormPosition, [{
    key: 'onChangeCareer',
    value: function onChangeCareer(e) {
      var currentCareer = e.target.value;
      var filteredCareers = this.props.refdata.careers.filter(function (item) {
        return currentCareer === item.name;
      });
      var currentCareerObj = filteredCareers.length ? filteredCareers[0] : { name: '', groupLabel: null };

      this.setState({ currentCareerObj: currentCareerObj });

      var positions = this.props.refdata.positions;
      var validPosition = (0, _positionFilter.filterPosition)(positions, currentCareerObj);

      var newPosition = validPosition.length === 1 ? validPosition[0].name : '';
      var newUserType = validPosition.length === 1 ? validPosition[0].userType : 'other';
      this.props.actions.setPosition(newPosition, newUserType);
    }
  }, {
    key: 'onChangePosition',
    value: function onChangePosition(e) {
      var newPosition = e.target.value;
      var positions = this.props.refdata.positions;
      var filteredPositions = positions.filter(function (p) {
        return newPosition === p.name;
      });

      var newUserType = filteredPositions.length ? filteredPositions[0].userType : 'other';
      this.props.actions.setPosition(newPosition, newUserType);
    }
  }, {
    key: 'onSubmit',
    value: function onSubmit(e) {
      if (!this.props.common.isModal && !this.props.common.isInline) return;
      e.preventDefault();
      var position = this.props.common.position;
      var userType = (0, _positionFilter.getUserTypePosition)(this.props.refdata.positions, position);

      this.props.actions.setUserType(userType);

      if (this.props.isStandAlone) {
        this.props.actions.updateUserData({ userType: userType, position: position });
      } else {
        this.props.actions.initSetFormType('register');
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props$refdata = this.props.refdata,
          positions = _props$refdata.positions,
          careers = _props$refdata.careers;

      var currentPosition = this.props.common.position;
      var currentCareerObj = this.state.currentCareerObj;

      var positionOptions = (0, _positionFilter.filterPosition)(positions, currentCareerObj).map(function (pos) {
        return {
          label: pos.name,
          value: pos.name
        };
      });

      positionOptions.unshift({
        label: 'Choose a position',
        value: ''
      });
      var careerOptions = careers.filter(function (pos) {
        return ['Teacher', 'Student Teacher', 'School Leader', 'Support Staff', 'Parent', 'Student', 'Other Position'].includes(pos.name);
      }).map(function (pos) {
        return {
          label: pos.name,
          value: pos.name
        };
      });

      careerOptions.unshift({
        label: 'Choose your role',
        value: ''
      });

      return _react2.default.createElement(
        'div',
        { id: 'select-position' },
        _react2.default.createElement(
          'div',
          { className: 'tes-modal__body_top' },
          _react2.default.createElement(
            'div',
            { className: 'padding-left-md padding-right-md padding-bottom-xs margin-bottom-xs' },
            _react2.default.createElement(
              'div',
              { className: 'heading-main text-center' },
              _react2.default.createElement(
                'h3',
                { className: 'tes-modal__heading' },
                'Join TES for free'
              )
            )
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'tes-modal__body_middle bg-blue-pattern' },
          _react2.default.createElement(
            'div',
            { className: 'padding-md' },
            _react2.default.createElement(
              'div',
              null,
              _react2.default.createElement(
                'h4',
                { className: 'tes-modal__heading text-white' },
                _react2.default.createElement(
                  'strong',
                  null,
                  'What is your role?'
                )
              )
            ),
            _react2.default.createElement(
              'form',
              { autoComplete: 'off', className: 't-student-form app-authentication-select-form',
                action: this.props.action, method: this.props.method,
                onSubmit: this.props.onSubmit
              },
              _react2.default.createElement(_HiddenInputs2.default, { isGetRequest: this.props.method.toLowerCase() === 'get', noPosition: true }),
              _react2.default.createElement(
                'div',
                { className: 'padding-bottom-md' },
                _react2.default.createElement(
                  'select',
                  {
                    autoComplete: 'off',
                    id: 'career-selector',
                    className: 'form-control select select--md',
                    onChange: function onChange(e) {
                      return _this2.onChangeCareer.call(_this2, e);
                    },
                    value: currentCareerObj.name
                  },
                  careerOptions.map(function (p, index) {
                    return _react2.default.createElement(
                      'option',
                      { key: 'career-' + index, value: p.value },
                      p.label
                    );
                  })
                )
              ),
              currentCareerObj.groupLabel ? _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(
                  'div',
                  { className: 'padding-bottom-md' },
                  _react2.default.createElement(
                    'select',
                    {
                      autoComplete: 'off',
                      id: 'position-selector',
                      className: 'form-control select select--md',
                      name: 'position',
                      onChange: function onChange(e) {
                        return _this2.onChangePosition.call(_this2, e);
                      },
                      value: currentPosition
                    },
                    positionOptions.map(function (p, index) {
                      return _react2.default.createElement(
                        'option',
                        { key: 'position-' + index, value: p.value },
                        p.label
                      );
                    })
                  )
                )
              ) : _react2.default.createElement('input', { type: 'hidden', name: 'position', value: currentPosition }),
              currentPosition ? _react2.default.createElement(
                'button',
                { onClick: function onClick(e) {
                    return _this2.onSubmit(e);
                  }, type: 'submit', className: 'tes-btn tes-btn--lg tes-btn--icon tes-btn--block tes-btn--primary' },
                'Ok'
              ) : null
            )
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'tes-modal__body_bottom' },
          _react2.default.createElement(
            'div',
            { className: 'more-info text-center text-sm padding-top-md border-top' },
            _react2.default.createElement(
              'span',
              null,
              'Already have a TES account?'
            ),
            _react2.default.createElement(
              'span',
              null,
              ' '
            ),
            _react2.default.createElement(
              _WidgetLink2.default,
              { formType: 'signIn' },
              'Log in now!'
            )
          )
        )
      );
    }
  }]);
  return SelectFormPosition;
}(_react.Component);

SelectFormPosition.propTypes = {
  common: _react.PropTypes.object.isRequired,
  errors: _react.PropTypes.object.isRequired,
  refdata: _react.PropTypes.object.isRequired,
  isStandAlone: _react.PropTypes.bool,
  action: _react.PropTypes.string.isRequired,
  method: _react.PropTypes.string.isRequired
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    actions: (0, _redux.bindActionCreators)(actionCreators, dispatch)
  };
};

exports.default = (0, _reactRedux.connect)(function (state) {
  return {
    common: state.common,
    errors: state.errors,
    refdata: state.refdata
  };
}, mapDispatchToProps)(SelectFormPosition);

});
},{"../lib/position-filter":173,"../reducers/actions":176,"./lib/HiddenInputs":167,"./lib/WidgetLink":169,"async-define":8,"babel-runtime/core-js/object/get-prototype-of":15,"babel-runtime/helpers/classCallCheck":21,"babel-runtime/helpers/createClass":22,"babel-runtime/helpers/inherits":23,"babel-runtime/helpers/possibleConstructorReturn":24}],165:[function(require,module,exports){
var asyncDefine = require('async-define');
asyncDefine(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function (__react,__react_dom,__redux,__react_redux){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = SelectPosition;

var _react = __react;

var _react2 = _interopRequireDefault(_react);

var _SelectFormPosition = require('./SelectFormPosition');

var _SelectFormPosition2 = _interopRequireDefault(_SelectFormPosition);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function SelectPosition() {
  return _react2.default.createElement(_SelectFormPosition2.default, {
    action: '/authn/register',
    method: 'get'
  });
}

});
},{"./SelectFormPosition":164,"async-define":8}],166:[function(require,module,exports){
var asyncDefine = require('async-define');
asyncDefine(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function (__react,__react_dom,__redux,__react_redux){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Signin = undefined;

var _keys = require('babel-runtime/core-js/object/keys');

var _keys2 = _interopRequireDefault(_keys);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __react;

var _react2 = _interopRequireDefault(_react);

var _getErrorFromPrefix = require('../lib/getErrorFromPrefix');

var _reactRedux = __react_redux;

var _redux = __redux;

var _actions = require('../reducers/actions');

var actionCreators = _interopRequireWildcard(_actions);

var _WidgetLink = require('./lib/WidgetLink');

var _WidgetLink2 = _interopRequireDefault(_WidgetLink);

var _HiddenInputs = require('./lib/HiddenInputs');

var _HiddenInputs2 = _interopRequireDefault(_HiddenInputs);

var _InputField = require('./lib/InputField');

var _InputField2 = _interopRequireDefault(_InputField);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getErrorMsg = (0, _getErrorFromPrefix.getErrorMsgFromPrefix)('signin');
var getErrorCls = (0, _getErrorFromPrefix.getErrorClsFromPrefix)('signin');
var getGenericErrorMsg = (0, _getErrorFromPrefix.getErrorMsgFromPrefix)('generic');
var getGenericErrorCls = (0, _getErrorFromPrefix.getErrorClsFromPrefix)('generic');

var Signin = exports.Signin = function (_Component) {
  (0, _inherits3.default)(Signin, _Component);

  function Signin() {
    (0, _classCallCheck3.default)(this, Signin);
    return (0, _possibleConstructorReturn3.default)(this, (Signin.__proto__ || (0, _getPrototypeOf2.default)(Signin)).apply(this, arguments));
  }

  (0, _createClass3.default)(Signin, [{
    key: 'getGoogleLogoURL',
    value: function getGoogleLogoURL() {
      return this.props.common.cdnUrl + 'img/google-logo-g.png';
    }
  }, {
    key: 'handleGoogle',
    value: function handleGoogle() {
      this.props.actions.initGoogleSignIn();
    }
  }, {
    key: 'handleSubmit',
    value: function handleSubmit(e) {
      e.preventDefault();
      var target = e.target;

      this.props.actions.initSignIn(function () {
        target.submit();
      });
    }
  }, {
    key: 'hasError',
    value: function hasError() {
      return this.props.errors ? (0, _keys2.default)(this.props.errors).filter(function (n) {
        return n.startsWith('signin.');
      }).length > 0 : false;
    }
  }, {
    key: 'changeField',
    value: function changeField(namepar, depspar) {
      var _this2 = this;

      var name = 'signin.' + namepar;
      var deps = depspar.map(function (n) {
        return 'signin.' + n;
      }) || [];
      return function (e) {
        var target = e.target;
        _this2.props.actions.setField('signIn', target.name, target.type === 'checkbox' || target.type === 'radio' ? target.checked : target.value);
        _this2.props.actions.changeField(name, deps);
      };
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var err = this.props.errors;

      return _react2.default.createElement(
        'div',
        { id: 'sign-in', className: 'padding-left-md padding-right-md padding-bottom-xs margin-bottom-xs' },
        _react2.default.createElement(
          'div',
          { className: 'heading-main margin-bottom-md text-center' },
          _react2.default.createElement(
            'h3',
            { className: 'tes-modal__heading' },
            'Please log in'
          )
        ),
        _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement(
            'div',
            { className: 'row' },
            _react2.default.createElement(
              'div',
              { className: 'col-xs-12' },
              _react2.default.createElement(
                'button',
                {
                  disabled: this.props.signIn.state === 'wait' || this.props.common.googleState === 'wait' ? 'disabled' : null,
                  onClick: function onClick(e) {
                    return _this3.handleGoogle(e);
                  },
                  className: 'tes-btn tes-btn--secondary tes-btn--icon tes-btn--block'
                },
                this.props.common.googleState === 'wait' ? _react2.default.createElement('i', { className: 'icon-spin icon-spinner tes-btn__icon' }) : _react2.default.createElement(
                  'span',
                  { className: 'text-sm' },
                  _react2.default.createElement('img', { style: { padding: '0 6px 2px 0' }, src: this.getGoogleLogoURL() }),
                  ' Log in with Google'
                )
              )
            )
          ),
          _react2.default.createElement(
            'form',
            { autoComplete: 'off', onSubmit: function onSubmit(e) {
                return _this3.handleSubmit(e);
              }, role: 'form', className: 't-sign-in-form margin-bottom-sm', method: 'post', action: '/api/authn/sign-in-redirect' },
            _react2.default.createElement(_HiddenInputs2.default, null),
            _react2.default.createElement(
              'div',
              { className: 'separator' },
              _react2.default.createElement(
                'span',
                { className: 'separator--text bg-light' },
                'or'
              )
            ),
            _react2.default.createElement(_InputField2.default, {
              name: 'identification',
              label: 'Username or email',
              icon: 'user',
              value: this.props.signIn.identification,
              errorClass: getErrorCls('userName')(err),
              errorMessage: getErrorMsg('userName')(err),
              onChange: this.changeField('userName', ['password']),
              autoFocus: 'true',
              autoComplete: 'off'
            }),
            _react2.default.createElement(_InputField2.default, {
              name: 'password',
              label: 'Password',
              icon: 'lock',
              value: this.props.signIn.password,
              errorClass: getErrorCls('password')(err),
              errorMessage: getErrorMsg('password')(err),
              onChange: this.changeField('password', ['userName']),
              type: 'password',
              autoComplete: 'off'
            }),
            _react2.default.createElement(
              'div',
              { className: 'text-sm margin-bottom-md margin-top-md' },
              _react2.default.createElement(
                'div',
                { className: 'tes-checkbox tes-checkbox--inline' },
                _react2.default.createElement(
                  'label',
                  { className: 'tes-control-label', title: 'This shouldn\'t be used on a shared computer' },
                  _react2.default.createElement('input', { type: 'checkbox',
                    name: 'trustedComputer',
                    value: 'true',
                    checked: this.props.signIn.trustedComputer,
                    onChange: this.changeField('trustedComputer', [])
                  }),
                  ' Stay logged in'
                )
              ),
              _react2.default.createElement(
                _WidgetLink2.default,
                { formType: 'forgotPassword' },
                'Forgot password?'
              )
            ),
            _react2.default.createElement(
              'div',
              null,
              _react2.default.createElement(
                'button',
                {
                  disabled: this.props.signIn.state === 'wait' || this.props.common.googleState === 'wait' ? 'disabled' : null,
                  type: 'submit', className: 'tes-btn tes-btn--lg sign-in-submit tes-btn--icon tes-btn--block tes-btn--primary'
                },
                this.props.signInstate === 'wait' ? _react2.default.createElement('i', { className: 'icon-spin icon-spinner icon-white tes-btn__icon' }) : 'Log in'
              )
            )
          ),
          getGenericErrorCls('googlebutton')(err) ? _react2.default.createElement(
            'div',
            { className: 'row' },
            _react2.default.createElement(
              'div',
              { className: 'col-xs-12 tes-has-error' },
              _react2.default.createElement(
                'div',
                { className: 'tes-help-block' },
                getGenericErrorMsg('googlebutton')(err)
              )
            )
          ) : null
        ),
        _react2.default.createElement(
          'div',
          { className: 'clearfix' },
          _react2.default.createElement(
            'div',
            { className: 'more-info text-center text-sm padding-top-sm' },
            _react2.default.createElement(
              'span',
              null,
              'Not a member yet?'
            ),
            _react2.default.createElement(
              'span',
              null,
              ' '
            ),
            _react2.default.createElement(
              _WidgetLink2.default,
              { formType: 'register' },
              'Join us for free'
            )
          )
        )
      );
    }
  }]);
  return Signin;
}(_react.Component);

Signin.propTypes = {
  common: _react.PropTypes.object.isRequired,
  errors: _react.PropTypes.object.isRequired,
  signIn: _react.PropTypes.object.isRequired
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    actions: (0, _redux.bindActionCreators)(actionCreators, dispatch)
  };
};

exports.default = (0, _reactRedux.connect)(function (state) {
  return {
    common: state.common,
    errors: state.errors,
    signIn: state.signIn
  };
}, mapDispatchToProps)(Signin);

});
},{"../lib/getErrorFromPrefix":172,"../reducers/actions":176,"./lib/HiddenInputs":167,"./lib/InputField":168,"./lib/WidgetLink":169,"async-define":8,"babel-runtime/core-js/object/get-prototype-of":15,"babel-runtime/core-js/object/keys":16,"babel-runtime/helpers/classCallCheck":21,"babel-runtime/helpers/createClass":22,"babel-runtime/helpers/inherits":23,"babel-runtime/helpers/possibleConstructorReturn":24}],167:[function(require,module,exports){
var asyncDefine = require('async-define');
asyncDefine(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function (__react,__react_dom,__redux,__react_redux){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.HiddenInputs = HiddenInputs;

var _react = __react;

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __react_redux;

var _tracking = require('../../lib/tracking');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function HiddenInputs(_ref) {
  var common = _ref.common,
      isGetRequest = _ref.isGetRequest,
      noUserType = _ref.noUserType,
      noPosition = _ref.noPosition;

  var pageContext = (0, _tracking.getPageContext)(common.pageMz, common.overrideMz);

  var pageContextInputs = ['pageId', 'pageType', 'pageSection', 'pageSubSection'].filter(function (name) {
    return pageContext && pageContext[name];
  }).map(function (name) {
    return _react2.default.createElement('input', { type: 'hidden', key: name, name: name, value: pageContext[name] });
  });

  return _react2.default.createElement(
    'span',
    null,
    pageContextInputs,
    common.rtn ? _react2.default.createElement('input', { type: 'hidden', name: 'rtn', value: common.rtn }) : null,
    !noUserType && common.userType ? _react2.default.createElement('input', { className: 't-user-type', type: 'hidden', name: 'userType', value: common.userType }) : null,
    !noPosition && common.position ? _react2.default.createElement('input', { className: 't-position', type: 'hidden', name: 'position', value: common.position }) : null,
    common.regUrl ? _react2.default.createElement('input', { className: 't-reg-url', type: 'hidden', name: 'regUrl', value: common.regUrl }) : null,
    _react2.default.createElement('input', { type: 'hidden', name: 'appId', value: common.appId }),
    !isGetRequest ? _react2.default.createElement('input', { type: 'hidden', name: '_CSRF_TOKEN', value: common.csrfToken }) : null,
    common.doSelectUserType ? _react2.default.createElement('input', { className: 't-select', type: 'hidden', name: 'select', value: 'true' }) : null,
    common.omitName ? _react2.default.createElement('input', { type: 'hidden', name: 'omitName', value: common.omitName }) : null
  );
}

HiddenInputs.propTypes = {
  common: _react.PropTypes.object.isRequired,
  isGetRequest: _react.PropTypes.bool,
  noUserType: _react.PropTypes.bool,
  noPosition: _react.PropTypes.bool
};

exports.default = (0, _reactRedux.connect)(function (state) {
  return {
    common: state.common
  };
})(HiddenInputs);

});
},{"../../lib/tracking":174,"async-define":8}],168:[function(require,module,exports){
var asyncDefine = require('async-define');
asyncDefine(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function (__react,__react_dom,__redux,__react_redux){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __react;

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function InputGroup(_ref) {
  var icon = _ref.icon,
      children = _ref.children;

  if (!icon) return _react2.default.createElement(
    "div",
    null,
    children
  );
  return _react2.default.createElement(
    "div",
    { className: "tes-input-group" },
    _react2.default.createElement(
      "span",
      { className: "tes-input-group__addon" },
      _react2.default.createElement("i", { className: "icon icon-" + icon })
    ),
    children
  );
}

InputGroup.propTypes = {
  icon: _react.PropTypes.string
};

function InputField(_ref2) {
  var errorClass = _ref2.errorClass,
      errorMessage = _ref2.errorMessage,
      label = _ref2.label,
      value = _ref2.value,
      name = _ref2.name,
      onChange = _ref2.onChange,
      type = _ref2.type,
      icon = _ref2.icon,
      autoFocus = _ref2.autoFocus,
      autoComplete = _ref2.autoComplete;

  var id = "auth-" + name;
  var widgetType = type || 'text';
  return _react2.default.createElement(
    "div",
    { className: errorClass },
    _react2.default.createElement(
      InputGroup,
      { icon: icon },
      _react2.default.createElement(
        "label",
        { className: "tes-control-label tes-control-label--hidden", htmlFor: id },
        label
      ),
      _react2.default.createElement("input", { onChange: onChange, id: id, type: widgetType,
        name: name,
        placeholder: label,
        className: "tes-control",
        value: value,
        autoFocus: autoFocus,
        autoComplete: autoComplete
      })
    ),
    _react2.default.createElement(
      "div",
      { className: "tes-help-block" },
      errorMessage
    )
  );
}

InputField.propTypes = {
  errorClass: _react.PropTypes.string.isRequired,
  errorMessage: _react.PropTypes.string.isRequired,
  label: _react.PropTypes.string.isRequired,
  icon: _react.PropTypes.string,
  value: _react.PropTypes.string.isRequired,
  name: _react.PropTypes.string.isRequired,
  type: _react.PropTypes.string,
  onChange: _react.PropTypes.func.isRequired,
  autoFocus: _react.PropTypes.string,
  autoComplete: _react.PropTypes.string
};

exports.default = InputField;

});
},{"async-define":8}],169:[function(require,module,exports){
var asyncDefine = require('async-define');
asyncDefine(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function (__react,__react_dom,__redux,__react_redux){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.WidgetLink = WidgetLink;

var _react = __react;

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __react_redux;

var _redux = __redux;

var _actions = require('../../reducers/actions');

var actionCreators = _interopRequireWildcard(_actions);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function WidgetLink(_ref) {
  var common = _ref.common,
      formType = _ref.formType,
      children = _ref.children,
      actions = _ref.actions;

  var registerPages = {
    signIn: 'sign-in',
    forgotPassword: 'forgot-password',
    register: common.doSelectUserType ? 'select' : 'register'
  };

  var registerPage = registerPages[formType];

  var switchTo = function switchTo(e) {
    if (!common.isModal && !common.isInline) return;
    e.preventDefault();
    actions.initSetFormType(registerPage);
  };

  var encodedRtn = encodeURIComponent(common.rtn);
  var encodedRegUrl = encodeURIComponent(common.regUrl);

  var qs = [];
  if (common.rtn) {
    qs.push('rtn=' + encodedRtn);
  }
  if (common.doSelectUserType) {
    qs.push('select=true');
  }
  if ('id' in common.overrideMz) {
    qs.push('pageId=' + common.overrideMz.id);
  }
  if ('type' in common.overrideMz) {
    qs.push('pageType=' + common.overrideMz.type);
  }
  if ('section' in common.overrideMz) {
    qs.push('pageSection=' + common.overrideMz.section);
  }
  if ('subsection' in common.overrideMz) {
    qs.push('pageSubSection=' + common.overrideMz.subsection);
  }
  if (common.regUrl) {
    qs.push('regUrl=' + encodedRegUrl);
  }
  if (common.omitName) {
    qs.push('omitName=' + common.omitName);
  }

  var baseURLs = {
    signIn: '/authn/sign-in',
    forgotPassword: '/authn/forgot-password',
    register: '/authn/' + registerPage
  };

  var baseURL = baseURLs[formType];
  var url = qs.length ? baseURL + '?' + qs.join('&') : baseURL;
  var extraClass = formType === 'forgotPassword' ? ' pull-right' : '';
  return _react2.default.createElement(
    'a',
    { onClick: switchTo, href: url, className: 't-switch-form' + extraClass },
    children
  );
}

WidgetLink.propTypes = {
  common: _react.PropTypes.object.isRequired,
  actions: _react.PropTypes.object.isRequired,
  formType: _react.PropTypes.string.isRequired
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    actions: (0, _redux.bindActionCreators)(actionCreators, dispatch)
  };
};

exports.default = (0, _reactRedux.connect)(function (state) {
  return {
    common: state.common
  };
}, mapDispatchToProps)(WidgetLink);

});
},{"../../reducers/actions":176,"async-define":8}],170:[function(require,module,exports){
var asyncDefine = require('async-define');
asyncDefine(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function (__react,__react_dom,__redux,__react_redux){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof2 = require('babel-runtime/helpers/typeof');

var _typeof3 = _interopRequireDefault(_typeof2);

var _keys = require('babel-runtime/core-js/object/keys');

var _keys2 = _interopRequireDefault(_keys);

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

var _stringify = require('babel-runtime/core-js/json/stringify');

var _stringify2 = _interopRequireDefault(_stringify);

var _assign = require('babel-runtime/core-js/object/assign');

var _assign2 = _interopRequireDefault(_assign);

var _slicedToArray2 = require('babel-runtime/helpers/slicedToArray');

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

var _reqwest = require('reqwest');

var _reqwest2 = _interopRequireDefault(_reqwest);

var _retry = require('async-deco/promise/retry');

var _retry2 = _interopRequireDefault(_retry);

var _memoize = require('async-deco/promise/memoize');

var _memoize2 = _interopRequireDefault(_memoize);

var _es6PromisePolyfill = require('es6-promise-polyfill');

var _es6PromisePolyfill2 = _interopRequireDefault(_es6PromisePolyfill);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint-disable no-console */
try {
  window.Promise = _es6PromisePolyfill2.default.Promise;
} catch (e) {
  // nothing
}

var getOrigin = function getOrigin() {
  if (window.location.origin) {
    return window.location.origin;
  }
  var port = window.location.port ? ':' + window.location.port : '';
  var protocol = window.location.protocol;
  var hostname = window.location.hostname;
  return protocol + '//' + hostname + port;
};

var XHRTIMEOUT_WITH_RETRY = 9000;
var XHRTIMEOUT_WITHOUT_RETRY = 20000;

var defaultParams = {
  type: 'json',
  contentType: 'application/json',
  headers: {
    accept: 'application/json',
    'x-auth-api-version': '2'
  }
};

function postRequest(endpoint, data, times) {
  var requestFunction = void 0;
  var timeout = void 0;
  if (times) {
    (function () {
      var t0 = new Date();
      var retry = (0, _retry2.default)(times, 100, function (err) {
        return err && err.status === 0;
      }, function () {
        return function (t, o) {
          var t1 = new Date();
          console.log('app-authentication: api trying ' + o.times + ' after ' + (t1 - t0) + ' ms');
        };
      });
      requestFunction = retry(_reqwest2.default);
      timeout = XHRTIMEOUT_WITH_RETRY;
    })();
  } else {
    requestFunction = _reqwest2.default;
    timeout = XHRTIMEOUT_WITHOUT_RETRY;
  }

  var _ref = document.cookie.match(/csrf=([^;]*)/) || [],
      _ref2 = (0, _slicedToArray3.default)(_ref, 2),
      match = _ref2[0],
      csrfToken = _ref2[1];

  return requestFunction((0, _assign2.default)({}, defaultParams, {
    url: endpoint,
    method: 'POST',
    timeout: timeout,
    data: (0, _stringify2.default)(data),
    headers: (0, _assign2.default)({}, defaultParams.headers, match && csrfToken ? {
      'x-csrf-token': match && csrfToken
    } : {})
  }));
}

var memoize = (0, _memoize2.default)(function (d) {
  try {
    return d.data.email ? d.data.email : null;
  } catch (e) {
    return null;
  }
});
var cachedReqwest = memoize(_reqwest2.default);

function getRequest(endpoint, data) {
  var timeout = XHRTIMEOUT_WITHOUT_RETRY;

  return cachedReqwest((0, _assign2.default)({}, defaultParams, {
    url: endpoint,
    method: 'GET',
    timeout: timeout,
    data: data
  }));
}

var events = function getEvents() {
  try {
    return window.TES.events;
  } catch (e) {
    return {
      on: function on() {},
      trigger: function trigger() {}
    };
  }
}();

var api = {
  verifyUsername: function verifyUsername(username) {
    return getRequest('/api/authn/find-user', { username: username });
  },
  verifyEmail: function verifyEmail(email) {
    return getRequest('/api/authn/find-user', { email: email });
  },
  signIn: function signIn(data) {
    return postRequest('/api/authn/sign-in-redirect', data, 4);
  },
  register: function register(data) {
    return postRequest('/api/authn/register-redirect', data);
  },
  googleSignIn: function googleSignIn(data) {
    return new _promise2.default(function (resolve, reject) {
      var params = (0, _keys2.default)(data).filter(function (k) {
        return !!data[k];
      }).map(function (k) {
        return [k, encodeURIComponent(data[k])];
      }).map(function (t) {
        return t[0] + '=' + t[1];
      }).join('&');

      var path = '/oauth/google?' + params;

      if (!data.isModal) {
        return window.location.assign(path);
      }

      var done = false;

      var googlePopup = window.open(path, '', 'location=0,status=0,width=600,height=500');

      function onMessage(evt) {
        var msg = void 0;
        if (evt.origin !== getOrigin()) return;
        try {
          msg = (0, _typeof3.default)(evt.data) === 'object' ? evt.data : JSON.parse(evt.data);
        } catch (e) {
          // ie9 returns evt.data === undefined, but I won't care!!!!
          // this is also the case of non JSON messages
          return;
        }
        if (msg.sender !== 'googlepopup') {
          return;
        }
        if (msg.status === 'ok' || msg.status === 'error') {
          done = true;
          window.removeEventListener('message', onMessage);
          googlePopup.close();
        }
        if (msg.status === 'ok') {
          resolve();
        }
        if (msg.status === 'error') {
          reject(new Error(msg.errorCode));
        }
      }

      window.addEventListener('message', onMessage);

      var _oauthInterval = window.setInterval(function () {
        var fireError = function fireError(errorCode) {
          if (!done) {
            reject(new Error(errorCode));
          }
          window.removeEventListener('message', onMessage);
          window.clearInterval(_oauthInterval);
        };
        try {
          if (!googlePopup) {
            fireError('google.popup.blocked');
          } else if (googlePopup.closed) {
            fireError('google.popup.closed');
          }
        } catch (e) {
          // ie fires error here
        }
      }, 1000);
    });
  },
  forgotPassword: function forgotPassword(data) {
    return postRequest('/api/authn/forgot-password', data);
  },
  updateUserData: function updateUserData(data) {
    return postRequest('/api/authn/edit-account', data);
  },
  reload: function reload() {
    window.location.reload(true);
  },
  loggedInEvent: function loggedInEvent() {
    events.trigger('logged-in');
  },
  closeModalEvent: function closeModalEvent() {
    events.trigger('modal-close', 'authapp');
  }
};

exports.default = api;

});
},{"async-deco/promise/memoize":1,"async-deco/promise/retry":2,"async-define":8,"babel-runtime/core-js/json/stringify":11,"babel-runtime/core-js/object/assign":12,"babel-runtime/core-js/object/keys":16,"babel-runtime/core-js/promise":18,"babel-runtime/helpers/slicedToArray":25,"babel-runtime/helpers/typeof":26,"es6-promise-polyfill":130,"reqwest":154}],171:[function(require,module,exports){
var asyncDefine = require('async-define');
asyncDefine(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function (__react,__react_dom,__redux,__react_redux){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.authDenied = authDenied;
exports.forgotPasswordDenied = forgotPasswordDenied;
var bannedStates = {
  2: 'banned',
  3: 'disapproved',
  4: 'possible spam activity',
  5: 'locked out'
};

function getResponse(err) {
  if ('response' in err || 'responseText' in err) {
    try {
      return JSON.parse(err.response || err.responseText);
    } catch (e) {
      return undefined;
    }
  } else {
    return err;
  }
}

function authDenied(err) {
  if (err.status === 401) {
    return 'signin.unauthorized';
  }
  if (err.status === 403) {
    var response = getResponse(err);
    if (response && 'data' in response && response.data.code && response.data.code in bannedStates) {
      return 'signin.' + bannedStates[response.data.code];
    }
    return 'signin.generic.banned';
  }
}

function forgotPasswordDenied(err) {
  if (err.status === 404) {
    return 'forgot-password.user.not-found';
  }
  if (err.status === 403) {
    var response = getResponse(err);
    if (response && 'data' in response && response.data.code && response.data.code in bannedStates) {
      return 'forgot-password.' + bannedStates[response.data.code];
    }
    return 'forgot-password.generic.banned';
  }
}

});
},{"async-define":8}],172:[function(require,module,exports){
var asyncDefine = require('async-define');
asyncDefine(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function (__react,__react_dom,__redux,__react_redux){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getErrorMsgFromPrefix = getErrorMsgFromPrefix;
exports.getErrorClsFromPrefix = getErrorClsFromPrefix;
function getErrorMsgFromPrefix(prefix) {
  return function (_field) {
    var field = prefix + '.' + _field;
    return function (err) {
      return err && field in err ? err[field].msg : '';
    };
  };
}

function getErrorClsFromPrefix(prefix) {
  return function (_field) {
    var field = prefix + '.' + _field;
    return function (err) {
      return err && field in err && err[field].state === 'error' ? ' tes-has-error' : '';
    };
  };
}

});
},{"async-define":8}],173:[function(require,module,exports){
var asyncDefine = require('async-define');
asyncDefine(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function (__react,__react_dom,__redux,__react_redux){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof2 = require('babel-runtime/helpers/typeof');

var _typeof3 = _interopRequireDefault(_typeof2);

exports.careerFinder = careerFinder;
exports.filterPosition = filterPosition;
exports.getUserTypePosition = getUserTypePosition;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function careerFinder(positions, careers, currentPosition) {
  var careerMatch = careers.filter(function (item) {
    return item.name === currentPosition;
  });
  if (careerMatch.length) {
    return { name: careerMatch[0].name, groupLabel: null };
  }
  var positionMatch = positions.filter(function (item) {
    return item.name === currentPosition;
  });
  if (positionMatch.length) {
    var _ret = function () {
      var groupLabel = positionMatch[0].groupLabel;
      var groupMatch = careers.filter(function (item) {
        return item.groupLabel === groupLabel;
      });
      if (groupMatch.length) {
        return {
          v: { name: groupMatch[0].name, groupLabel: groupLabel }
        };
      }
    }();

    if ((typeof _ret === 'undefined' ? 'undefined' : (0, _typeof3.default)(_ret)) === "object") return _ret.v;
  }
  return { name: '', groupLabel: null };
}

function filterPosition(positions, currentCareerObj) {
  return positions.filter(function (pos) {
    if (currentCareerObj.groupLabel) {
      return pos.groupLabel === currentCareerObj.groupLabel;
    }
    return pos.name === currentCareerObj.name;
  });
}

function getUserTypePosition(positions, currentPosition) {
  var posObj = positions.find(function (pos) {
    return pos.name === currentPosition;
  });
  return posObj ? posObj.userType : 'other';
}

});
},{"async-define":8,"babel-runtime/helpers/typeof":26}],174:[function(require,module,exports){
var asyncDefine = require('async-define');
asyncDefine(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function (__react,__react_dom,__redux,__react_redux){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.trackClick = trackClick;
exports.trackDisplay = trackDisplay;
exports.trackError = trackError;
exports.trackForgotPassword = trackForgotPassword;
exports.trackLogin = trackLogin;
exports.trackRegister = trackRegister;
exports.getTrackingType = getTrackingType;
exports.getPageContext = getPageContext;
/* global _mz:false, _mze:false */

function hasMz() {
  try {
    return !!_mz;
  } catch (e) {
    return false;
  }
}

function trackClick(formType) {
  if (!hasMz()) return;
  var eventTitle = void 0;
  if (formType === 'sign-in') {
    eventTitle = 'login';
  } else if (formType === 'register' || formType === 'select') {
    eventTitle = 'register';
  }
  if (eventTitle) {
    _mz.emit(_mze.CLICK, {
      module: {
        type: 'auth-links'
      },
      eventTitle: eventTitle
    });
  }
}

function trackDisplay(formType, type, userType, isSelectPosition, doSelectUserType) {
  if (!hasMz()) return;
  var eventTitle = {
    'sign-in': 'tes-login',
    register: 'register',
    'forgot-password': 'forgot-password',
    select: 'tes-account-type'
  };
  var event = {
    id: eventTitle[formType] || 'tes-login',
    module: {
      id: doSelectUserType ? 'useSelect' : null,
      type: type
    }
  };

  if (formType === 'select') {
    event.variant = isSelectPosition ? 'position-selector' : 'user-type-selector';
  } else if (userType) {
    event.variant = userType;
  }

  _mz.emit(_mze.DISPLAY, event);
}

function trackError(id, msg, type) {
  if (!hasMz()) return;
  var evt = id === 'register-fail' ? _mze.REGISTER_FAIL : _mze.LOGIN_FAIL;
  _mz.emit(evt, {
    id: id,
    payload: {
      message: msg
    },
    module: {
      type: type
    }
  });
}

function trackForgotPassword(type, cb) {
  if (!hasMz()) return cb && cb();
  _mz.emit(_mze.SUBMIT, {
    id: 'forgot-password',
    module: {
      type: type
    }
  }, cb);
}

function trackLogin(id, type, cb) {
  if (!hasMz()) return cb && cb();
  _mz.emit(_mze.LOGIN, {
    id: id,
    module: {
      type: type
    }
  }, cb);
}

function trackRegister(type, cb) {
  if (!hasMz()) return cb && cb();
  _mz.emit(_mze.REGISTER, {
    id: 'register',
    module: {
      type: type
    },
    tags: ['funnel']
  }, cb);
}

function getTrackingType(isModal, isInline) {
  if (isModal) {
    return 'modal';
  } else if (isInline) {
    return 'embed';
  }
  return 'standalone';
}

function getPageContext(pageMetadata, overridePageMetadata) {
  var meta = {};

  if ('id' in overridePageMetadata || 'id' in pageMetadata) {
    meta.pageId = overridePageMetadata.id || pageMetadata.id;
  }

  if ('type' in overridePageMetadata || 'type' in pageMetadata) {
    meta.pageType = overridePageMetadata.type || pageMetadata.type;
  }

  if ('section' in overridePageMetadata || 'section' in pageMetadata) {
    meta.pageSection = overridePageMetadata.section || pageMetadata.section;
  }

  if ('subsection' in overridePageMetadata || 'subsection' in pageMetadata) {
    meta.pageSubSection = overridePageMetadata.subsection || pageMetadata.subsection;
  }

  return meta;
}

});
},{"async-define":8}],175:[function(require,module,exports){
var asyncDefine = require('async-define');
asyncDefine(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function (__react,__react_dom,__redux,__react_redux){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof2 = require('babel-runtime/helpers/typeof');

var _typeof3 = _interopRequireDefault(_typeof2);

exports.default = traverseObject;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function traverseObject(obj, key) {
  if ((typeof obj === 'undefined' ? 'undefined' : (0, _typeof3.default)(obj)) !== 'object') {
    return undefined;
  }
  for (var k in obj) {
    if (key === k) {
      return obj[key];
    }
    var value = traverseObject(obj[k], key);
    if (value) {
      return value;
    }
  }
  return undefined;
}

});
},{"async-define":8,"babel-runtime/helpers/typeof":26}],176:[function(require,module,exports){
var asyncDefine = require('async-define');
asyncDefine(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function (__react,__react_dom,__redux,__react_redux){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.reset = reset;
exports.initSetFormType = initSetFormType;
exports.setFormType = setFormType;
exports.setPosition = setPosition;
exports.updateUserData = updateUserData;
exports.validationErrors = validationErrors;
exports.setUserType = setUserType;
exports.successGoogleSignIn = successGoogleSignIn;
exports.successSignIn = successSignIn;
exports.successRegister = successRegister;
exports.failSignIn = failSignIn;
exports.failRegister = failRegister;
exports.failForgotPassword = failForgotPassword;
exports.failGoogleSignIn = failGoogleSignIn;
exports.initSignIn = initSignIn;
exports.initRegister = initRegister;
exports.initGoogleSignIn = initGoogleSignIn;
exports.initForgotPassword = initForgotPassword;
exports.sentForgotPassword = sentForgotPassword;
exports.successForgotPassword = successForgotPassword;
exports.validateField = validateField;
exports.changeField = changeField;
exports.setField = setField;
exports.resetErrors = resetErrors;
exports.suggestUserName = suggestUserName;
exports.trackClick = trackClick;
exports.trackDisplay = trackDisplay;

var _constants = require('./constants');

var constant = _interopRequireWildcard(_constants);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

// Action Creators
function reset() {
  return { type: constant.RESET };
}

function initSetFormType(formType) {
  return { type: constant.INIT_SET_FORM_TYPE, formType: formType };
}

function setFormType(formType) {
  return { type: constant.SET_FORM_TYPE, formType: formType };
}

function setPosition(position, userType) {
  return { type: constant.SET_POSITION, position: position, userType: userType };
}

function updateUserData(data) {
  return { type: constant.UPDATE_USER_DATA, data: data };
}

function validationErrors(errors) {
  return { type: constant.VALIDATION_ERRORS, errors: errors };
}

function setUserType(userType) {
  return { type: constant.SET_USER_TYPE, userType: userType };
}

function successGoogleSignIn() {
  return { type: constant.SUCCESS_GOOGLE_SIGN_IN };
}

function successSignIn() {
  return { type: constant.SUCCESS_SIGN_IN };
}

function successRegister() {
  return { type: constant.SUCCESS_REGISTER };
}

function failSignIn(errors) {
  return { type: constant.FAIL_SIGN_IN, errors: errors };
}

function failRegister(errors) {
  return { type: constant.FAIL_REGISTER, errors: errors };
}

function failForgotPassword(errors) {
  return { type: constant.FAIL_FORGOT_PASSWORD, errors: errors };
}

function failGoogleSignIn(errors) {
  return { type: constant.FAIL_GOOGLE_SIGN_IN, errors: errors };
}

function initSignIn(callback) {
  return { type: constant.INIT_SIGN_IN, callback: callback };
}

function initRegister(callback) {
  return { type: constant.INIT_REGISTER, callback: callback };
}

function initGoogleSignIn() {
  return { type: constant.INIT_GOOGLE_SIGN_IN };
}

function initForgotPassword() {
  return { type: constant.INIT_FORGOT_PASSWORD };
}

function sentForgotPassword() {
  return { type: constant.SENT_FORGOT_PASSWORD };
}

function successForgotPassword() {
  return { type: constant.SUCCESS_FORGOT_PASSWORD };
}

function validateField(name) {
  return { type: constant.VALIDATE_FIELD, name: name };
}

function changeField(name, deps) {
  return { type: constant.CHANGE_FIELD, name: name, deps: deps };
}

function setField(form, name, value) {
  return { type: constant.SET_FIELD, form: form, name: name, value: value };
}

function resetErrors() {
  return { type: constant.RESET_ERRORS };
}

function suggestUserName(username) {
  return { type: constant.SUGGEST_USER_NAME, username: username };
}

function trackClick(formType) {
  return { type: constant.TRACK_CLICK, formType: formType };
}

function trackDisplay(formType) {
  return { type: constant.TRACK_DISPLAY, formType: formType };
}

});
},{"./constants":177,"async-define":8}],177:[function(require,module,exports){
var asyncDefine = require('async-define');
asyncDefine(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function (__react,__react_dom,__redux,__react_redux){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var RESET = exports.RESET = 'RESET';
var INIT_SET_FORM_TYPE = exports.INIT_SET_FORM_TYPE = 'INIT_SET_FORM_TYPE';
var SET_FORM_TYPE = exports.SET_FORM_TYPE = 'SET_FORM_TYPE';
var SET_USER_TYPE = exports.SET_USER_TYPE = 'SET_USER_TYPE';
var SET_POSITION = exports.SET_POSITION = 'SET_POSITION';
var UPDATE_USER_DATA = exports.UPDATE_USER_DATA = 'UPDATE_USER_DATA';

var VALIDATION_ERRORS = exports.VALIDATION_ERRORS = 'VALIDATION_ERRORS';

var SUCCESS_GOOGLE_SIGN_IN = exports.SUCCESS_GOOGLE_SIGN_IN = 'SUCCESS_GOOGLE_SIGN_IN';
var SUCCESS_SIGN_IN = exports.SUCCESS_SIGN_IN = 'SUCCESS_SIGN_IN';
var SUCCESS_REGISTER = exports.SUCCESS_REGISTER = 'SUCCESS_REGISTER';
var SUCCESS_FORGOT_PASSWORD = exports.SUCCESS_FORGOT_PASSWORD = 'SUCCESS_FORGOT_PASSWORD';

var INIT_SIGN_IN = exports.INIT_SIGN_IN = 'INIT_SIGN_IN';
var INIT_REGISTER = exports.INIT_REGISTER = 'INIT_REGISTER';
var INIT_GOOGLE_SIGN_IN = exports.INIT_GOOGLE_SIGN_IN = 'INIT_GOOGLE_SIGN_IN';

var FAIL_SIGN_IN = exports.FAIL_SIGN_IN = 'FAIL_SIGN_IN';
var FAIL_REGISTER = exports.FAIL_REGISTER = 'FAIL_REGISTER';
var FAIL_FORGOT_PASSWORD = exports.FAIL_FORGOT_PASSWORD = 'FAIL_FORGOT_PASSWORD';
var FAIL_GOOGLE_SIGN_IN = exports.FAIL_GOOGLE_SIGN_IN = 'FAIL_GOOGLE_SIGN_IN';

var INIT_FORGOT_PASSWORD = exports.INIT_FORGOT_PASSWORD = 'INIT_FORGOT_PASSWORD';
var SENT_FORGOT_PASSWORD = exports.SENT_FORGOT_PASSWORD = 'SENT_FORGOT_PASSWORD';

var VALIDATE_FIELD = exports.VALIDATE_FIELD = 'VALIDATE_FIELD';
var CHANGE_FIELD = exports.CHANGE_FIELD = 'CHANGE_FIELD';
var SET_FIELD = exports.SET_FIELD = 'SET_FIELD';

var RESET_ERRORS = exports.RESET_ERRORS = 'RESET_ERRORS';
var SUGGEST_USER_NAME = exports.SUGGEST_USER_NAME = 'SUGGEST_USER_NAME';

var TRACK_DISPLAY = exports.TRACK_DISPLAY = 'TRACK_DISPLAY';
var TRACK_CLICK = exports.TRACK_CLICK = 'TRACK_CLICK';

});
},{"async-define":8}],178:[function(require,module,exports){
var asyncDefine = require('async-define');
asyncDefine(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function (__react,__react_dom,__redux,__react_redux){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _assign = require('babel-runtime/core-js/object/assign');

var _assign2 = _interopRequireDefault(_assign);

var _keys = require('babel-runtime/core-js/object/keys');

var _keys2 = _interopRequireDefault(_keys);

exports.default = reducer;

var _constants = require('./constants');

var constant = _interopRequireWildcard(_constants);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var initialState = {
  common: {},
  register: {
    firstName: '',
    lastName: '',
    email: '',
    username: '',
    password: '',
    newsletter: false,
    autoFillUsername: true,
    state: null
  },
  signIn: {
    identification: '',
    password: '',
    trustedComputer: false,
    state: null
  },
  forgotPassword: {
    identification: '',
    state: null
  },
  errors: {}
};

function extend(state, obj) {
  var s = {};
  (0, _keys2.default)(obj).forEach(function (attr) {
    s[attr] = (0, _assign2.default)({}, state[attr], obj[attr]);
  });
  return (0, _assign2.default)({}, state, s);
}

// Reducer
function reset(state) {
  var newState = {
    errors: {},
    common: (0, _assign2.default)({}, state.common, { googleState: null }),
    register: initialState.register,
    signIn: initialState.signIn,
    forgotPassword: initialState.forgotPassword
  };
  newState.signIn.trustedComputer = state.common.isMobile;
  return (0, _assign2.default)({}, state, newState);
}

function resetErrors(state) {
  return (0, _assign2.default)({}, state, { errors: {} });
}

function setFormType(state, action) {
  return extend(state, { common: { formType: action.formType } });
}

function setUserType(state, action) {
  return extend(state, { common: { userType: action.userType } });
}

function setPosition(state, action) {
  return extend(state, { common: { userType: action.userType, position: action.position } });
}

function validationErrors(state, action) {
  return extend(state, { errors: action.errors });
}

function initSignIn(state) {
  return extend(resetErrors(state), { signIn: { state: 'wait' } });
}

function initRegister(state) {
  return extend(resetErrors(state), { register: { state: 'wait' } });
}

function initGoogleSignIn(state) {
  return extend(resetErrors(state), { common: { googleState: 'wait' } });
}

function initForgotPassword(state) {
  return extend(resetErrors(state), { forgotPassword: { state: 'wait' } });
}

function failSignIn(state) {
  return extend(state, { signIn: { state: null } });
}

function failRegister(state) {
  return extend(state, { register: { state: null } });
}

function failGoogleSignIn(state) {
  return extend(state, { common: { googleState: null } });
}

function failForgotPassword(state) {
  return extend(state, { forgotPassword: { state: null } });
}

function sentForgotPassword(state) {
  return extend(resetErrors(state), { forgotPassword: { state: 'sent' } });
}

function validateField(state, action) {
  if (action.name === 'registration.email' && state.register.username === '') {
    return extend(state, { register: { autoFillUsername: true } });
  }
  if (action.name === 'registration.username') {
    return extend(state, { register: { autoFillUsername: false } });
  }
  return state;
}

function changeField(state, action) {
  var newErrors = (0, _assign2.default)({}, state.errors);
  delete newErrors[action.name];
  action.deps.forEach(function (d) {
    return delete newErrors[d];
  });
  return (0, _assign2.default)({}, state, { errors: newErrors });
}

function setField(state, action) {
  var obj = {};
  obj[action.form] = {};
  obj[action.form][action.name] = action.value;
  if (action.form === 'signIn' && action.name === 'identification') {
    (0, _assign2.default)(obj, { forgotPassword: { identification: action.value } });
  }
  return extend(state, obj);
}

function suggestUserName(state, action) {
  if (!state.register.autoFillUsername) {
    return state;
  }
  var newErrors = (0, _assign2.default)({}, state.errors);
  delete newErrors['registration.username'];
  var newState = (0, _assign2.default)({}, state, { errors: newErrors });
  return extend(newState, { register: { username: action.username } });
}

function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  switch (action.type) {
    case constant.RESET:
      return reset(state, action);
    case constant.SET_FORM_TYPE:
      return setFormType(state, action);
    case constant.SET_USER_TYPE:
      return setUserType(state, action);
    case constant.SET_POSITION:
      return setPosition(state, action);
    case constant.VALIDATION_ERRORS:
      return validationErrors(state, action);
    case constant.INIT_SIGN_IN:
      return initSignIn(state, action);
    case constant.INIT_REGISTER:
      return initRegister(state, action);
    case constant.INIT_GOOGLE_SIGN_IN:
      return initGoogleSignIn(state, action);
    case constant.INIT_FORGOT_PASSWORD:
      return initForgotPassword(state, action);
    case constant.FAIL_SIGN_IN:
      return failSignIn(state, action);
    case constant.FAIL_REGISTER:
      return failRegister(state, action);
    case constant.FAIL_GOOGLE_SIGN_IN:
      return failGoogleSignIn(state, action);
    case constant.FAIL_FORGOT_PASSWORD:
      return failForgotPassword(state, action);
    case constant.SENT_FORGOT_PASSWORD:
      return sentForgotPassword(state, action);
    case constant.VALIDATE_FIELD:
      return validateField(state, action);
    case constant.CHANGE_FIELD:
      return changeField(state, action);
    case constant.SET_FIELD:
      return setField(state, action);
    case constant.RESET_ERRORS:
      return resetErrors(state, action);
    case constant.SUGGEST_USER_NAME:
      return suggestUserName(state, action);

    default:
      return state;
  }
}

});
},{"./constants":177,"async-define":8,"babel-runtime/core-js/object/assign":12,"babel-runtime/core-js/object/keys":16}],179:[function(require,module,exports){
var asyncDefine = require('async-define');
asyncDefine(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function (__react,__react_dom,__redux,__react_redux){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _keys = require('babel-runtime/core-js/object/keys');

var _keys2 = _interopRequireDefault(_keys);

var _typeof2 = require('babel-runtime/helpers/typeof');

var _typeof3 = _interopRequireDefault(_typeof2);

var _slicedToArray2 = require('babel-runtime/helpers/slicedToArray');

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

exports.initSignIn = initSignIn;
exports.initRegister = initRegister;
exports.initGoogleSignIn = initGoogleSignIn;
exports.initForgotPassword = initForgotPassword;
exports.successSignIn = successSignIn;
exports.successForgotPassword = successForgotPassword;
exports.updateUserData = updateUserData;
exports.validateField = validateField;
exports.suggestUserName = suggestUserName;
exports.initSetFormType = initSetFormType;
exports.failSignIn = failSignIn;
exports.failRegister = failRegister;
exports.trackClickSaga = trackClickSaga;
exports.trackDisplaySaga = trackDisplaySaga;
exports.default = rootSaga;

var _reduxSaga = require('redux-saga');

var _effects = require('redux-saga/effects');

var _minijoi = require('module-tsl-error-middlewares/src/minijoi');

var _minijoi2 = _interopRequireDefault(_minijoi);

var _deniedErrorcode = require('../lib/denied-errorcode');

var _actions = require('../reducers/actions');

var actions = _interopRequireWildcard(_actions);

var _tracking = require('../lib/tracking');

var _traverseObject = require('../lib/traverse-object');

var _traverseObject2 = _interopRequireDefault(_traverseObject);

var _errorMessages = require('../../app/domain/errorMessages');

var _errorMessages2 = _interopRequireDefault(_errorMessages);

var _constants = require('../reducers/constants');

var constant = _interopRequireWildcard(_constants);

var _api = require('../lib/api');

var _api2 = _interopRequireDefault(_api);

var _utils = require('./utils');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _marked = [initSignIn, initRegister, initGoogleSignIn, initForgotPassword, successSignIn, successForgotPassword, updateUserData, validateField, suggestUserName, initSetFormType, failSignIn, failRegister, trackClickSaga, trackDisplaySaga, takeLatestWithName, rootSaga].map(_regenerator2.default.mark);

/*
  utilities
*/
function getWindow() {
  try {
    return window;
  } catch (e) {
    return {};
  }
}

function getErrorCode(xhr, prefix) {
  var genericErrorCode = xhr.status >= 400 && xhr.status < 500 ? 'denied' : 'generic';
  try {
    var response = JSON.parse(xhr.response || xhr.responseText);
    // assembling the error code
    var errorCodes = response.errors.map(function (e) {
      return prefix + '.' + e.field + '.' + e.types[0];
    });
    return errorCodes.length ? errorCodes.join(',') : prefix + '.' + genericErrorCode + '.error';
  } catch (e) {
    if (getWindow()._airbrake) {
      var errorObj = void 0;
      if (xhr.status === 0) {
        errorObj = { error: { message: 'app-authentication: api timing out (' + prefix + ') readystate ' + xhr.readyState, fileName: 'restapi.js', lineNumber: 0, columnNumber: 0 } };
      } else {
        errorObj = { error: { message: 'app-authentication: api returning unexpected ' + genericErrorCode + ' (' + prefix + '): ' + xhr.status + ' - ' + xhr.response, fileName: 'api.js', lineNumber: 0, columnNumber: 0 } };
      }
      getWindow()._airbrake.push(errorObj);
    }
    return prefix + '.' + genericErrorCode + '.error';
  }
}

var userNameValidation = _minijoi2.default.string().min(3).max(30).regex(/^[A-Za-z0-9_\-]*$/).required();
var emailValidation = _minijoi2.default.string().email();

var schemas = {
  registration: _minijoi2.default.object().keys({
    username: userNameValidation,
    email: emailValidation,
    password: _minijoi2.default.string().min(6).required(),
    firstName: _minijoi2.default.string(),
    lastName: _minijoi2.default.string(),
    newsletter: _minijoi2.default.boolean()
  })
};

/*
  sagas
*/
function initSignIn(action) {
  var isInline, isModal, credentials, errorCode, errors;
  return _regenerator2.default.wrap(function initSignIn$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return (0, _effects.put)(actions.resetErrors());

        case 2:
          _context.next = 4;
          return (0, _effects.select)(_utils.getIsInline);

        case 4:
          isInline = _context.sent;
          _context.next = 7;
          return (0, _effects.select)(_utils.getIsModal);

        case 7:
          isModal = _context.sent;

          if (!(!isInline && !isModal)) {
            _context.next = 20;
            break;
          }

          _context.prev = 9;
          _context.next = 12;
          return (0, _effects.cps)(_tracking.trackLogin, 'tes-login', (0, _tracking.getTrackingType)(isModal, isInline));

        case 12:
          _context.next = 17;
          break;

        case 14:
          _context.prev = 14;
          _context.t0 = _context['catch'](9);

          console.log('Tracking Login error', _context.t0.message); // eslint-disable-line no-console

        case 17:
          _context.next = 19;
          return (0, _effects.call)(action.callback);

        case 19:
          return _context.abrupt('return');

        case 20:
          _context.prev = 20;
          _context.next = 23;
          return (0, _effects.call)(_tracking.trackLogin, 'tes-login', (0, _tracking.getTrackingType)(isModal, isInline));

        case 23:
          _context.next = 25;
          return (0, _effects.select)(_utils.getSignInData);

        case 25:
          credentials = _context.sent;
          _context.next = 28;
          return (0, _effects.call)(_api2.default.signIn, credentials);

        case 28:
          _context.next = 30;
          return (0, _effects.put)(actions.successSignIn());

        case 30:
          _context.next = 40;
          break;

        case 32:
          _context.prev = 32;
          _context.t1 = _context['catch'](20);
          errorCode = (0, _deniedErrorcode.authDenied)(_context.t1) || getErrorCode(_context.t1, 'signin');
          errors = (0, _errorMessages2.default)(errorCode);
          _context.next = 38;
          return (0, _effects.put)(actions.validationErrors(errors));

        case 38:
          _context.next = 40;
          return (0, _effects.put)(actions.failSignIn(errors));

        case 40:
        case 'end':
          return _context.stop();
      }
    }
  }, _marked[0], this, [[9, 14], [20, 32]]);
}

function initRegister(action) {
  var isInline, isModal, info, errorCode, errors;
  return _regenerator2.default.wrap(function initRegister$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          _context2.next = 2;
          return (0, _effects.put)(actions.resetErrors());

        case 2:
          _context2.next = 4;
          return (0, _effects.select)(_utils.getIsInline);

        case 4:
          isInline = _context2.sent;
          _context2.next = 7;
          return (0, _effects.select)(_utils.getIsModal);

        case 7:
          isModal = _context2.sent;

          if (!(!isInline && !isModal)) {
            _context2.next = 20;
            break;
          }

          _context2.prev = 9;
          _context2.next = 12;
          return (0, _effects.cps)(_tracking.trackRegister, (0, _tracking.getTrackingType)(isModal, isInline));

        case 12:
          _context2.next = 17;
          break;

        case 14:
          _context2.prev = 14;
          _context2.t0 = _context2['catch'](9);

          console.log('Tracking Registration error', _context2.t0.message); // eslint-disable-line no-console

        case 17:
          _context2.next = 19;
          return (0, _effects.call)(action.callback);

        case 19:
          return _context2.abrupt('return');

        case 20:
          _context2.prev = 20;
          _context2.next = 23;
          return (0, _effects.call)(_tracking.trackRegister, (0, _tracking.getTrackingType)(isModal, isInline));

        case 23:
          _context2.next = 25;
          return (0, _effects.select)(_utils.getRegistrationData);

        case 25:
          info = _context2.sent;
          _context2.next = 28;
          return (0, _effects.call)(_api2.default.register, info);

        case 28:
          _context2.next = 30;
          return (0, _effects.put)(actions.successRegister());

        case 30:
          _context2.next = 40;
          break;

        case 32:
          _context2.prev = 32;
          _context2.t1 = _context2['catch'](20);
          errorCode = getErrorCode(_context2.t1, 'registration');
          errors = (0, _errorMessages2.default)(errorCode);
          _context2.next = 38;
          return (0, _effects.put)(actions.validationErrors(errors));

        case 38:
          _context2.next = 40;
          return (0, _effects.put)(actions.failRegister(errors));

        case 40:
        case 'end':
          return _context2.stop();
      }
    }
  }, _marked[1], this, [[9, 14], [20, 32]]);
}

function initGoogleSignIn() {
  var isInline, isModal, info, errorCode, errors;
  return _regenerator2.default.wrap(function initGoogleSignIn$(_context3) {
    while (1) {
      switch (_context3.prev = _context3.next) {
        case 0:
          _context3.prev = 0;
          _context3.next = 3;
          return (0, _effects.put)(actions.resetErrors());

        case 3:
          _context3.next = 5;
          return (0, _effects.select)(_utils.getIsInline);

        case 5:
          isInline = _context3.sent;
          _context3.next = 8;
          return (0, _effects.select)(_utils.getIsModal);

        case 8:
          isModal = _context3.sent;
          _context3.next = 11;
          return (0, _effects.select)(_utils.getGoogleSignInData);

        case 11:
          info = _context3.sent;

          if (!(!isModal && !isInline)) {
            _context3.next = 24;
            break;
          }

          _context3.prev = 13;
          _context3.next = 16;
          return (0, _effects.cps)(_tracking.trackLogin, 'google-login', (0, _tracking.getTrackingType)(isModal, isInline));

        case 16:
          _context3.next = 21;
          break;

        case 18:
          _context3.prev = 18;
          _context3.t0 = _context3['catch'](13);

          console.log('Tracking Google Login error', _context3.t0.message); // eslint-disable-line no-console

        case 21:
          _context3.next = 23;
          return (0, _effects.call)(_api2.default.googleSignIn, info);

        case 23:
          return _context3.abrupt('return');

        case 24:
          _context3.next = 26;
          return (0, _effects.call)(_tracking.trackLogin, 'google-login', (0, _tracking.getTrackingType)(isModal, isInline));

        case 26:
          _context3.next = 28;
          return (0, _effects.call)(_api2.default.googleSignIn, info);

        case 28:
          _context3.next = 30;
          return (0, _effects.put)(actions.successGoogleSignIn());

        case 30:
          _context3.next = 40;
          break;

        case 32:
          _context3.prev = 32;
          _context3.t1 = _context3['catch'](0);
          errorCode = _context3.t1.message;
          errors = (0, _errorMessages2.default)(errorCode);
          _context3.next = 38;
          return (0, _effects.put)(actions.validationErrors(errors));

        case 38:
          _context3.next = 40;
          return (0, _effects.put)(actions.failGoogleSignIn(errors));

        case 40:
        case 'end':
          return _context3.stop();
      }
    }
  }, _marked[2], this, [[0, 32], [13, 18]]);
}

function initForgotPassword() {
  var isInline, isModal, info, errorCode, errors;
  return _regenerator2.default.wrap(function initForgotPassword$(_context4) {
    while (1) {
      switch (_context4.prev = _context4.next) {
        case 0:
          _context4.next = 2;
          return (0, _effects.put)(actions.resetErrors());

        case 2:
          _context4.next = 4;
          return (0, _effects.select)(_utils.getIsInline);

        case 4:
          isInline = _context4.sent;
          _context4.next = 7;
          return (0, _effects.select)(_utils.getIsModal);

        case 7:
          isModal = _context4.sent;
          _context4.prev = 8;
          _context4.next = 11;
          return (0, _effects.cps)(_tracking.trackForgotPassword, (0, _tracking.getTrackingType)(isModal, isInline));

        case 11:
          _context4.next = 16;
          break;

        case 13:
          _context4.prev = 13;
          _context4.t0 = _context4['catch'](8);

          console.log('Tracking forgot password error', _context4.t0.message); // eslint-disable-line no-console

        case 16:
          _context4.prev = 16;
          _context4.next = 19;
          return (0, _effects.select)(_utils.getForgotPasswordData);

        case 19:
          info = _context4.sent;
          _context4.next = 22;
          return (0, _effects.call)(_api2.default.forgotPassword, info);

        case 22:
          _context4.next = 24;
          return (0, _effects.put)(actions.sentForgotPassword());

        case 24:
          _context4.next = 26;
          return (0, _effects.put)(actions.setField('forgotPassword', 'identification', ''));

        case 26:
          _context4.next = 36;
          break;

        case 28:
          _context4.prev = 28;
          _context4.t1 = _context4['catch'](16);
          errorCode = (0, _deniedErrorcode.forgotPasswordDenied)(_context4.t1) || getErrorCode(_context4.t1, 'forgot-password');
          errors = (0, _errorMessages2.default)(errorCode);
          _context4.next = 34;
          return (0, _effects.put)(actions.validationErrors(errors));

        case 34:
          _context4.next = 36;
          return (0, _effects.put)(actions.failForgotPassword(errors));

        case 36:
        case 'end':
          return _context4.stop();
      }
    }
  }, _marked[3], this, [[8, 13], [16, 28]]);
}

function successSignIn() {
  var onSuccess;
  return _regenerator2.default.wrap(function successSignIn$(_context5) {
    while (1) {
      switch (_context5.prev = _context5.next) {
        case 0:
          _context5.next = 2;
          return (0, _effects.select)(_utils.getOnSuccess);

        case 2:
          onSuccess = _context5.sent;

          if (!(onSuccess === 'reload')) {
            _context5.next = 8;
            break;
          }

          _context5.next = 6;
          return (0, _effects.call)(_api2.default.reload);

        case 6:
          _context5.next = 16;
          break;

        case 8:
          _context5.next = 10;
          return (0, _effects.call)(_api2.default.closeModalEvent);

        case 10:
          _context5.next = 12;
          return (0, _effects.call)(_api2.default.loggedInEvent);

        case 12:
          _context5.next = 14;
          return (0, _effects.call)(_reduxSaga.delay, 200);

        case 14:
          _context5.next = 16;
          return (0, _effects.put)(actions.reset());

        case 16:
        case 'end':
          return _context5.stop();
      }
    }
  }, _marked[4], this);
}

function successForgotPassword() {
  return _regenerator2.default.wrap(function successForgotPassword$(_context6) {
    while (1) {
      switch (_context6.prev = _context6.next) {
        case 0:
          _context6.next = 2;
          return (0, _effects.put)(actions.setField('forgotPassword', 'identification', ''));

        case 2:
          _context6.next = 4;
          return (0, _effects.call)(_api2.default.closeModalEvent);

        case 4:
          _context6.next = 6;
          return (0, _effects.call)(_reduxSaga.delay, 200);

        case 6:
          _context6.next = 8;
          return (0, _effects.put)(actions.reset());

        case 8:
        case 'end':
          return _context6.stop();
      }
    }
  }, _marked[5], this);
}

function updateUserData(action) {
  var errorCode;
  return _regenerator2.default.wrap(function updateUserData$(_context7) {
    while (1) {
      switch (_context7.prev = _context7.next) {
        case 0:
          _context7.prev = 0;
          _context7.next = 3;
          return (0, _effects.call)(_api2.default.updateUserData, action.data);

        case 3:
          _context7.next = 5;
          return (0, _effects.put)(actions.successSignIn());

        case 5:
          _context7.next = 12;
          break;

        case 7:
          _context7.prev = 7;
          _context7.t0 = _context7['catch'](0);
          errorCode = getErrorCode(_context7.t0, 'edit-account');
          _context7.next = 12;
          return (0, _effects.put)(actions.validationErrors((0, _errorMessages2.default)(errorCode)));

        case 12:
        case 'end':
          return _context7.stop();
      }
    }
  }, _marked[6], this, [[0, 7]]);
}

function validateField(action) {
  var _this = this;

  var userData, response, _response, _ret;

  return _regenerator2.default.wrap(function validateField$(_context9) {
    while (1) {
      switch (_context9.prev = _context9.next) {
        case 0:
          _context9.next = 2;
          return (0, _effects.call)(_reduxSaga.delay, 1200);

        case 2:
          _context9.next = 4;
          return (0, _effects.select)(_utils.getRegistrationData);

        case 4:
          userData = _context9.sent;

          if (!(action.name === 'registration.username' && userData.username && !_minijoi2.default.validate(userData.username, userNameValidation).error)) {
            _context9.next = 14;
            break;
          }

          _context9.next = 8;
          return (0, _effects.call)(_api2.default.verifyUsername, userData.username);

        case 8:
          response = _context9.sent;

          if (!response.length) {
            _context9.next = 12;
            break;
          }

          _context9.next = 12;
          return (0, _effects.put)(actions.validationErrors((0, _errorMessages2.default)('registration.username.duplicate')));

        case 12:
          _context9.next = 30;
          break;

        case 14:
          if (!(action.name === 'registration.email' && userData.email && !_minijoi2.default.validate(userData.email, emailValidation).error)) {
            _context9.next = 26;
            break;
          }

          _context9.next = 17;
          return (0, _effects.call)(_api2.default.verifyEmail, userData.email);

        case 17:
          _response = _context9.sent;

          if (!_response.length) {
            _context9.next = 21;
            break;
          }

          _context9.next = 21;
          return (0, _effects.put)(actions.validationErrors((0, _errorMessages2.default)('registration.email.duplicate')));

        case 21:
          if (!_response.suggestedUsername) {
            _context9.next = 24;
            break;
          }

          _context9.next = 24;
          return (0, _effects.put)(actions.suggestUserName(_response.suggestedUsername));

        case 24:
          _context9.next = 30;
          break;

        case 26:
          return _context9.delegateYield(_regenerator2.default.mark(function _callee() {
            var _action$name$split, _action$name$split2, form, fieldName, schema, outcome, errorCode;

            return _regenerator2.default.wrap(function _callee$(_context8) {
              while (1) {
                switch (_context8.prev = _context8.next) {
                  case 0:
                    _action$name$split = action.name.split('.'), _action$name$split2 = (0, _slicedToArray3.default)(_action$name$split, 2), form = _action$name$split2[0], fieldName = _action$name$split2[1];

                    if (form in schemas) {
                      _context8.next = 3;
                      break;
                    }

                    return _context8.abrupt('return', {
                      v: void 0
                    });

                  case 3:
                    schema = schemas[form];
                    outcome = _minijoi2.default.validate(userData, schema, { abortEarly: false });

                    if (outcome.error) {
                      _context8.next = 7;
                      break;
                    }

                    return _context8.abrupt('return', {
                      v: void 0
                    });

                  case 7:
                    errorCode = outcome.error.details.filter(function (e) {
                      return e.path === fieldName;
                    }).map(function (e) {
                      return form + '.' + e.path + '.' + e.type;
                    }).join(',');

                    if (!errorCode.length) {
                      _context8.next = 11;
                      break;
                    }

                    _context8.next = 11;
                    return (0, _effects.put)(actions.validationErrors((0, _errorMessages2.default)(errorCode)));

                  case 11:
                  case 'end':
                    return _context8.stop();
                }
              }
            }, _callee, _this);
          })(), 't0', 27);

        case 27:
          _ret = _context9.t0;

          if (!((typeof _ret === 'undefined' ? 'undefined' : (0, _typeof3.default)(_ret)) === "object")) {
            _context9.next = 30;
            break;
          }

          return _context9.abrupt('return', _ret.v);

        case 30:
        case 'end':
          return _context9.stop();
      }
    }
  }, _marked[7], this);
}

function suggestUserName() {
  var userData, response;
  return _regenerator2.default.wrap(function suggestUserName$(_context10) {
    while (1) {
      switch (_context10.prev = _context10.next) {
        case 0:
          _context10.next = 2;
          return (0, _effects.select)(_utils.getRegistrationData);

        case 2:
          userData = _context10.sent;

          if (!(userData.email && !_minijoi2.default.validate(userData.email, emailValidation).error)) {
            _context10.next = 10;
            break;
          }

          _context10.next = 6;
          return (0, _effects.call)(_api2.default.verifyEmail, userData.email);

        case 6:
          response = _context10.sent;

          if (!response.suggestedUsername) {
            _context10.next = 10;
            break;
          }

          _context10.next = 10;
          return (0, _effects.put)(actions.suggestUserName(response.suggestedUsername));

        case 10:
        case 'end':
          return _context10.stop();
      }
    }
  }, _marked[8], this);
}

function initSetFormType(action) {
  var isInline, isModal, oldFormType;
  return _regenerator2.default.wrap(function initSetFormType$(_context11) {
    while (1) {
      switch (_context11.prev = _context11.next) {
        case 0:
          _context11.next = 2;
          return (0, _effects.select)(_utils.getIsInline);

        case 2:
          isInline = _context11.sent;
          _context11.next = 5;
          return (0, _effects.select)(_utils.getIsModal);

        case 5:
          isModal = _context11.sent;

          if (!(!isModal && !isInline)) {
            _context11.next = 8;
            break;
          }

          return _context11.abrupt('return');

        case 8:
          _context11.next = 10;
          return (0, _effects.select)(_utils.getFormType);

        case 10:
          oldFormType = _context11.sent;

          if (!(oldFormType === action.formType)) {
            _context11.next = 13;
            break;
          }

          return _context11.abrupt('return');

        case 13:
          _context11.next = 15;
          return (0, _effects.put)(actions.setFormType(action.formType));

        case 15:
          _context11.next = 17;
          return (0, _effects.put)(actions.trackClick(action.formType));

        case 17:
          _context11.next = 19;
          return (0, _effects.put)(actions.trackDisplay(action.formType));

        case 19:
        case 'end':
          return _context11.stop();
      }
    }
  }, _marked[9], this);
}

function failSignIn(action) {
  var filteredErrors, msg, id, isInline, isModal;
  return _regenerator2.default.wrap(function failSignIn$(_context12) {
    while (1) {
      switch (_context12.prev = _context12.next) {
        case 0:
          if (action.errors) {
            _context12.next = 2;
            break;
          }

          return _context12.abrupt('return');

        case 2:
          filteredErrors = (0, _keys2.default)(action.errors).filter(function (e) {
            return e.startsWith('signin.') || e.startsWith('generic.googlebutton');
          });

          if (!filteredErrors.length) {
            _context12.next = 14;
            break;
          }

          msg = (0, _traverseObject2.default)(action.errors[filteredErrors[0]], 'msg') || 'unknown error';
          id = filteredErrors[0] === 'generic.googlebutton' ? 'google-login-fail' : 'login-fail';
          _context12.next = 8;
          return (0, _effects.select)(_utils.getIsInline);

        case 8:
          isInline = _context12.sent;
          _context12.next = 11;
          return (0, _effects.select)(_utils.getIsModal);

        case 11:
          isModal = _context12.sent;
          _context12.next = 14;
          return (0, _effects.call)(_tracking.trackError, id, msg, (0, _tracking.getTrackingType)(isModal, isInline));

        case 14:
        case 'end':
          return _context12.stop();
      }
    }
  }, _marked[10], this);
}

function failRegister(action) {
  var filteredErrors, msg, isInline, isModal;
  return _regenerator2.default.wrap(function failRegister$(_context13) {
    while (1) {
      switch (_context13.prev = _context13.next) {
        case 0:
          if (action.errors) {
            _context13.next = 2;
            break;
          }

          return _context13.abrupt('return');

        case 2:
          filteredErrors = (0, _keys2.default)(action.errors).filter(function (e) {
            return e.startsWith('registration.');
          });

          if (!filteredErrors.length) {
            _context13.next = 13;
            break;
          }

          msg = (0, _traverseObject2.default)(action.errors[filteredErrors[0]], 'msg') || 'unknown error';
          _context13.next = 7;
          return (0, _effects.select)(_utils.getIsInline);

        case 7:
          isInline = _context13.sent;
          _context13.next = 10;
          return (0, _effects.select)(_utils.getIsModal);

        case 10:
          isModal = _context13.sent;
          _context13.next = 13;
          return (0, _effects.call)(_tracking.trackError, 'register-fail', msg, (0, _tracking.getTrackingType)(isModal, isInline));

        case 13:
        case 'end':
          return _context13.stop();
      }
    }
  }, _marked[11], this);
}

function trackClickSaga(action) {
  return _regenerator2.default.wrap(function trackClickSaga$(_context14) {
    while (1) {
      switch (_context14.prev = _context14.next) {
        case 0:
          _context14.next = 2;
          return (0, _effects.call)(_tracking.trackClick, action.formType);

        case 2:
        case 'end':
          return _context14.stop();
      }
    }
  }, _marked[12], this);
}

function trackDisplaySaga(action) {
  var isInline, isModal, userType, isSelectPosition, doSelectUserType;
  return _regenerator2.default.wrap(function trackDisplaySaga$(_context15) {
    while (1) {
      switch (_context15.prev = _context15.next) {
        case 0:
          _context15.next = 2;
          return (0, _effects.select)(_utils.getIsInline);

        case 2:
          isInline = _context15.sent;
          _context15.next = 5;
          return (0, _effects.select)(_utils.getIsModal);

        case 5:
          isModal = _context15.sent;
          _context15.next = 8;
          return (0, _effects.select)(_utils.getUserType);

        case 8:
          userType = _context15.sent;
          _context15.next = 11;
          return (0, _effects.select)(_utils.getIsSelectPosition);

        case 11:
          isSelectPosition = _context15.sent;
          _context15.next = 14;
          return (0, _effects.select)(_utils.getDoSelectUserType);

        case 14:
          doSelectUserType = _context15.sent;

          if (isInline) {
            _context15.next = 18;
            break;
          }

          _context15.next = 18;
          return (0, _effects.call)(_tracking.trackDisplay, action.formType, (0, _tracking.getTrackingType)(isModal, isInline), userType, isSelectPosition, doSelectUserType);

        case 18:
        case 'end':
          return _context15.stop();
      }
    }
  }, _marked[13], this);
}

function takeLatestWithName(pattern, saga) {
  var task;
  return _regenerator2.default.wrap(function takeLatestWithName$(_context17) {
    while (1) {
      switch (_context17.prev = _context17.next) {
        case 0:
          _context17.next = 2;
          return (0, _effects.fork)(_regenerator2.default.mark(function newSaga() {
            var lastTask, action;
            return _regenerator2.default.wrap(function newSaga$(_context16) {
              while (1) {
                switch (_context16.prev = _context16.next) {
                  case 0:
                    lastTask = {};

                  case 1:
                    if (!true) {
                      _context16.next = 13;
                      break;
                    }

                    _context16.next = 4;
                    return (0, _effects.take)(pattern);

                  case 4:
                    action = _context16.sent;

                    if (!(action.name in lastTask)) {
                      _context16.next = 8;
                      break;
                    }

                    _context16.next = 8;
                    return (0, _effects.cancel)(lastTask[action.name]);

                  case 8:
                    _context16.next = 10;
                    return (0, _effects.fork)(saga, action);

                  case 10:
                    lastTask[action.name] = _context16.sent;
                    _context16.next = 1;
                    break;

                  case 13:
                  case 'end':
                    return _context16.stop();
                }
              }
            }, newSaga, this);
          }));

        case 2:
          task = _context17.sent;
          return _context17.abrupt('return', task);

        case 4:
        case 'end':
          return _context17.stop();
      }
    }
  }, _marked[14], this);
}

function isEmail(action) {
  return action.type === constant.VALIDATE_FIELD && action.name === 'registration.email';
}

function rootSaga() {
  return _regenerator2.default.wrap(function rootSaga$(_context18) {
    while (1) {
      switch (_context18.prev = _context18.next) {
        case 0:
          _context18.next = 2;
          return [(0, _reduxSaga.takeEvery)(constant.INIT_SIGN_IN, initSignIn), (0, _reduxSaga.takeEvery)(constant.INIT_REGISTER, initRegister), (0, _reduxSaga.takeEvery)(constant.INIT_GOOGLE_SIGN_IN, initGoogleSignIn), (0, _reduxSaga.takeEvery)(constant.INIT_FORGOT_PASSWORD, initForgotPassword), (0, _reduxSaga.takeEvery)(constant.SUCCESS_GOOGLE_SIGN_IN, successSignIn), (0, _reduxSaga.takeEvery)(constant.SUCCESS_SIGN_IN, successSignIn), (0, _reduxSaga.takeEvery)(constant.SUCCESS_REGISTER, successSignIn), (0, _reduxSaga.takeEvery)(constant.SUCCESS_FORGOT_PASSWORD, successForgotPassword), (0, _reduxSaga.takeEvery)(constant.UPDATE_USER_DATA, updateUserData), (0, _reduxSaga.takeEvery)(constant.INIT_SET_FORM_TYPE, initSetFormType), (0, _reduxSaga.takeEvery)(constant.FAIL_SIGN_IN, failSignIn), (0, _reduxSaga.takeEvery)(constant.FAIL_GOOGLE_SIGN_IN, failSignIn), (0, _reduxSaga.takeEvery)(constant.FAIL_REGISTER, failRegister), (0, _reduxSaga.takeEvery)(constant.TRACK_CLICK, trackClickSaga), (0, _reduxSaga.takeEvery)(constant.TRACK_DISPLAY, trackDisplaySaga), takeLatestWithName(constant.VALIDATE_FIELD, validateField), (0, _reduxSaga.throttle)(800, isEmail, suggestUserName)];

        case 2:
        case 'end':
          return _context18.stop();
      }
    }
  }, _marked[15], this);
}

});
},{"../../app/domain/errorMessages":156,"../lib/api":170,"../lib/denied-errorcode":171,"../lib/tracking":174,"../lib/traverse-object":175,"../reducers/actions":176,"../reducers/constants":177,"./utils":180,"async-define":8,"babel-runtime/core-js/object/keys":16,"babel-runtime/helpers/slicedToArray":25,"babel-runtime/helpers/typeof":26,"babel-runtime/regenerator":27,"module-tsl-error-middlewares/src/minijoi":137,"redux-saga":141,"redux-saga/effects":139}],180:[function(require,module,exports){
var asyncDefine = require('async-define');
asyncDefine(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function (__react,__react_dom,__redux,__react_redux){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getIsSelectPosition = getIsSelectPosition;
exports.getDoSelectUserType = getDoSelectUserType;
exports.getOnSuccess = getOnSuccess;
exports.getFormType = getFormType;
exports.getIsInline = getIsInline;
exports.getIsModal = getIsModal;
exports.getUserType = getUserType;
exports.getForgotPasswordData = getForgotPasswordData;
exports.getSignInData = getSignInData;
exports.getRegistrationData = getRegistrationData;
exports.getGoogleSignInData = getGoogleSignInData;

var _tracking = require('../lib/tracking');

function getIsSelectPosition(state) {
  return state.common.isSelectPosition;
}

function getDoSelectUserType(state) {
  return state.common.doSelectUserType;
}

function getOnSuccess(state) {
  return state.common.onSuccess;
}

function getFormType(state) {
  return state.common.formType;
}

function getIsInline(state) {
  return state.common.isInline;
}

function getIsModal(state) {
  return state.common.isModal;
}

function getUserType(state) {
  return state.common.userType;
}

function getForgotPasswordData(state) {
  return { email: state.forgotPassword.identification };
}

function getSignInData(state) {
  var common = state.common;
  var signIn = state.signIn;
  var pageContext = (0, _tracking.getPageContext)(common.pageMz, common.overrideMz);

  var identification = signIn.identification;
  var password = signIn.password;
  var trustedComputer = signIn.trustedComputer;
  var appId = common.appId;

  var pageId = pageContext.pageId;
  var pageType = pageContext.pageType;
  var pageSection = pageContext.pageSection;
  var pageSubSection = pageContext.pageSubSection;

  var data = {
    appId: appId,
    identification: identification,
    password: password,
    trustedComputer: trustedComputer,
    pageId: pageId,
    pageType: pageType,
    pageSection: pageSection,
    pageSubSection: pageSubSection
  };

  return data;
}

function getRegistrationData(state) {
  var common = state.common;
  var register = state.register;
  var pageContext = (0, _tracking.getPageContext)(common.pageMz, common.overrideMz);

  var isModal = common.isModal;
  var isInline = common.isInline;
  var isStudent = common.userType === 'student';

  var pageId = pageContext.pageId;
  var pageType = pageContext.pageType;
  var pageSection = pageContext.pageSection;
  var pageSubSection = pageContext.pageSubSection;

  var data = {
    username: register.username,
    email: register.email || '',
    password: register.password,
    userType: common.userType || null,
    newsletter: isStudent ? false : register.newsletter,
    regUrl: !isModal && !isInline ? common.rtn : window && window.location.href,
    pageId: pageId,
    pageType: pageType,
    pageSection: pageSection,
    pageSubSection: pageSubSection,
    appId: common.appId
  };

  if (common.isSelectPosition) {
    data.position = common.position || '';
  }

  if (!common.omitName) {
    data.firstName = register.firstName;
    data.lastName = register.lastName;
  }

  return data;
}

function getGoogleSignInData(state) {
  var common = state.common;
  var register = state.register;
  var pageContext = (0, _tracking.getPageContext)(common.pageMz, common.overrideMz);

  var isStudent = common.userType === 'student';
  var isModal = common.isModal;
  var isInline = common.isInline;

  var pageId = pageContext.pageId;
  var pageType = pageContext.pageType;
  var pageSection = pageContext.pageSection;
  var pageSubSection = pageContext.pageSubSection;
  var regUrl = void 0;
  if (common.regUrl) {
    regUrl = common.regUrl;
  } else if (!isModal && !isInline) {
    regUrl = common.rtn;
  } else {
    regUrl = window && window.location.href;
  }

  var data = {
    isModal: isModal || isInline,
    userType: common.userType,
    newsletter: isStudent ? false : register.newsletter,
    regUrl: regUrl,
    appId: common.appId,
    pageId: pageId,
    pageType: pageType,
    pageSection: pageSection,
    pageSubSection: pageSubSection,
    rtn: isModal || isInline ? '/oauth/close-modal' : common.rtn || window.location.href
  };

  if (common.isSelectPosition) {
    data.position = common.position || '';
  }

  return data;
}

});
},{"../lib/tracking":174,"async-define":8}],181:[function(require,module,exports){
(function (process){
var asyncDefine = require('async-define');
asyncDefine(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function (__react,__react_dom,__redux,__react_redux){
'use strict';

require('ima.js-babel6-polyfill');

var _es6ObjectAssign = require('es6-object-assign');

var _es6ObjectAssign2 = _interopRequireDefault(_es6ObjectAssign);

require('string.prototype.startswith');

var _reduxSaga = require('redux-saga');

var _reduxSaga2 = _interopRequireDefault(_reduxSaga);

var _react = __react;

var _react2 = _interopRequireDefault(_react);

var _reactDom = __react_dom;

var _reactDom2 = _interopRequireDefault(_reactDom);

var _reactRedux = __react_redux;

var _redux = __redux;

var _reducers = require('../reducers');

var _reducers2 = _interopRequireDefault(_reducers);

var _App = require('../components/App');

var _App2 = _interopRequireDefault(_App);

var _sagas = require('../sagas');

var _sagas2 = _interopRequireDefault(_sagas);

var _actions = require('../reducers/actions');

var actions = _interopRequireWildcard(_actions);

var _utils = require('../sagas/utils');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var events = window.TES.events; // polyfills


_es6ObjectAssign2.default.polyfill();

process.env.BROWSER = true;

var mountPointCls = 'app-auth-mountpoint';
var mountPoint = '.' + mountPointCls;

var bootstrap = function bootstrap() {
  var sagaMiddleware = (0, _reduxSaga2.default)();

  var mountElement = document.querySelector(mountPoint);
  mountElement.className = mountPointCls + '-loaded';
  var initialState = JSON.parse(mountElement.getAttribute('data-init-state'));

  var enhancer = (0, _redux.compose)((0, _redux.applyMiddleware)(sagaMiddleware));

  var store = (0, _redux.createStore)(_reducers2.default, initialState, enhancer);
  // then run the saga
  sagaMiddleware.run(_sagas2.default);

  var app = _react2.default.createElement(_App2.default);
  var provider = _react2.default.createElement(_reactRedux.Provider, { store: store }, app);

  _reactDom2.default.render(provider, mountElement);

  events.on('modal-switch', function (eventType, data) {
    if (data.appId === 'authapp') {
      store.dispatch(actions.initSetFormType(data.msg));
    }
  });
  // // this sends an event only when I am NOT changing the form type
  events.on(/modal-(switch|init)/, function (eventType, data) {
    var form = data.msg;
    if (data.appId === 'authapp' && form === (0, _utils.getFormType)(store.getState())) {
      store.dispatch(actions.trackClick(form));
    }
  });
};

if (document.querySelector(mountPoint)) {
  bootstrap(); // page init
} else {
  events.one('modal-init', bootstrap); // modal init
}

});
}).call(this,require('_process'))

},{"../components/App":157,"../reducers":178,"../reducers/actions":176,"../sagas":179,"../sagas/utils":180,"_process":138,"async-define":8,"es6-object-assign":129,"ima.js-babel6-polyfill":134,"redux-saga":141,"string.prototype.startswith":155}]},{},[181])
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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
